// =============================================================================
// NutriLithe (Lithe.Fit) -- App.js V194 "OBS-001: Yesterday tab in food search overlay"
// V98: Full audit fixes: logout reload, LLM model constants, UTC date fix, camera backgrounding, console gating, state reset, error boundaries, select(*) cleanup
//
// SQL MIGRATION REQUIRED — run once in Supabase SQL editor before deploying:
//   ALTER TABLE profiles ADD COLUMN IF NOT EXISTS gdpr_accepted_at timestamptz;
//   ALTER TABLE profiles ADD COLUMN IF NOT EXISTS terms_accepted_at timestamptz;
// V93: Win-first AI audit prompts. 7-day log: colour-coded +/- vs target, clean header. Hydration moved below Copy Yesterday.
//   Build Recipe in Recipes card. Supplement AI dose button. Macro bars distinct colours. Delete All My Data deduped.
// V92: Full visual overhaul. Themes rewritten: Balanced=Yellow/White, Critical=Red/Black, Motivational=Green/White.
//   Google Fonts (Inter+Poppins) injected at runtime. ComicCard/Btn/Field/SectionLabel all rounded and modernised.
//   Soft drop shadows replace hard geometric shadows. All border-radius values driven from theme.
// V91: BottomNav and AppSwitcher now stretch edge-to-edge (removed maxWidth:450 + translate centring).
//   Shell no longer centre-justifies content. All screens fill the viewport properly.
// V90: phone container full-screen (no outer border/shadow/maxWidth).
//   Critical persona voice restored: ruthless, direct, banned softening words.
//   Branded foods: zero-macro items now show warning instead of 0s.
// V89: All three persona system prompts replaced. Each box has a locked 4-sentence contract.
//   Box 1: metabolic state + today energy/focus effect + trajectory risk + physique verdict.
//   Box 2: honest gaps only, natural meal windows, no commands unless < 2h left in day.
//   Box 3: 30-day projection from 7-day history with real maths. Not scary, not fluffy.
//   EVENING PRO_RATA_LAW no longer unlocks "Full Bad Boy / name failures" override.
//   MACRO PACING LAW retained and now explicitly overrides EVENING window rules.
// V88: History-aware macro urgency (protein/fat/carbs ON TRACK suppresses eat-now commands).
//   MACRO PACING LAW injected into all 3 personas -- overrides voice contract.
//   Shadows removed across all themes. Danger Zone moved to Settings.
//   Meal Ideas moved from Today to My Meals tab. Active Calorie Target box in Settings.
// V87: Three feature sets applied cleanly onto V84 base (V85/V86 were built from wrong base -- V70).
//   1. Branded foods: new branded_foods Supabase table merged into natural search.
//      brandedRowToCandidate converts per-serving macros to per-100g for logging pipeline.
//      KNOWN_BRANDS list routes brand-name queries (greggs, kfc, etc) to branded items first.
//      searchFoodsDBForMerge runs foods + branded_foods queries in parallel via Promise.all.
//      Candidate card shows coloured brand badge (GREGGS, KFC etc).
//      468 rows across 25 UK chains in branded_foods_seed_v2.sql.
//   2. Serving UX: modal is branded-aware. Shows per-serving macros not per-100g.
//      Qty field shows "Servings" (enter 1 or 2) not raw grams for branded items.
//      Preview reads "1 serving (116g)" not "For 116g".
//   3. Launch screen: branded app-selection screen shown on first load / refresh
//      before login. Lithe.Fit logo, NutriLithe tile + LiftLithe tile with taglines.
//      Tapping NutriLithe enters existing login flow. LiftLithe goes to /workout.
// NutriLithe (Lithe.Fit) -- App.jsx V84 "Rebranding + AI time-aware tolerance + Supp UX + Barcode fallback + Play Store blockers"
// V84:
//   1. Rebranded NutriPilot -> Lithe throughout. Contact email -> hello@lithe.fit.
//   2. AI tolerance bands now pro-rata adjusted by time of day (paceFraction).
//   3. Supplement intake removed from AI audit output.
//   4. Supplement add UX: two-step flow (search first, then details).
//   5. Barcode lookup falls back to world.openfoodfacts.org if UK subdomain misses.
//   6. Account deletion flow in Settings (Danger Zone).
//   7. AppSwitcher hidden on Capacitor native builds.
//   8. Camera permission rationale screen before first getUserMedia call.
//   9. Age gate (16+) added to signup flow.
// V83: UI cleanup -- 7 removals/moves.
// V82: AI audit tolerance bands (5%=green, 10%=amber, >10%=red),
//   supplement search debounced predictive, prominent Add button,
//   LM Link removed from Settings UI.
// V81: Supplements tab.
// V81: Full Supplements feature.
//   - New "Supplements" bottom nav tab (6th tab, gated by hasTargets).
//   - supplement_stacks + supplement_logs Supabase tables.
//   - Daily view grouped by timing slot with checkboxes.
//   - Add supplement: search DB first, fall back to free text.
//   - AI Schedule Planner: LLM assigns optimal timing per supplement.
//   - AI integration: daily audit SUPPLEMENT LOG block, weekly briefing
//     adherence %, target generation gets stack context.
// V80: Dynamic calorie adjustment + auto-audit schedule.
// V80: Two features:
//   1. Dynamic calorie adjustment. After 14+ days of weight logs, a
//      weekly useEffect checks if the trend diverges from the goal by
//      >0.3kg/week and silently adjusts targets.calories by +/-100 kcal
//      (max +/-300 kcal from original). Saves to Supabase. Toast shown.
//   2. Auto-audit schedule. autoAuditTime stored in profile (default "").
//      A useEffect checks every minute. When current time matches and
//      the audit hasnt run today (np_last_audit_date in localStorage),
//      runCopilot() is called automatically. Setting in Settings.
// V79: Workout calorie credit.
// V79: WorkoutPilot calorie bridge.
//   fetchTodayWorkouts(uid) reads workout_sessions for today, selecting
//   id, name, duration, calories_burned, date.
//   todayWorkouts state populated on load alongside food logs.
//   Workout credit card rendered above macro bars on Today dashboard:
//   shows session name, duration, and estimated kcal burned.
//   Multiple sessions stacked if more than one logged today.
//   AI audit context updated: WORKOUT CREDIT line injected so the
//   coach accounts for calories burned.
// V78: My Meals tab + custom water input.
// V78: Three additions:
//   1. My Meals tab (5th bottom nav tab, gated by hasTargets).
//      Shows all saved favourites + a recipe builder. Recipe builder
//      lets user search DB/manual for ingredients, build running totals,
//      name and save to saved_meals. Recipe IDs tracked in localStorage
//      (np_recipe_ids) to distinguish from starred favourites.
//      Both sections support one-tap log (with meal type picker) and delete.
//   2. Custom water input -- third button on HydrationGauge opens a
//      small inline input so users can log any amount (330ml can,
//      500ml bottle, etc).
//   3. BookOpen icon added to lucide imports for My Meals tab.
// V77: Log item edit modal.
// V77: Edit button on logged food items. Pencil icon opens a bottom-sheet
//   modal pre-filled with the item's current values. User can correct name,
//   calories, protein, carbs, fat, fibre, sugar, sodium. Optimistic update
//   (instant UI) then Supabase write in background, same pattern as
//   updateMealType. snapshotDay called after to keep daily totals in sync.
// V76: Copy day picker + barcode timeout increase.
// V76: Two improvements:
//   1. Copy Yesterday replaced with a two-step modal flow: step 1 shows
//      yesterday's meal slots (Breakfast/Lunch/Dinner/Snack), step 2 shows
//      individual items with checkboxes. User picks what to copy into the
//      currently selected meal type. Replaces the blind copy-all behaviour.
//   2. OPF fetch timeouts increased 10s -> 20s for both barcode lookup and
//      NLP text search -- 10s was too tight on mobile connections.
// V75: Weekly briefing water fix.
// V75: fetchSevenDayLogs now fetches water_logs in parallel alongside food logs
//   and merges water_ml per day into byDay[date].water. Weekly briefing
//   avgWater now reads from byDay instead of the unreliable dayHistory
//   snapshot, so historical water data from the water_logs table is used.
// V74: select("*") narrowed + empty states.
// V74: Three improvements:
//   1. select("*") replaced with explicit column lists on all Supabase reads.
//   2. Today dashboard empty state upgraded with meal-type shortcuts.
//   3. Intel Charts sub-view empty state for users with no history.
// V73: 7-Day macro filter overhaul.
// V73: Three improvements to Progress 7-Day Log macro filter:
//   1. Filter button + dropdown moved inside the 7-Day Log card header
//      (was in top nav bar -- too far from the table it controls).
//   2. Kcal removed from filter options -- it is hardcoded as the delta
//      column and was confusing to have as a toggle.
//   3. Max 5 macros enforced in the UI -- unchecked items are disabled
//      and greyed out when 5 are already selected. Counter shows n/5.
//   progressMacros initial state updated: calories removed, protein/carbs/
//   fat/fibre as defaults (4 of 5 slots filled).
// V72: insertLog duplicate-tap prevention.
// V72: insertLog guard ref prevents double-tap from firing two Supabase inserts.
//   insertingRef.current flips true at function entry, resets in finally block.
//   All call sites benefit automatically -- NLP log, barcode log, quick-add,
//   favourite add, and AI meal suggestion add.
// V71: Camera stream stopped on app backgrounding -- visibilitychange + pagehide.
// V70: "Persona Differentiation + Settings Label + Chart Fix + AI + Water Fix"
// V55: Four structural upgrades to macro generation.
//   1. isGenerating state: button locks during LLM call, shows "AI Sports Nutritionist
//      calculating protocol..." spinner until fully resolved.
//   2. MACRO_SYSTEM prompt rewritten as elite/ruthless clinical sports nutritionist.
//      Schema expanded: weeks_to_goal (integer ETA) + rationale (2-sentence clinical
//      justification). max_tokens raised to 300. Protein/carb/fat protocols use
//      advanced sports science targets, not fixed percentages.
//   3. PROTOCOL ESTABLISHED modal: on successful generation, targetBriefing state
//      is populated with {targets, weeksToGoal, rationale, _h, _w, _a}. Modal
//      displays all 5 macros + ETA + rationale. Accept & Execute saves to Supabase
//      and navigates to dashboard. Reject discards without saving.
//   4. JS calcTargets fallback REMOVED from generateTargets. Catch block sets hard
//      error in onboardErr -- no numbers injected on failure.
// V54: Five targeted fixes (NLP filter, weight sync, delta dedup, physiqueGoal
//      in Settings, LLM macro generation with JS fallback, prompt law upgrades).
//   1. fetchNLP garbage filter: single-word queries now reject product names
//      with >3 words (blocks "Food In A Bottle" etc). Exact-match names sorted
//      to index[0] before popularity sort. isSingleWord detection from queryWords.
//   2. logWeight now syncs kg to profiles.weight and calls setWeight(String(kg))
//      immediately -- Today/AI/targets recalculate without page reload.
//   3. Progress 7-Day Delta: dayHistory deduped by date and sorted ascending
//      before slice(-7) so newest 7 distinct calendar days always render.
//   4a. Settings screen: physiqueGoal textarea added before Coach Persona card.
//   4b. generateTargets upgraded to LLM-driven macro generation: Step 1 classifies
//      activity (unchanged), Step 2 calls llama-3.3-70b-versatile as clinical
//      sports nutritionist for full macro JSON (calories/protein/carbs/fat/fibre).
//      Validation gates: calories 800-6000, protein >30g, fat >10g. JS calcTargets
//      remains as fallback if LLM fails or returns implausible values.
//   5. Daily Audit system prompt upgrades: HYDRATION COMMAND LAW (no "Xml/h"
//      micro-math, bulk commands only), PHYSIQUE GOAL LAW (no verbatim name-drop,
//      use "your target physique"), DEFICIT LAW (300-500 kcal deficit is optimal
//      recomposition zone -- only flag if >600 kcal below active target).
//      Water tactical line updated to bulk-command format.
// V53: Pro-Rata Audit Law -- MORNING/MIDDAY/EVENING windows, PRO_RATA_LAW block.
//      Three windows: MORNING 05-11 (Building -- no "failure"/Accidental Keto,
//      proactive fuelling focus), MIDDAY 12-17 (50% benchmark -- flag only if
//      significantly behind pace, >25% of daily target short of expected intake),
//      EVENING 17-23 (full audit, all language permitted, final-state critique).
//      PRO_RATA_LAW block injected into BOTH system prompt and user prompt.
//      Accidental Keto alert suppressed in MORNING window; reframed as correction
//      opportunity rather than hard failure.
//      MIDDAY: caloriesPaceTarget computed from waking window fraction. PACE CHECK
//      block injected into user prompt with expected/actual/status.
//      All three SYSTEM prompts now carry PROFILE block with height, weightGoal,
//      physiqueGoal, targets.calories, targets.protein injected dynamically.
//      GOAL ALIGNMENT LAW: model forbidden from guessing or substituting weight
//      targets not stated in profile. Physique scaling uses user's actual height.
//      hour variable renamed currentHour throughout for clarity.
// V52: snapshotDay waterOverride param; insertLog/deleteLog carbs in snap reduce;
//      WEEKLY_SYSTEM TARGET LAW + PROS LAW.
// V50: runWeeklyBriefing structural overhaul -- JSON output with four keys,
//      splitWeeklyResponse() parser, four-section UI card.
//      Day History Ledger: d.target falls back to targets.calories for old
//      day_history entries that predate the target field. daysMet and Wall of
//      Shame fallback both updated with same guard.
//      Daily Audit: splitAuditResponse fully rewritten -- 3-strategy pipeline
//      (firstBrace/lastBrace JSON extract -> regex key extraction -> ### split)
//      avoids cleanAIResponse conflict. max_tokens raised 600 -> 900.
//      JSON_CONTRACT tightened: first token must be {, last must be }.
//      Weekly Briefing: sentence count changed 7-12 -> 4-7 per spec.
//      Fuel Check rule added to WEEKLY_SYSTEM: flags fat>20g over + carbs>50g
//      under as energy conflict for 3x/week lifting mandate.
// V48: Dynamic physique scaling, metabolic state classification, 7h protein
//      timing, snapshotDay carbs field, weekly briefing refactor.
// V45: OPF search reverted to search_terms; Grams/Serving toggle in modal;
//      duplicate Market Region / Physique Goal cards removed from Onboard.
// V44: AI context strengthened -- BMR, TDEE, physique goal in prompts.
// V43: Search-First modal, Market Region, Physique Goal field.
// V42: Auth race condition fix, NLP extractSearchTerm translation layer.
// V41: OPF popularity sort, snapshotDay, WeightVsCalorieChart, Habit Matrix
// V40: Gorillaz concrete theme, distinct macro bar colours, MOCK_DB removed
// V39: CameraErrorBoundary, CircadianAlignmentScore, syncWater, Accordion
//      Ledger, Satiety Index, NLP candidate list, Bad Boy voice sharpened
// ─────────────────────────────────────────────────────────────────────────────
// ARCHITECTURE NOTE — LOCAL-ONLY MANDATE
// This prototype is intentionally zero-cloud for AI and zero-external for scanning.
// Any suggestion to route barcode data through a cloud vision API (Google Vision,
// AWS Rekognition, Azure Computer Vision) is REJECTED. Reasons:
//   1. Cost: all three charge per-image after free tier. Barcode scanning is
//      high-frequency — a user logs 4-6 items/day = 120-180 API calls/month.
//   2. Privacy: food log data is personal health data. Sending images to Google
//      to read a barcode is unnecessary data exposure.
//   3. Latency: a round-trip to a cloud vision API adds 300-800 ms vs <50 ms
//      for native BarcodeDetector running on the GPU.
//   4. Dependency: cloud APIs have rate limits, outages, and breaking changes.
//      The native BarcodeDetector API has been stable since Chrome 83 (2020).
// The BarcodeDetector fallback is: manual numeric entry. That is sufficient.
// ==============================================================================
import { useState, useEffect, useCallback, useRef, useMemo, Component } from "react";
import * as Sentry from "@sentry/react";
import { setAnalyticsUserId, logEvent as firebaseLogEvent } from "./firebase";
import { Analytics } from "@vercel/analytics/react";
import { supabase } from "./supabaseClient";
import { Lightning, ChartBar, EnvelopeSimple, WarningCircle, EyeSlash, Eye, User, Lock, Plus, Cloud, Check, ArrowLeft, CheckCircle, Trophy } from "@phosphor-icons/react";

// ─── MODULE IMPORTS ───────────────────────────────────────────────────────────
import { THEMES, T, getHeaderBg } from "./themes";
import { API_BASE, LLM_URL_DEFAULT, LLM_MODEL_DEFAULT, LLM_MODEL_HEAVY, LLM_MODEL_LIGHT, getLLMUrl, LLM_TIMEOUT_MS, llmFetch, llmErrMsg, cleanAIResponse, extractSearchTerm, AI_SAFETY_LAW, INJURY_LAW, WORKOUT_SAFETY_LAW, sendChatMessage } from "./llm";
import { MEALS, MEAL_ICON, PERSONAS, PERSONA_PREVIEW, SEDENTARY_KW, isSedentary, OPF_SEARCH, OPF_URL, TODAY_ISO, opfServingSuggestion, calcTargets, clamp, fmtDuration, fmtDate, hourOf, BODY_FIELDS, printSummary, SIMPLE_GOAL_PRESETS } from "./constants";
import { fetchThirtyDayLogs, fetchSevenDayLogs, fetchKnownBrands } from "./supabaseQueries";
import MacroRing from "./components/MacroRing";
import MacroBar from "./components/MacroBar";
import ComicCard from "./components/ComicCard";
import Btn from "./components/Btn";
import Field from "./components/Field";
import Spinner from "./components/Spinner";
import SectionLabel from "./components/SectionLabel";
import GenderToggle from "./components/GenderToggle";
import PersonaPicker from "./components/PersonaPicker";
import BottomNav from "./components/BottomNav";
import SecureContextCard from "./components/SecureContextCard";
import MeasurementSparkline from "./components/MeasurementSparkline";
import ErrorBoundary from "./components/ErrorBoundary";
import SettingsScreen from "./screens/SettingsScreen";
import IntelligenceScreen from "./screens/IntelligenceScreen";
import MyMealsScreen from "./screens/MyMealsScreen";
import SupplementsScreen from "./screens/SupplementsScreen";
import ProgressScreen from "./screens/ProgressScreen";
import NutriDashboardScreen from "./screens/NutriDashboardScreen";
import SyncBadge from "./components/SyncBadge";
import BurnDownChart from "./components/BurnDownChart";
import HydrationGauge from "./components/HydrationGauge";
import { useHints } from "./hooks/useHints";
import { useHealthConnect } from "./hooks/useHealthConnect";
import { enqueue, processQueue, getQueueLength, isQueueFull, clearQueue } from "./offlineQueue";

// ─── FEATURE FLAGS ────────────────────────────────────────────────────────────
const PREMIUM_ENABLED = false; // flip to true to activate premium gating

// ─── CONFIG ───────────────────────────────────────────────────────────────────
// LLM_URL_DEFAULT: the Vercel serverless function that proxies to Groq.
// The API key is injected server-side — never sent from the frontend.
// LM Link (localStorage key "lm_url") overrides this at runtime for local
// LM Studio development — no rebuild required. getLLMUrl() is called fresh
// on every llmFetch so endpoint changes take effect immediately.

// ==============================================================================
// NUDGE MODAL — in-app smart prompt overlay
// Fixed-position card that appears above the BottomNav.
// Auto-dismisses after 30 seconds if no action taken.
// Defined outside App so it is not re-created on every App render.
// ==============================================================================
function NudgeModal({ nudge, setActiveNudge, T }) {
  const timerRef = useRef(null);
  useEffect(() => {
    if (!nudge) return;
    timerRef.current = setTimeout(() => setActiveNudge(null), 30000);
    return () => clearTimeout(timerRef.current);
  }, [nudge, setActiveNudge]);
  if (!nudge) return null;
  return (
    <div style={{
      position:"fixed", bottom:72, left:0, right:0,
      zIndex:8000, display:"flex", justifyContent:"center",
      padding:"0 12px", pointerEvents:"none",
    }}>
      <div style={{
        background:T.card, border:`1px solid ${T.cardBorder}`, borderRadius:18,
        boxShadow:T.shadow, padding:16,
        maxWidth:420, width:"100%", pointerEvents:"all",
      }}>
        <h3 style={{color:T.inkDark,fontSize:16,fontWeight:800,fontFamily:T.fontDisplay,
          margin:"0 0 8px"}}>
          {nudge.title}
        </h3>
        <p style={{color:T.inkMuted,fontSize:12,fontFamily:T.fontSans,fontWeight:500,
          margin:"0 0 12px",lineHeight:1.5}}>
          {nudge.body}
        </p>
        <div style={{display:"flex",gap:10,alignItems:"center"}}>
          <button onClick={nudge.onPrimary} style={{
            flex:2, background:T.hydrationBlue||T.accent, color:"#fff", border:"none",
            borderRadius:12, padding:11, fontSize:12,
            fontWeight:700, fontFamily:T.fontSans,
            cursor:"pointer",
          }}>
            {nudge.primaryLabel}
          </button>
          <button onClick={nudge.onSecondary} style={{
            flex:1, background:"transparent", color:T.inkMuted, border:"none",
            padding:"11px 8px", fontSize:12, fontWeight:600,
            fontFamily:T.fontSans, cursor:"pointer",
          }}>
            {nudge.secondaryLabel}
          </button>
        </div>
      </div>
    </div>
  );
}

// ==============================================================================
// TOP-LEVEL ERROR BOUNDARY — catches errors above per-screen ErrorBoundary
// (auth gate, routing, theme init). Minimal styling — no T theme dependency.
// ==============================================================================
export class TopLevelErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  componentDidCatch(error, info) {
    console.error('Top-level error:', error, info);
    Sentry.captureException(error, { extra: { boundary: 'TopLevel', componentStack: info?.componentStack } });
  }
  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: '2rem', textAlign: 'center', fontFamily: 'Inter, system-ui, sans-serif' }}>
          <p style={{ fontSize: 16, fontWeight: 600, marginBottom: 12 }}>Something went wrong. Please refresh the app.</p>
          <button onClick={() => window.location.reload()} style={{
            background: T.ink, color: T.card, border: 'none', borderRadius: 8,
            padding: '10px 24px', fontSize: 13, fontWeight: 700, cursor: 'pointer',
          }}>Reload</button>
        </div>
      );
    }
    return this.props.children;
  }
}

// ==============================================================================
// MAIN APP
// ==============================================================================
export default function App() {
  // ── Psych-Mode: theme applied per render, before any state reads ───────────
  // Object.assign runs here so the theme is live for all JSX in this render.
  // The actual Object.assign with live persona state runs after persona useState.
  // See comment below at persona declaration.
  const [session,    setSession]    = useState(null);
  const [authReady,  setAuthReady]  = useState(false);
  // V42: profileLoading gates the post-auth render until loadProfileAndLogs
  // completes. Prevents flash-to-onboard on page refresh for logged-in users.
  const [profileLoading, setProfileLoading] = useState(true);
  const [profileLoaded,  setProfileLoaded]  = useState(false); // V103: true only after loadProfileAndLogs completes — guards onboarding condition
  const [activeNudge,    setActiveNudge]    = useState(null);  // V104: in-app nudge modal — one at a time
  const [targetWeight,   setTargetWeight]   = useState(null); // V105: target weight in kg (numeric|null)
  // V24 FIX 8a: Premium tier gating
  const [isPremium,      setIsPremium]      = useState(false); // true if profiles.is_premium === true
  const [showPaywall,    setShowPaywall]    = useState(false); // paywall modal visibility
  const [paywallReason,  setPaywallReason]  = useState("general"); // "daily_limit" | "persona" | "general"
  const [waitlistEmail,     setWaitlistEmail]     = useState("");
  const [waitlistSubmitted, setWaitlistSubmitted] = useState(false);
  const [waitlistSubmitting,setWaitlistSubmitting]= useState(false);
  const effectiveIsPremium = !PREMIUM_ENABLED || isPremium; // when PREMIUM_ENABLED=false, everyone has full access
  const [showLaunch,     setShowLaunch]     = useState(() => {
    try { return localStorage.getItem("lithe_app") !== "nutri"; } catch(_) { return true; }
  });  // V87: app selection screen — persisted so returning users skip it
  const [authScreen, setAuthScreen] = useState("login"); // "login"|"signup"|"reset"
  const [resetOk,    setResetOk]    = useState("");
  const [gdprConsent,setGdprConsent]= useState(false);
  const [ageConfirmed,setAgeConfirmed]= useState(false);
  const [authEmail,  setAuthEmail]  = useState("");
  const [authPass,   setAuthPass]   = useState("");
  const [authName,   setAuthName]   = useState("");
  const [authErr,    setAuthErr]    = useState("");
  const [authLoad,   setAuthLoad]   = useState(false);
  const [showPass,   setShowPass]   = useState(false);
  const [resendCountdown, setResendCountdown] = useState(0);   // V191: resend confirmation email cooldown
  const [resendOk,        setResendOk]        = useState("");  // V191: "Email sent!" brief feedback
  // Password reset callback state
  const [isPasswordReset, setIsPasswordReset] = useState(false);
  const [newPassword, setNewPassword]         = useState("");
  const [newPasswordErr, setNewPasswordErr]   = useState("");
  const [newPasswordDone, setNewPasswordDone] = useState(false);
  const [newPasswordLoading, setNewPasswordLoading] = useState(false);

  // ── Screen ─────────────────────────────────────────────────────────────────
  const [screen,   setScreen]   = useState("settings");
  const screenRef = useRef(screen); // V25 FIX 4: stable ref for back-button handler
  const screenHistoryRef = useRef([]); // V28: back button screen stack
  const modalCloseRef = useRef(null); // V28: stores a function to close the topmost modal

  // ── Profile ────────────────────────────────────────────────────────────────
  const [height,     setHeight]     = useState("175");
  const [weight,     setWeight]     = useState("75");
  const [age,        setAge]        = useState("28");
  const [gender,     setGender]     = useState("M");
  const [goal,       setGoal]       = useState("");

  const [darkMode, setDarkMode] = useState(()=>{ try{ return localStorage.getItem("np_dark")==="1"; }catch(_){ return false; } });
  const [persona,    setPersona]    = useState("Balanced");
  // Apply theme immediately — before any JSX that reads T
  // Apply dark variant if darkMode is on
  const effectiveTheme = darkMode ? (persona + "Dark") : persona;
  Object.assign(T, THEMES[effectiveTheme] || THEMES[persona] || THEMES.Balanced);
  // Sync document body background to current theme (affects area outside phone shell)
  useEffect(() => {
    // Inject Google Fonts if not already present
    if (!document.getElementById("lithe-fonts")) {
      const link = document.createElement("link");
      link.id = "lithe-fonts";
      link.rel = "stylesheet";
      link.href = "https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800;900&family=Poppins:wght@600;700;800;900&display=swap";
      document.head.appendChild(link);
    }
    // Inject animation keyframes if not already present
    if (!document.getElementById("lithe-keyframes")) {
      const style = document.createElement("style");
      style.id = "lithe-keyframes";
      style.textContent = `
        @keyframes np-spin {
          to { transform: rotate(360deg); }
        }
        @keyframes np-shimmer {
          0%   { background-position: -200% center; }
          100% { background-position:  200% center; }
        }
        .macrobar-shimmer {
          background-image: linear-gradient(90deg, transparent 25%, rgba(255,255,255,0.18) 50%, transparent 75%);
          background-size: 200% 100%;
          animation: np-shimmer 1.6s linear infinite;
        }
        * { font-size: inherit; }
        body { font-size: 15px; }
      `;
      document.head.appendChild(style);
    }
    document.body.style.background = T.bg;
    document.body.style.fontFamily = T.fontSans;
    return () => { document.body.style.background = ""; };
  }, [persona, darkMode]);
  // Persist dark mode preference to localStorage
  useEffect(() => { try { localStorage.setItem("np_dark", darkMode ? "1" : "0"); } catch(_){} }, [darkMode]);
  // V191: resend confirmation email countdown ticker
  useEffect(() => {
    if (resendCountdown <= 0) return;
    const t = setTimeout(() => setResendCountdown(c => c - 1), 1000);
    return () => clearTimeout(t);
  }, [resendCountdown]);
  const headerBg = getHeaderBg(persona);
  // MEAL_COLOR must be derived after Object.assign so it reflects the live theme
  const MEAL_COLOR = { Breakfast:T.mealBreakfast, Lunch:T.mealLunch, Dinner:T.mealDinner, Snack:T.mealSnack };
  const [country,    setCountry]    = useState("uk");        // V43: OPF market region
  const [physiqueGoal, setPhysiqueGoal] = useState("");      // V43: physique goal for AI
  const [goalMode,   setGoalMode]   = useState("simple");   // "ai" | "simple"
  const [simpleGoal, setSimpleGoal] = useState("lose"); // "lose" | "maintain" | "bulk"
  // SIMPLE_GOAL_PRESETS imported from ./constants — single source of truth
  const [wakeTime,   setWakeTime]   = useState("07:00");
  const [bedTime,    setBedTime]    = useState("23:00");
  const [autoAuditTime, setAutoAuditTime] = useState("");  // "HH:MM" or "" to disable
  const [adjustToast,   setAdjustToast]   = useState("");  // dynamic calorie adj toast
  const [targets,    setTargets]    = useState({calories:0,protein:0,carbs:0,fat:0,fibre:30,sugar:30,sodium:2300,bmr:0,tdeeRaw:0});
  const [dayHistory, setDayHistory] = useState([]);

  // ── Onboard ────────────────────────────────────────────────────────────────
  const [bmrPreview,     setBmrPreview]     = useState(0);
  const [onboardLoading,  setOnboardLoading]  = useState(false);
  const [onboardErr,      setOnboardErr]      = useState("");
  const [isGenerating,    setIsGenerating]    = useState(false);   // V55: AI lockout during macro generation
  const [targetBriefing,  setTargetBriefing]  = useState(null);    // V55: { targets, weeksToGoal, rationale }
  const [wizardStep,      setWizardStep]      = useState(0);       // V94: Onboarding wizard (0=inactive, 1-5=steps)
  const [wizardActivity,  setWizardActivity]  = useState("light"); // V191: activity level selected in wizard step 3
  const [showWizardDone,  setShowWizardDone]  = useState(false);   // V190: post-wizard delight screen

  // ── Date Navigation (V26 HOTFIX 7) ─────────────────────────────────────────
  const [viewingDate, setViewingDate] = useState(() => new Date().toISOString().split("T")[0]);
  const isViewingToday = viewingDate === TODAY_ISO();

  // ── Logs ───────────────────────────────────────────────────────────────────
  const [logs,       setLogs]       = useState([]);
  const [logMode,    setLogMode]    = useState("nlp");
  const [mealType,   setMealType]   = useState("");
  const [nlpQty,     setNlpQty]     = useState("");
  const [nlpFood,    setNlpFood]    = useState("");
  const [barcode,    setBarcode]    = useState("");
  const [barcodeQty, setBarcodeQty] = useState("100");
  const [manual,     setManual]     = useState({name:"",calories:"",protein:"",carbs:"",fat:""});
  const [logLoading, setLogLoading] = useState(false);
  const [logErr,     setLogErr]     = useState("");
  const [logOk,      setLogOk]      = useState("");
  const [suggestions,setSuggestions] = useState([]);
  // Dynamic brand set — loaded once on mount from branded_foods table
  const [knownBrands, setKnownBrands] = useState(new Set());
  // NLP selection list — populated after OPF search, cleared on select or cancel
  const [nlpCandidates, setNlpCandidates] = useState([]); // [{name,kcal100,p100,c100,f100,fi100,su100,na100}]
  const [nlpHistory, setNlpHistory] = useState(()=>{ try { return JSON.parse(localStorage.getItem("np_nlp_history"))||[]; } catch(_){ return []; } });
  // V26 FIX 17: Food search history (Supabase-backed)
  const [searchHistory, setSearchHistory] = useState([]);
  const [showSearchHistory, setShowSearchHistory] = useState(false);
  // V26 FIX 18: Barcode scan history
  const [barcodeHistory, setBarcodeHistory] = useState([]);
  // V26 FIX 24: Achievement system
  const [unlockedAchievements, setUnlockedAchievements] = useState([]);
  const [achievementToast, setAchievementToast] = useState(null);
  // V159 FIX 5: one-shot re-evaluation after logHistory loads
  const achieveInitRef = useRef(false);
  // V43: Search-First modal state -- selected candidate awaiting qty confirmation
  const [nlpModal, setNlpModal] = useState(null);     // candidate object or null
  const [nlpModalQty, setNlpModalQty] = useState("100"); // qty input inside modal
  const [nlpModalError, setNlpModalError] = useState(""); // inline validation error
  // Accordion ledger — which meal slots are expanded (all collapsed by default)
  const [openSlots,  setOpenSlots]  = useState({});

  // ── Hydration ──────────────────────────────────────────────────────────────
  const [waterMl,    setWaterMl]    = useState(0);

  // syncWater: update local state with functional update (stale-closure-safe)
  // and debounce the Supabase write so rapid taps accumulate correctly.
  const waterSyncTimer = useRef(null);
  const waterNextRef = useRef(0); // tracks latest value for debounced write
  function syncWater(delta) {
    if (!session) return;
    setWaterMl(prev => {
      const next = Math.max(0, prev + delta);
      waterNextRef.current = next;
      // Debounce the Supabase write — only fires 600ms after last tap
      clearTimeout(waterSyncTimer.current);
      waterSyncTimer.current = setTimeout(async () => {
        const val = waterNextRef.current;
        try {
          const logDate = viewingDate || TODAY_ISO();
          // Only update profiles.water_ml when viewing today
          if (logDate === TODAY_ISO()) {
            await supabase.from("profiles").upsert(
              { id: session.user.id, water_ml: val, water_date: logDate, updated_at: new Date().toISOString() },
              { onConflict: "id" }
            );
          }
          try {
            await supabase.from("water_logs").upsert(
              { user_id: session.user.id, log_date: logDate, water_ml: val },
              { onConflict: "user_id,log_date" }
            );
          } catch(wErr) {
            enqueue("water_logs", "upsert", { user_id: session.user.id, log_date: logDate, water_ml: val }, session.user.id);
            if (process.env.NODE_ENV !== "production") console.warn("[syncWater] water_logs queued offline", wErr);
          }
          if (logDate === TODAY_ISO()) snapshotDay(null, val);
        } catch(e) {
          Sentry.captureException(e, { extra: { context: "syncWater" } }); if (process.env.NODE_ENV !== "production") console.error("[syncWater]", e);
          setSyncErr(true);
          showToast("Failed to sync hydration.");
        }
      }, 600);
      return next;
    });
  }

  // ── Unit toggles ───────────────────────────────────────────────────────────
  const [barcodeUnit,    setBarcodeUnit]    = useState("g");
  const [manualUnit,     setManualUnit]     = useState("g");

  // ── Camera scanner (V16.1) ────────────────────────────────────────────────
  // cameraActive: video stream is running
  // cameraErr: string — populated by permission gate or browser capability check
  // cameraToast: string — transient HTTPS warning, auto-clears after 4 s
  const [cameraActive,    setCameraActive]    = useState(false);
  const [cameraRationaleShown, setCameraRationaleShown] = useState(
    () => { try { return localStorage.getItem("np_cam_rationale") === "1"; } catch(_) { return false; } }
  );
  const [showCameraRationale, setShowCameraRationale] = useState(false);
  const [cameraSecureErr, setCameraSecureErr] = useState(false);  // true = show SecureContextCard
  const [cameraErr,       setCameraErr]       = useState("");
  // videoReady: true once onloadedmetadata has fired and the frame buffer is populated.
  // Used to show the "Tap to Start Video" fallback overlay when autoplay is blocked.
  const [videoReady,      setVideoReady]      = useState(false);
  const [cameraToast,     setCameraToast]     = useState("");
  // Barcode state machine: idle → scanning → review → (back to idle after log)
  // scannedProduct: raw nutriments + name from OPF, stored between scan and confirm
  const [barcodeStep,     setBarcodeStep]     = useState("idle"); // "idle"|"scanning"|"review"
  const [scannedProduct,  setScannedProduct]  = useState(null);   // {name, kcal100, p100, c100, f100}
  const videoRef = useRef(null);
  const streamRef = useRef(null);    // MediaStream — held so we can stop tracks
  const detectorRef = useRef(null);  // BarcodeDetector instance
  const rafRef = useRef(null);       // requestAnimationFrame handle
  const insertingRef = useRef(false); // duplicate-tap guard for insertLog

  // V28 FIX 4: Contextual hints
  const hints = useHints(session?.user?.id);

  // ── AI: Audit tab ──────────────────────────────────────────────────────────
  // V47: Three separate state vars instead of a single cpResp JSON string.
  // parseCpResp() is now only used for loading stored last_audit from Supabase.
  // Live audit results are split immediately at the point of receipt.
  const [cpLoading,        setCpLoading]        = useState(false);
  const [cpHeadline,       setCpHeadline]       = useState(""); // V40: headline text
  const [cpMetabolic,      setCpMetabolic]      = useState(""); // right_now text (was metabolic_review)
  const [cpTactical,       setCpTactical]       = useState(""); // recovery text (was tactical_recovery)
  const [cpOutlook,        setCpOutlook]        = useState(""); // outlook text
  const [cpAction,         setCpAction]         = useState(""); // V40: action text
  // cpResp kept for backward-compat with Supabase last_audit load path only
  const [cpResp,           setCpResp]           = useState(""); // legacy — JSON string from DB

  // ── AI: Intelligence screen ────────────────────────────────────────────────
  const [weeklyLoading,   setWeeklyLoading]   = useState(false);
  const [crossAppData, setCrossAppData] = useState(null);
  const [crossAppLoading, setCrossAppLoading] = useState(false);
  const [bodyProjData, setBodyProjData] = useState(null);
  const [bodyProjLoading, setBodyProjLoading] = useState(false);
  const [mealPrepData, setMealPrepData] = useState(null);
  const [mealPrepLoading, setMealPrepLoading] = useState(false);
  const [mealPrepError, setMealPrepError] = useState("");
  const [wbSummary,       setWbSummary]       = useState("");
  const [wbPros,          setWbPros]          = useState([]);
  const [wbNegatives,     setWbNegatives]     = useState([]);
  const [wbPriorities,    setWbPriorities]    = useState([]);
  const [weeklyTs,        setWeeklyTs]        = useState(()=>{ try{ return parseInt(localStorage.getItem("np_weekly_ts"))||0; }catch(_){ return 0; } });
  // Intelligence screen view toggle
  const [intelView,      setIntelView]      = useState("weekly"); // "weekly" | "daily"
  // intelByDay: { "YYYY-MM-DD": { calories, protein, carbs, fat, logged } }
  // Populated by loadIntelMeta() or as a side-effect of runWeeklyBriefing().
  const [intelByDay,     setIntelByDay]     = useState({});
  const [habitMetrics,   setHabitMetrics]   = useState(()=>{
    try { const s=localStorage.getItem("lithe_habit_metrics"); return s?JSON.parse(s):["Calories","Protein","Fiber","Water","Fats"]; } catch(_){ return ["Calories","Protein","Fiber","Water","Fats"]; }
  });
  useEffect(()=>{ try { localStorage.setItem("lithe_habit_metrics", JSON.stringify(habitMetrics)); } catch(_){} }, [habitMetrics]);
  const [visibleMacros,  setVisibleMacros]  = useState(["calories","protein","carbs","fat","fibre"]);
  const [progressMacros, setProgressMacros] = useState(["protein","carbs","fat","fibre"]);
  const [showProgressFilter,setShowProgressFilter] = useState(false);
  const [showMacroFilter,setShowMacroFilter]= useState(false);
  const [logHistory,     setLogHistory]     = useState([]); // 30-day from logs table
  const [intelLoading,   setIntelLoading]   = useState(false);

  // ── Sync ───────────────────────────────────────────────────────────────────
  const [syncing,   setSyncing]   = useState(false);
  const [syncErr,   setSyncErr]   = useState(false);
  const [isOnline,  setIsOnline]  = useState(true); // Default to online — flip only on explicit offline event

  // ── Health Connect (Part 1) ───────────────────────────────────────────────
  const hc = useHealthConnect();


  // ── Body Measurements ──────────────────────────────────────────────────────
  const [bodyMeasurements, setBodyMeasurements] = useState([]);
  const [bodyMeasLoading, setBodyMeasLoading] = useState(false);
  const [bodyMeasForm, setBodyMeasForm] = useState({});
  const [showBodyMeas, setShowBodyMeas] = useState(false);

  // ── LM Link — localStorage-backed LLM endpoint override ──────────────────
  // Default: "/api/chat" (Vercel serverless → Groq). Set a custom URL here to
  // route requests to a local LM Studio instance instead. Never synced to Supabase.
  const [lmUrl, setLmUrl] = useState(() => {
    try { return localStorage.getItem("lm_url") || LLM_URL_DEFAULT; } catch(_) { return LLM_URL_DEFAULT; }
  });

  // ── Saved Meals / Favourites ───────────────────────────────────────────────
  const [savedMeals,    setSavedMeals]    = useState([]);
  const [showFavs,      setShowFavs]      = useState(false);
  const [savingMeal,    setSavingMeal]    = useState(false);
  // My Meals / Recipe builder state
  const [showRecipeBuilder, setShowRecipeBuilder] = useState(false);
  const [recipeIngredients, setRecipeIngredients] = useState([]);  // [{name,calories,protein,carbs,fat,fibre,sugar,sodium,grams}]
  const [recipeSearch,  setRecipeSearch]  = useState("");
  const [recipeResults, setRecipeResults] = useState([]);
  const [recipeSearching,setRecipeSearching]=useState(false);
  const [recipeName,    setRecipeName]    = useState("");
  const [recipeSaving,  setRecipeSaving]  = useState(false);
  const [recipeLogModal,setRecipeLogModal]= useState(null);  // meal object to log
  const [recipeLogType, setRecipeLogType] = useState("");    // meal type for log
  // Recipe IDs tracked in localStorage to distinguish from starred favourites
  const [recipeIds, setRecipeIds] = useState(() => {
    try { return new Set(JSON.parse(localStorage.getItem("np_recipe_ids")||"[]")); }
    catch(_) { return new Set(); }
  });
  // Custom water input state
  const [showCustomWater, setShowCustomWater] = useState(false);
  const [customWaterVal,  setCustomWaterVal]  = useState("");

  // ── Weight Log ─────────────────────────────────────────────────────────────
  const [weightLogs,    setWeightLogs]    = useState([]);
  const [weightInput,   setWeightInput]   = useState("");
  const [weightLogLoading, setWeightLogLoading] = useState(false);

  // ── Meal Suggestions ──────────────────────────────────────────────────────
  const [mealSugLoading, setMealSugLoading] = useState(false);
  const [mealSuggestions, setMealSuggestions] = useState([]);
  const [mealSugErr, setMealSugErr] = useState("");

  // ── Hero Summary ─────────────────────────────────────────────────────────────
  const [heroSummary,        setHeroSummary]        = useState("");
  const [heroSummaryLoading, setHeroSummaryLoading] = useState(false);
  const heroSummaryCalRef = useRef(0);

  // ── Food DB search state ──────────────────────────────────────────────────
  const [dbSuggestions,  setDbSuggestions]  = useState([]); // predictive dropdown results
  const [dbSearching,    setDbSearching]    = useState(false);
  const [showSuggestForm,setShowSuggestForm]= useState(false);
  const [suggestForm,    setSuggestForm]    = useState({name:"",brand:"",calories:"",protein:"",carbs:"",fat:"",cookingState:"raw"});
  const [suggestOk,      setSuggestOk]      = useState("");
  const [suggestErr,     setSuggestErr]     = useState("");
  const dbDebounceRef = useRef(null);
  const swipeRef = useRef({}); // {[itemId]: {startX, delta, swiped}}

  // ── Copy Yesterday ─────────────────────────────────────────────────────────
  const [copyLoading,   setCopyLoading]   = useState(false);
  const [copyOk,        setCopyOk]        = useState("");
  const [copyModal,     setCopyModal]     = useState(null); // null | "slots" | "items"
  const [copyYestLogs,  setCopyYestLogs]  = useState([]);   // all of yesterday's logs
  const [copySelSlot,   setCopySelSlot]   = useState(null); // selected meal slot
  const [copySelItems,  setCopySelItems]  = useState(new Set()); // selected item indices
  const [editItem,      setEditItem]      = useState(null);      // item being edited | null
  const [showDeleteModal,  setShowDeleteModal]  = useState(false);
  const [deleteConfirmText,setDeleteConfirmText]= useState("");
  const [deleteErr,        setDeleteErr]        = useState("");
  const [deleteLoading,    setDeleteLoading]    = useState(false);
  const [exportLoading,    setExportLoading]    = useState(null);  // "json"|"csv"|null
  const [exportErr,        setExportErr]        = useState("");
  const [editForm,      setEditForm]      = useState({});        // edit form field values
  const [editSourceFood, setEditSourceFood] = useState(null);    // fetched source food for enhanced edit
  const [todayWorkouts, setTodayWorkouts] = useState([]);        // workout_sessions for today
  const [postWorkoutNudge, setPostWorkoutNudge] = useState(null); // { message, workoutName }
  // ── Supplements
  const [suppStack,        setSuppStack]        = useState([]);
  const [suppTakenToday,   setSuppTakenToday]   = useState(new Set());
  const [suppLogIds,       setSuppLogIds]       = useState({});
  const [suppLoading,      setSuppLoading]      = useState(false);
  const [showSuppAdd,      setShowSuppAdd]      = useState(false);
  const [suppAddStep,      setSuppAddStep]      = useState("search"); // "search" | "details"
  const [suppForm,         setSuppForm]         = useState({name:"",dose:"",timing:"Morning",notes:""});
  const [suppSearch,       setSuppSearch]       = useState("");
  const [suppSearchRes,    setSuppSearchRes]    = useState([]);
  const [suppSearching,    setSuppSearching]    = useState(false);
  const suppDbDebounceRef = useRef(null);
  const [suppScheduleLoad, setSuppScheduleLoad] = useState(false);
  const [suppScheduleMsg,  setSuppScheduleMsg]  = useState("");
  const SUPP_TIMINGS = ["Morning","Pre-Workout","Post-Workout","With Meals","Evening","Bedtime"];

  // ── Serving size preset ────────────────────────────────────────────────────
  const [servingPreset, setServingPreset] = useState("");

  // ── Toast notifications ──────────────────────────────────────────────────
  const [toast, setToast] = useState(null); // { message, type: "error"|"success"|"info" }
  const toastTimer = useRef(null);
  function showToast(message, type = "error") {
    clearTimeout(toastTimer.current);
    setToast({ message, type });
    toastTimer.current = setTimeout(() => setToast(null), 4000);
  }

  // V24 FIX 5: open external links safely — Capacitor Browser plugin on native, window.open on web
  function openExternalLink(url) {
    const isNative = typeof window !== "undefined" &&
      (window.location?.protocol === "capacitor:" || !!(window.Capacitor?.isNativePlatform?.()));
    if (isNative) {
      import(/* webpackIgnore: true */ "@capacitor/browser")
        .then(({ Browser }) => Browser.open({ url }))
        .catch(() => window.open(url, "_system"));
    } else {
      window.open(url, "_blank");
    }
  }



  // ── Derived (V25 FIX 5: useMemo for expensive computations) ──────────────
  const totals = useMemo(() => logs.reduce((acc,l)=>({
    calories:acc.calories+(parseFloat(l.calories)||0),
    protein: acc.protein +(parseFloat(l.protein) ||0),
    carbs:   acc.carbs   +(parseFloat(l.carbs)   ||0),
    fat:     acc.fat     +(parseFloat(l.fat)      ||0),
    fibre:   acc.fibre   +(parseFloat(l.fibre)    ||0),
    sugar:   acc.sugar   +(parseFloat(l.sugar)    ||0),
    sodium:  acc.sodium  +(parseFloat(l.sodium)   ||0),
  }),{calories:0,protein:0,carbs:0,fat:0,fibre:0,sugar:0,sodium:0}), [logs]);

  const personaData  = PERSONAS.find(p=>p.id===persona)||PERSONAS[1];
  const hasTargets   = targets.calories > 0;
  const lastMealType = logs.length>0?logs[logs.length-1].meal_type:"None";
  // groupedLogs: group by meal_type, matching against the MEALS constant.
  // Items whose meal_type is missing, null, or not in MEALS go into "Other"
  // so they are never silently dropped from the Today view.
  const groupedLogs = useMemo(() => {
    const groups = MEALS.reduce((a, mt) => {
      const items = logs.filter(l => l.meal_type === mt);
      if (items.length > 0) a[mt] = items;
      return a;
    }, {});
    const unmatched = logs.filter(l => !MEALS.includes(l.meal_type));
    if (unmatched.length > 0) groups["Other"] = unmatched;
    return groups;
  }, [logs]);
  const hydrationTarget = useMemo(() => Math.round((parseFloat(weight) || 75) * 35 / 50) * 50, [weight]);

  // V158: Bug fix — was checking protein per individual food item (> 15g each),
  // causing false positives when a meal has >15g total spread across multiple items
  // (e.g. eggs 12g + yogurt 11g = 23g total, neither item alone passes the filter).
  // Fix: group logs by meal_type, sum protein per meal, check meal total > 15g.
  const proteinLogs = useMemo(() => {
    const mealProtein = {};
    const mealLatest  = {};
    logs.forEach(l => {
      const mt = l.meal_type || "Other";
      mealProtein[mt] = (mealProtein[mt] || 0) + (parseFloat(l.protein) || 0);
      if (l.logged_at && (!mealLatest[mt] || new Date(l.logged_at) > new Date(mealLatest[mt]))) {
        mealLatest[mt] = l.logged_at;
      }
    });
    return Object.entries(mealProtein)
      .filter(([mt, p]) => p > 15 && mealLatest[mt])
      .map(([mt, p]) => ({ meal_type: mt, protein: p, logged_at: mealLatest[mt] }))
      .sort((a, b) => new Date(b.logged_at) - new Date(a.logged_at));
  }, [logs]);
  const lastProteinLog  = proteinLogs[0];
  // V48: 7-hour waking window threshold (was 4h). Only alerts if no protein-dense
  // meal (>15g total across all items in the meal) has been logged within 7 hours.
  const proteinGapAlert = lastProteinLog
    ? (Date.now() - new Date(lastProteinLog.logged_at).getTime()) > 7 * 60 * 60 * 1000
    : logs.length > 0;

  // ─── AUTH INIT ─────────────────────────────────────────────────────────────
  const loadedRef = useRef(null);
  // Gate check runs first — string building is skipped entirely in production.
  function dbgTrace(fn) { if (process.env.NODE_ENV !== "production") console.log("[TRACE]", typeof fn === "function" ? fn() : fn); }
  const nlpQtyRef = useRef(null);

  useEffect(()=>{
    // V102: Auth init — getSession() FIRST, then onAuthStateChange for future events.
    //
    // Problem with the previous pattern on native Capacitor Android:
    //   onAuthStateChange fires INITIAL_SESSION with session=null before the token
    //   refresh completes. The old code treated null as "confirmed no session" and
    //   released profileLoading, showing the login screen. Then SIGNED_IN fired and
    //   re-loaded — but if getSession() had already set loadedRef, the SIGNED_IN
    //   guard blocked the load and targets stayed 0 → onboarding showed on every restart.
    //
    // Fix: await getSession() in initAuth() before making any routing decision.
    //   INITIAL_SESSION is ignored in onAuthStateChange (handled by initAuth).
    //   Only SIGNED_IN and SIGNED_OUT trigger state changes after initial load.
    let mounted = true;

    const initAuth = async () => {
      dbgTrace("initAuth START");
      try {
        const { data: { session } } = await supabase.auth.getSession();
        if (!mounted) return;
        dbgTrace(() => "initAuth gotSession: " + (session ? session.user.id.slice(0,8) : "null"));
        setAuthReady(true);
        if (session) {
          setSession(session);
          // loadedRef guard: only load once per user ID
          if (!loadedRef.current || loadedRef.current !== session.user.id) {
            loadedRef.current = session.user.id;
            dbgTrace("initAuth → loadProfileAndLogs START");
            await loadProfileAndLogs(session.user.id);
            dbgTrace("initAuth → loadProfileAndLogs DONE");
          } else {
            dbgTrace("initAuth SKIPPED loadProfile (already loaded)");
          }
        } else {
          // Confirmed no session — release gate and show auth screen
          setSession(null);
          setProfileLoading(false);
        }
      } catch(e) {
        if (!mounted) return;
        Sentry.captureException(e, { extra: { context: "initAuth" } }); if (process.env.NODE_ENV !== "production") { console.error("[initAuth]", e); }
        // getSession failed — fall through to auth screen
        setAuthReady(true);
        setSession(null);
        setProfileLoading(false);
      }
      // V26 FIX 6: SplashScreen.hide() moved to end of loadProfileAndLogs to avoid white flash
    };

    initAuth();

    const {data:{subscription}} = supabase.auth.onAuthStateChange((event, session)=>{
      if (!mounted) return;

      if (event === "PASSWORD_RECOVERY") {
        setSession(session);
        setAuthReady(true);
        setIsPasswordReset(true);
        return;
      }

      // INITIAL_SESSION is handled by initAuth() above — ignore here to prevent
      // routing decisions before getSession() has confirmed the true session state.
      if (event === "INITIAL_SESSION") return;

      if (event === "SIGNED_IN") {
        setSession(session);
        setAuthReady(true);
        if (session) {
          // V26 FIX: Allow re-load if previous load got zero targets (RLS race condition)
          const needsLoad = !loadedRef.current || loadedRef.current !== session.user.id;
          if (needsLoad) {
            loadedRef.current = session.user.id;
            dbgTrace("SIGNED_IN → loadProfileAndLogs");
            loadProfileAndLogs(session.user.id);
          }
        }
      }

      dbgTrace(() => "onAuthStateChange: " + event);
      if (event === "SIGNED_OUT") {
        dbgTrace("SIGNED_OUT → targets=0");
        loadedRef.current = null;
        setSession(null);
        setAuthReady(true);
        setProfileLoading(false);
        setProfileLoaded(false); // V103: reset so next login re-evaluates onboarding
        // Reset core state so a subsequent login starts clean
        setTargets({calories:0,protein:0,carbs:0,fat:0,fibre:30,sugar:30,sodium:2300,bmr:0,tdeeRaw:0});
        setLogs([]);
        setDayHistory([]);
        setScreen("settings");
      }
    });

    return ()=>{ mounted = false; subscription.unsubscribe(); };
  },[]); // eslint-disable-line react-hooks/exhaustive-deps

  // ─── ONLINE/OFFLINE DETECTION ───────────────────────────────────────────
  useEffect(() => {
    const goOnline  = () => { setIsOnline(true); processQueue(supabase); };
    const goOffline = () => setIsOnline(false);
    window.addEventListener("online",  goOnline);
    window.addEventListener("offline", goOffline);
    return () => {
      window.removeEventListener("online",  goOnline);
      window.removeEventListener("offline", goOffline);
    };
  }, []);

  // ─── OFFLINE QUEUE DROP NOTIFICATION ─────────────────────────────────────
  useEffect(() => {
    const onDrop = () => showToast("Some data couldn't be saved and was discarded. Check your connection.");
    window.addEventListener("offlineQueueItemDropped", onDrop);
    return () => window.removeEventListener("offlineQueueItemDropped", onDrop);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // ─── DYNAMIC BRAND SET ────────────────────────────────────────────────────
  // Load known brands once on mount. Any brand added to branded_foods in Supabase
  // is automatically treated as a priority brand in food search — no code changes needed.
  useEffect(() => {
    fetchKnownBrands().then(brands => setKnownBrands(brands));
  }, []);

  // ─── AUTO-AUDIT SCHEDULE ──────────────────────────────────────────────────
  // Checks every 60s if the current HH:MM matches autoAuditTime.
  // Fires runCopilot() once per day (localStorage key np_last_audit_date).
  const runCopilotRef = useRef(runCopilot);
  useEffect(() => { runCopilotRef.current = runCopilot; });

  // BUG 1 FIX: 7-day cooldown after accepting an adaptive TDEE suggestion.
  // Prevents the useEffect from immediately re-firing after the user accepts.
  const adaptiveSuggestionAcceptedRef = useRef(null);
  useEffect(() => {
    try {
      const stored = localStorage.getItem("adaptive_tdee_last_accepted");
      if (stored) adaptiveSuggestionAcceptedRef.current = parseInt(stored, 10);
    } catch(_) {}
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (!autoAuditTime || !hasTargets) return;
    const check = () => {
      const now = new Date();
      const hhmm = `${String(now.getHours()).padStart(2,"0")}:${String(now.getMinutes()).padStart(2,"0")}`;
      if (hhmm !== autoAuditTime) return;
      const today = TODAY_ISO();
      try {
        if (localStorage.getItem("np_last_audit_date") === today) return;
        localStorage.setItem("np_last_audit_date", today);
      } catch(_) {}
      runCopilotRef.current();
    };
    check();
    const t = setInterval(check, 60000);
    return () => clearInterval(t);
  }, [autoAuditTime, hasTargets]); // eslint-disable-line react-hooks/exhaustive-deps

  // ─── HERO SUMMARY TRIGGER ────────────────────────────────────────────────
  // Fires when calorie total changes by >50 kcal. Silent fail — never crashes.
  useEffect(() => {
    const cal = Math.round(totals.calories || 0);
    if (heroSummaryLoading) return;
    if (Math.abs(cal - heroSummaryCalRef.current) < 50 && heroSummaryCalRef.current !== 0) return;
    heroSummaryCalRef.current = cal;
    setHeroSummaryLoading(true);
    runHeroSummary({
      calConsumed:   cal,
      calTarget:     targets.calories,
      calRemaining:  Math.max(0, targets.calories - cal),
      proteinEaten:  Math.round(totals.protein  || 0),
      proteinTarget: targets.protein  || 0,
      carbsEaten:    Math.round(totals.carbs    || 0),
      carbsTarget:   targets.carbs    || 0,
      fatEaten:      Math.round(totals.fat      || 0),
      fatTarget:     targets.fat      || 0,
      fibreEaten:    Math.round(totals.fibre    || 0),
      fibreTarget:   targets.fibre    || 30,
      currentPersona: persona,
    }).then(text => {
      setHeroSummary(text || "");
      setHeroSummaryLoading(false);
    });
  }, [totals.calories]); // eslint-disable-line react-hooks/exhaustive-deps

  // ─── DYNAMIC CALORIE ADJUSTMENT ──────────────────────────────────────────
  // V105: Shows a suggestion card instead of auto-applying. Respects targetWeight
  // direction lock (never suggest eating more if trying to lose, etc.) and
  // enforces a BMR floor so suggestions are always safe.
  useEffect(() => {
    if (!hasTargets || !weightLogs || weightLogs.length < 4) return;
    if (!targets.calories || !targets.tdeeRaw) return;
    // BUG 1 FIX: 7-day cooldown — don't show another suggestion within one week of accepting
    const ONE_WEEK = 7 * 24 * 60 * 60 * 1000;
    const lastAccepted = adaptiveSuggestionAcceptedRef.current;
    if (lastAccepted && Date.now() - lastAccepted < ONE_WEEK) return;
    const sorted = [...weightLogs].sort((a,b) => new Date(a.logged_at)-new Date(b.logged_at));
    const oldest = sorted[0];
    const newest = sorted[sorted.length-1];
    const daySpan = Math.max(1, Math.round(
      (new Date(newest.logged_at)-new Date(oldest.logged_at)) / 86400000
    ));
    if (daySpan < 14) return; // need at least 2 weeks
    const wDelta    = parseFloat(newest.weight_kg) - parseFloat(oldest.weight_kg);
    const weeklyRate = (wDelta / daySpan) * 7;
    const isLose = (goal||"").toLowerCase().includes("lose");
    const isGain = (goal||"").toLowerCase().includes("gain") || (goal||"").toLowerCase().includes("muscle");
    const expectedRate = isLose ? -0.5 : isGain ? 0.25 : 0;
    const drift = weeklyRate - expectedRate;
    if (Math.abs(drift) < 0.3) return; // within tolerance
    const adjustment = drift > 0 ? -100 : 100;
    const originalCal = targets.tdeeRaw
      ? (isLose ? targets.tdeeRaw - 500 : isGain ? targets.tdeeRaw + 250 : targets.tdeeRaw)
      : targets.calories;
    const suggested = Math.round(Math.min(
      originalCal + 300,
      Math.max(originalCal - 300, targets.calories + adjustment)
    ));
    if (suggested === targets.calories) return;
    if (suggested < 1000 || suggested > 6000) return;
    // ── Direction lock using targetWeight ──────────────────────────────────
    const currentW = parseFloat(weight) || 0;
    const tgt = targetWeight !== null ? parseFloat(targetWeight) : null;
    if (tgt !== null && currentW > 0) {
      const isLosingTowardTarget  = currentW > tgt + 1;
      const isGainingTowardTarget = currentW < tgt - 1;
      // Trying to lose — never suggest eating more
      if (isLosingTowardTarget  && suggested > targets.calories) return;
      // Trying to gain — never suggest eating less
      if (isGainingTowardTarget && suggested < targets.calories) return;
    }
    // ── BMR floor — never suggest below BMR ────────────────────────────────
    const h = parseFloat(height) || 175;
    const w = parseFloat(weight) || 75;
    const a = parseInt(age)      || 28;
    const bmrFloor = Math.round(gender === "M"
      ? (10 * w) + (6.25 * h) - (5 * a) + 5
      : (10 * w) + (6.25 * h) - (5 * a) - 161);
    if (suggested < bmrFloor) return;
    // ── Show suggestion card (not auto-apply) ──────────────────────────────
    const tgtLabel = tgt !== null ? `${tgt}kg` : null;
    const newTargets = {...targets, calories: suggested};
    setActiveNudge({
      id: "adaptive_tdee",
      title: "Calorie target suggestion",
      body: tgtLabel
        ? `Based on your recent weight trend, adjusting to ${suggested} kcal/day keeps you on track toward ${tgtLabel}.`
        : `Based on your recent weight trend, your target could be adjusted to ${suggested} kcal/day. Set a target weight in Profile settings for more accurate suggestions.`,
      primaryLabel: `Update to ${suggested} kcal`,
      secondaryLabel: "Keep current",
      onPrimary: () => {
        // BUG 1 FIX: stamp acceptance time so the 7-day guard fires next render
        const now = Date.now();
        adaptiveSuggestionAcceptedRef.current = now;
        try { localStorage.setItem("adaptive_tdee_last_accepted", now.toString()); } catch(_) {}
        setTargets(newTargets);
        saveProfile({targets: newTargets});
        setAdjustToast(`Target updated to ${suggested} kcal based on your weight trend.`);
        setTimeout(() => setAdjustToast(""), 6000);
        setActiveNudge(null);
      },
      onSecondary: () => setActiveNudge(null),
    });
  }, [weightLogs, targets, goal, hasTargets, targetWeight, weight, height, age, gender]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(()=>{
    const h=parseFloat(height),w=parseFloat(weight),a=parseInt(age);
    if(h>0&&w>0&&a>0) setBmrPreview(Math.round((10*w)+(6.25*h)-(5*a)+(gender==="M"?5:-161)));
  },[height,weight,age,gender]);

  // ─── CAMERA: attach stream to <video> after mount ─────────────────────────
  // THE FIX FOR BLACK SCREEN (V32):
  // startCameraScanner acquires the MediaStream and calls setCameraActive(true).
  // The <video> element is conditionally rendered — it only exists in the DOM
  // AFTER React commits that state change. videoRef.current is null for the
  // entire duration of startCameraScanner, so assigning srcObject there silently
  // no-ops and the stream is never attached.
  //
  // This effect runs after every render where cameraActive===true, which means
  // it runs exactly once after the <video> mounts. At that point videoRef.current
  // is guaranteed to be the live DOM element. We assign srcObject here, wire
  // onloadedmetadata, and attempt the speculative play() for autoplay.
  // The "Tap to Start Video" overlay handles the case where play() is blocked.
  useEffect(() => {
    if (!cameraActive) return;          // video element not in DOM — nothing to do
    if (!streamRef.current) return;     // no stream acquired yet (should not happen)
    const videoEl = videoRef.current;
    if (!videoEl) return;               // belt-and-suspenders guard

    videoEl.srcObject = streamRef.current;
    videoEl.onloadedmetadata = () => {
      setVideoReady(true);
      // Speculative play — works on desktop + most Android Chrome.
      // Blocked play() is handled by the "Tap to Start Video" overlay.
      videoEl.play().catch((playErr) => {
      });
    };
  }, [cameraActive]); // eslint-disable-line react-hooks/exhaustive-deps

  // ─── CAMERA: stop stream on app backgrounding ──────────────────────────────
  useEffect(() => {
    const handleVisibility = () => { if (document.hidden) stopCamera(); };
    const handlePageHide = () => stopCamera();
    document.addEventListener("visibilitychange", handleVisibility);
    window.addEventListener("pagehide", handlePageHide);
    return () => {
      document.removeEventListener("visibilitychange", handleVisibility);
      window.removeEventListener("pagehide", handlePageHide);
    };
  }, []);

  // V25 FIX 4: keep screenRef in sync — separate from back-button listener
  useEffect(() => {
    // V28: Push to history stack when screen changes (avoid duplicates at top)
    if (screenHistoryRef.current[screenHistoryRef.current.length - 1] !== screenRef.current && screenRef.current !== screen) {
      screenHistoryRef.current.push(screenRef.current);
      if (screenHistoryRef.current.length > 20) screenHistoryRef.current.shift(); // cap stack
    }
    screenRef.current = screen;
  }, [screen]);

  // V28: Track topmost open modal for back button
  useEffect(() => {
    if (activeNudge) { modalCloseRef.current = () => setActiveNudge(null); return; }
    if (nlpModal) { modalCloseRef.current = () => setNlpModal(null); return; }
    if (showPaywall) { modalCloseRef.current = () => setShowPaywall(false); return; }
    if (copyModal) { modalCloseRef.current = () => setCopyModal(null); return; }
    if (editItem) { modalCloseRef.current = () => setEditItem(null); return; }
    if (showDeleteModal) { modalCloseRef.current = () => setShowDeleteModal(false); return; }
    if (showSuppAdd) { modalCloseRef.current = () => setShowSuppAdd(false); return; }
    if (showRecipeBuilder) { modalCloseRef.current = () => setShowRecipeBuilder(false); return; }
    if (recipeLogModal) { modalCloseRef.current = () => setRecipeLogModal(null); return; }
    if (showCameraRationale) { modalCloseRef.current = () => setShowCameraRationale(false); return; }
    if (showCustomWater) { modalCloseRef.current = () => setShowCustomWater(false); return; }
    if (showBodyMeas) { modalCloseRef.current = () => setShowBodyMeas(false); return; }
    if (showMacroFilter) { modalCloseRef.current = () => setShowMacroFilter(false); return; }
    if (showProgressFilter) { modalCloseRef.current = () => setShowProgressFilter(false); return; }
    modalCloseRef.current = null; // no modal open
  }, [activeNudge, nlpModal, showPaywall, copyModal, editItem, showDeleteModal, showSuppAdd, showRecipeBuilder, recipeLogModal, showCameraRationale, showCustomWater, showBodyMeas, showMacroFilter, showProgressFilter]);

  // ─── ANDROID BACK BUTTON ────────────────────────────────────────────────────
  // V25 FIX 4: single listener registration (no screen dep) — reads screenRef to avoid
  // race condition where multiple listeners fire on rapid navigation.
  useEffect(() => {
    const isNative = typeof window !== "undefined" &&
      (window.location.protocol === "capacitor:" || !!(window.Capacitor?.isNativePlatform?.()));
    if (!isNative) return;
    let cleanup = () => {};
    (async () => {
      try {
        const { App: CapApp } = await import(/* webpackIgnore: true */ "@capacitor/app");
        const handle = await CapApp.addListener("backButton", () => {
          // V28: Priority 1 — Close topmost modal
          if (modalCloseRef.current) { modalCloseRef.current(); return; }
          // Priority 2 — Navigate back through screen history
          if (screenHistoryRef.current.length > 0) {
            const prev = screenHistoryRef.current.pop();
            setScreen(prev);
            return;
          }
          // Priority 3 — At root, minimize app
          if (screenRef.current === "dashboard") {
            CapApp.minimizeApp();
          } else {
            setScreen("dashboard");
          }
        });
        cleanup = () => handle.remove();
      } catch (_) { /* not available in web build */ }
    })();
    return () => cleanup();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // ─── NUDGE: fire once after profile fully loads ────────────────────────────
  // profileLoaded flips true at the end of loadProfileAndLogs.
  // checkNudges is a function declaration lower in the file — hoisted to scope.
  useEffect(() => {
    if (profileLoaded && hasTargets && session) {
      checkNudges();
    }
  }, [profileLoaded]); // eslint-disable-line react-hooks/exhaustive-deps

  // ─── FETCH TODAY'S WORKOUTS ─────────────────────────────────────────────────
  // Reads workout_sessions for today from the shared Supabase project.
  // Called alongside loadProfileAndLogs so the credit appears on first render.
  async function fetchTodayWorkouts(uid) {
    try {
      const { data } = await supabase
        .from("workout_sessions")
        .select("id,name,duration,calories_burned,date")
        .eq("user_id", uid)
        .eq("date", TODAY_ISO())
        .order("date", { ascending: false });
      setTodayWorkouts(data || []);
      // V27 FIX 8: Check for new workouts and trigger post-workout advisor
      if (data && data.length > 0) {
        const latest = data[0];
        runPostWorkoutAdvisor(latest);
      }
    } catch(e) {
      if (process.env.NODE_ENV !== "production") { console.warn("[fetchTodayWorkouts]", e.message); }
    }
  }

  // ─── SUPABASE: LOAD ────────────────────────────────────────────────────────
  const PROFILE_COLS = "id,height,weight,age,gender,goal,persona,country,physique_goal,wake_time,bed_time,auto_audit_time,water_date,water_ml,targets,day_history,last_audit,target_weight,goal_mode,simple_goal,is_premium";

  async function loadProfileAndLogs(uid) {
    setSyncing(true); setSyncErr(false); setProfileLoading(true);
    // Hoisted so routing code after try/catch can read it without relying on
    // a setTargets functional-update prev (which could be stale in edge cases).
    let loadedCalories = 0;

    // ── BLOCK A: Profile data ─────────────────────────────────────────────────
    // Routing-critical. A failure here triggers a fallback fetch for calories
    // so we can still route to dashboard rather than accidentally showing onboarding.
    try {
      let profile = null, pErr = null;

      // First attempt
      const res1 = await supabase.from("profiles").select(PROFILE_COLS).eq("id", uid).single();
      profile = res1.data;
      pErr = res1.error;
      dbgTrace(() => "fetch1 profile=" + (profile ? "YES cal=" + (profile.targets?.calories ?? "?") : "NULL") + " err=" + (pErr?.code || "none"));

      // V26 CRITICAL FIX: If profile is null but we have a valid uid, RLS may not
      // have the JWT yet on cold open. Retry once after 1.2s delay.
      const isNoRow1 = pErr && (pErr.code === "PGRST116" || pErr.status === 406);
      if ((!profile || isNoRow1) && uid) {
        dbgTrace("retry after 1200ms delay...");
        await new Promise(r => setTimeout(r, 1200));
        const res2 = await supabase.from("profiles").select(PROFILE_COLS).eq("id", uid).single();
        if (res2.data) {
          profile = res2.data;
          pErr = res2.error;
          dbgTrace(() => "retry profile=" + (profile ? "YES cal=" + (profile.targets?.calories ?? "?") : "NULL"));
        } else {
          dbgTrace(() => "retry still NULL err=" + (res2.error?.code || "none"));
        }
      }

      const isNoRow = pErr && (pErr.code === "PGRST116" || pErr.status === 406);
      if (pErr && !isNoRow) throw pErr;
      if (!profile && !isNoRow) {
        Sentry.captureMessage("[loadProfileAndLogs] RLS returned empty for valid session", { extra: { uid } });
        if (process.env.NODE_ENV !== "production") { console.error("[loadProfileAndLogs] RLS returned empty for valid session:", uid); }
        showToast("Could not load your profile. Please sign out and back in.");
      }
      if (profile) {
        setHeight(profile.height||"175"); setWeight(profile.weight||"75");
        setAge(profile.age||"28");        setGender(profile.gender||"M");
        setGoal(profile.goal||"");
        setPersona(profile.persona||"Balanced");
        setCountry(profile.country||"uk");
        setPhysiqueGoal(profile.physique_goal||"");
        if (profile.goal_mode)   setGoalMode(profile.goal_mode);
        if (profile.simple_goal) setSimpleGoal(profile.simple_goal);
        setWakeTime(profile.wake_time||"07:00");
        setBedTime(profile.bed_time||"23:00");
        setAutoAuditTime(profile.auto_audit_time||"");
        setTargetWeight(profile.target_weight || null);
        setIsPremium(!!profile.is_premium); // V24 FIX 8a: default false if column missing
        // V24 FIX 8c: if free user has a premium-only persona, reset to Balanced
        if (PREMIUM_ENABLED && !profile.is_premium && (profile.persona === "Critical" || profile.persona === "Motivational")) {
          setPersona("Balanced");
        }
        // Date-aware water reset: if water_date != today, reset to 0 and persist
        if (profile.water_date === TODAY_ISO()) {
          setWaterMl(profile.water_ml||0);
        } else {
          setWaterMl(0);
          // Reset in background — don't block app load
          (async () => {
            try {
              await supabase.from("profiles").upsert(
                { id: uid, water_ml: 0, water_date: TODAY_ISO(), updated_at: new Date().toISOString() },
                { onConflict: "id" }
              );
            } catch(e) { Sentry.captureException(e, { extra: { context: "waterReset" } }); if (process.env.NODE_ENV !== "production") { console.error("[waterReset]", e); } }
          })();
        }
        // V26 HOTFIX: Parse targets robustly — handle string, object, null
        let rawTargets = profile.targets;
        dbgTrace(() => "profile.targets raw cal=" + (rawTargets?.calories ?? "null") + " type=" + typeof rawTargets);
        if (typeof rawTargets === "string") {
          try { rawTargets = JSON.parse(rawTargets); } catch(_) { rawTargets = null; }
        }
        const profileTargets = (rawTargets && typeof rawTargets === "object" && rawTargets.calories > 0)
          ? rawTargets
          : {calories:0,protein:0,carbs:0,fat:0,fibre:30,sugar:30,sodium:2300,bmr:0,tdeeRaw:0};
        dbgTrace(() => "setTargets cal=" + profileTargets.calories + " p=" + profileTargets.protein);
        setTargets(profileTargets);
        loadedCalories = profileTargets.calories || 0;
        setDayHistory(profile.day_history||[]);
        setCpResp(profile.last_audit||"");
        // V40: hydrate 5-field audit display vars from stored last_audit
        if (profile.last_audit) {
          const stored = parseCpResp(profile.last_audit);
          if (stored) {
            setCpHeadline(stored.headline || "");
            setCpMetabolic(stored.right_now || stored.metabolic_review || "");
            setCpTactical(stored.recovery || stored.tactical_recovery || "");
            setCpOutlook(stored.outlook || "");
            setCpAction(stored.action || "");
          }
        }
        // screen routed atomically below with profileLoading release
      } else { dbgTrace("NO profile row — new user"); }
    } catch(e) {
      dbgTrace(() => "CATCH profile fetch: " + e.message);
      Sentry.captureException(e, { extra: { context: "loadProfileAndLogs:profileFetch" } }); if (process.env.NODE_ENV !== "production") { console.error("[loadProfileAndLogs] profile fetch:", e); }
      setSyncErr(true);
      // Fallback: if the full profile fetch failed but the user has targets stored,
      // do a minimal select so we can still route to dashboard not onboarding.
      // targets is a JSONB column — select it directly and read .calories.
      if (loadedCalories === 0) {
        try {
          const { data: fallback } = await supabase
            .from("profiles").select("targets").eq("id", uid).single();
          if (fallback?.targets?.calories > 0) {
            loadedCalories = fallback.targets.calories;
          }
        } catch(_) { /* silent — we tried, routing will fall back to settings */ }
      }
    }

    // ── BLOCK B: Secondary data ───────────────────────────────────────────────
    // Non-fatal: a failure here does NOT affect routing — user still goes to
    // dashboard if loadedCalories > 0. Today's logs just won't show this session.
    try {
      // Today's food logs
      if (process.env.NODE_ENV !== "production") {
        console.log("[logs fetch] user_id:", uid);
        console.log("[logs fetch] query date:", TODAY_ISO());
      }
      const {data:logRows, error:lErr} = await supabase
        .from("logs").select("id,user_id,name,calories,protein,carbs,fat,fibre,sugar,sodium,meal_type,source,log_date,logged_at,source_food_id,source_table,logged_grams")
        .eq("user_id", uid).eq("log_date", TODAY_ISO())
        .order("logged_at", {ascending:false});
      if (lErr) throw lErr;
      if (process.env.NODE_ENV !== "production") {
        console.log("[logs fetch] rows returned:", logRows?.length ?? 0);
        console.log("[logs fetch] first row sample:", logRows?.[0] ?? null);
      }
      setLogs(logRows||[]);
      // Saved meals (favourites)
      const {data:favRows} = await supabase
        .from("saved_meals").select("id,user_id,name,calories,protein,carbs,fat,fibre,sugar,sodium,created_at")
        .eq("user_id", uid).order("created_at", {ascending:false});
      setSavedMeals(favRows||[]);
      // Weight log — last 14 entries
      // V101 fix: query with logged_at (original schema) — created_at may not exist
      const {data:wRows} = await supabase
        .from("weight_logs").select("id,user_id,weight_kg,note,logged_at")
        .eq("user_id", uid).order("logged_at", {ascending:false}).limit(14);
      setWeightLogs(wRows||[]);
      // Body measurements — last 30 entries
      const {data:bmRows} = await supabase
        .from("body_measurements").select("id,user_id,date,weight_kg,body_fat_pct,chest_cm,waist_cm,hips_cm,arms_cm,thighs_cm,neck_cm,shoulders_cm,notes,logged_at")
        .eq("user_id", uid).order("logged_at", {ascending:false}).limit(30);
      setBodyMeasurements(bmRows||[]);
    } catch(e) {
      Sentry.captureException(e, { extra: { context: "secondaryFetch" } }); if (process.env.NODE_ENV !== "production") { console.error("[secondary fetch]", e); }
      // Non-fatal — routing unaffected, dashboard still loads
    }
    if (uid) {
      fetchThirtyDayLogs(uid).then(hist => setLogHistory(hist)).catch(e => { if (process.env.NODE_ENV !== "production") { console.warn("[fetchThirtyDayLogs]", e); } });
      // V42: Auto-load intelByDay on app start so Charts tab has data immediately
      fetchSevenDayLogs(uid).then(({ byDay }) => setIntelByDay(byDay)).catch(e => { if (process.env.NODE_ENV !== "production") { console.warn("[fetchSevenDayLogs auto]", e); } });
      fetchTodayWorkouts(uid);
      loadSupplements(uid);
    }
    setSyncing(false);
    // Route using loadedCalories — set from profile.targets inside the try block.
    // Avoids calling side effects inside a setTargets functional updater (which
    // React may call multiple times in Strict/concurrent mode).
    const hasT = loadedCalories > 0;
    if (hasT) {
      // Auto-dismiss launch screen for returning users with targets —
      // they've already chosen NutriLithe, don't show app selection again
      setShowLaunch(false);
      try { localStorage.setItem("lithe_app", "nutri"); } catch(_) {}
    }
    setScreen(hasT ? "dashboard" : "settings");
    setProfileLoading(false);
    setProfileLoaded(true); // V103: mark load complete — unlocks onboarding condition
    // Firebase Analytics: identify user + record session start (production only)
    if (process.env.NODE_ENV === 'production') {
      setAnalyticsUserId(uid);
      firebaseLogEvent('app_open');
    }
    checkAchievements();
    // V26 FIX 6: hide splash after profile is fully loaded to avoid white flash
    try {
      const { SplashScreen } = await import(/* webpackIgnore: true */ "@capacitor/splash-screen");
      SplashScreen.hide();
    } catch(_) { /* not available in web build */ }
  }

  // ─── V26 HOTFIX 7: Load logs for a specific date ──────────────────────────
  async function loadDateLogs(dateStr) {
    if (!session) return;
    setSyncing(true);
    try {
      const { data: logRows } = await supabase
        .from("logs").select("id,user_id,name,calories,protein,carbs,fat,fibre,sugar,sodium,meal_type,source,log_date,logged_at,source_food_id,source_table,logged_grams")
        .eq("user_id", session.user.id).eq("log_date", dateStr)
        .order("logged_at", { ascending: false });
      setLogs(logRows || []);
      // Load water for that date
      if (dateStr === TODAY_ISO()) {
        // For today, reload water from profile to restore correct value
        try {
          const { data: prof } = await supabase
            .from("profiles").select("water_ml,water_date")
            .eq("id", session.user.id).single();
          if (prof && prof.water_date === TODAY_ISO()) {
            setWaterMl(prof.water_ml || 0);
          } else {
            setWaterMl(0);
          }
        } catch(_) { /* keep existing waterMl */ }
      } else {
        try {
          const { data: wRow } = await supabase
            .from("water_logs").select("water_ml")
            .eq("user_id", session.user.id).eq("log_date", dateStr).single();
          setWaterMl(wRow?.water_ml || 0);
        } catch(_) { setWaterMl(0); }
      }
    } catch(e) {
      Sentry.captureException(e, { extra: { context: "loadDateLogs" } }); if (process.env.NODE_ENV !== "production") console.error("[loadDateLogs]", e);
    }
    setSyncing(false);
  }

  function navigateDate(direction) {
    const d = new Date(viewingDate);
    d.setDate(d.getDate() + direction);
    const newDate = d.toISOString().split("T")[0];
    // Don't go into the future
    if (newDate > TODAY_ISO()) return;
    // Guard: if somehow invalid, reset to today
    if (!/^\d{4}-\d{2}-\d{2}$/.test(newDate)) { setViewingDate(TODAY_ISO()); return; }
    setViewingDate(newDate);
    loadDateLogs(newDate);
  }

  function returnToToday() {
    setViewingDate(TODAY_ISO());
    if (session) loadDateLogs(TODAY_ISO());
  }

  // ─── V26 FIX 17: Food search history ──────────────────────────────────────
  async function fetchSearchHistory() {
    if (!session) return;
    try {
      const { data } = await supabase
        .from("food_search_history")
        .select("id,query,searched_at")
        .eq("user_id", session.user.id)
        .order("searched_at", { ascending: false })
        .limit(10);
      setSearchHistory(data || []);
    } catch(_) {}
  }

  async function saveSearchQuery(query) {
    if (!session || !query || query.length <= 2) return;
    try {
      await supabase.from("food_search_history").insert(
        { user_id: session.user.id, query, searched_at: new Date().toISOString() }
      );
      // Cleanup: keep max 20
      const { data: all } = await supabase
        .from("food_search_history")
        .select("id")
        .eq("user_id", session.user.id)
        .order("searched_at", { ascending: false });
      if (all && all.length > 20) {
        const toDelete = all.slice(20).map(r => r.id);
        await supabase.from("food_search_history").delete().in("id", toDelete);
      }
    } catch(_) {}
  }

  // ─── V26 FIX 18: Barcode scan history ─────────────────────────────────────
  async function fetchBarcodeHistory() {
    if (!session) return;
    try {
      const { data } = await supabase
        .from("barcode_scan_history")
        .select("id,barcode,product_name,calories,protein,carbs,fat,scanned_at")
        .eq("user_id", session.user.id)
        .order("scanned_at", { ascending: false })
        .limit(5);
      setBarcodeHistory(data || []);
    } catch(_) {}
  }

  async function saveBarcodeHistory(barcode, product) {
    if (!session || !barcode) return;
    try {
      await supabase.from("barcode_scan_history").upsert(
        { user_id: session.user.id, barcode, product_name: product.name,
          calories: product.calories, protein: product.protein,
          carbs: product.carbs, fat: product.fat,
          scanned_at: new Date().toISOString() },
        { onConflict: "user_id,barcode" }
      );
    } catch(_) {}
  }

  // ─── V26 FIX 24: Achievement definitions ──────────────────────────────────
  const ACHIEVEMENTS = [
    { id: "first_log", name: "First Log", desc: "Log your first food", icon: "🍽️" },
    { id: "logs_10", name: "10 Foods", desc: "Log 10 food items", icon: "📝" },
    { id: "logs_50", name: "50 Foods", desc: "Log 50 food items", icon: "📋" },
    { id: "logs_100", name: "Century", desc: "Log 100 food items", icon: "💯" },
    { id: "logs_250", name: "Dedicated Logger", desc: "Log 250 food items", icon: "🏅" },
    { id: "protein_7d", name: "Protein Streak", desc: "Hit protein target 7 days straight", icon: "💪" },
    { id: "streak_7d", name: "Week Warrior", desc: "Log every day for 7 days", icon: "🔥" },
    { id: "streak_30d", name: "Monthly Monarch", desc: "Log every day for 30 days", icon: "👑" },
    { id: "all_macros", name: "Perfect Day", desc: "Hit all macro targets in a single day", icon: "⭐" },
    { id: "first_workout", name: "First Workout", desc: "Complete your first workout", icon: "🏋️" },
    { id: "workouts_10", name: "10 Workouts", desc: "Complete 10 workouts", icon: "💪" },
    { id: "workouts_50", name: "50 Workouts", desc: "Complete 50 workouts", icon: "🔨" },
    { id: "workouts_100", name: "Iron Century", desc: "Complete 100 workouts", icon: "🏆" },
    { id: "first_pr", name: "First PR", desc: "Set your first personal record", icon: "🥇" },
  ];

  function checkAchievements(context = {}) {
    if (!session) return;
    const uid = session.user.id;
    // Fire and forget — non-blocking
    (async () => {
      try {
        const { data: existing } = await supabase
          .from("achievements")
          .select("achievement_id")
          .eq("user_id", uid);
        const earned = new Set((existing||[]).map(a => a.achievement_id));
        const newlyUnlocked = [];

        // Log count achievements
        const totalLogs = context.totalLogs || logs.length;
        if (totalLogs >= 1 && !earned.has("first_log")) newlyUnlocked.push("first_log");
        if (totalLogs >= 10 && !earned.has("logs_10")) newlyUnlocked.push("logs_10");
        if (totalLogs >= 50 && !earned.has("logs_50")) newlyUnlocked.push("logs_50");
        if (totalLogs >= 100 && !earned.has("logs_100")) newlyUnlocked.push("logs_100");
        if (totalLogs >= 250 && !earned.has("logs_250")) newlyUnlocked.push("logs_250");

        // Streak achievements from logHistory (total days logged, consistent with streak_7d/30d pattern)
        const streakDays = (logHistory||[]).filter(d => d.logged).length;
        if (streakDays >= 7 && !earned.has("streak_7d")) newlyUnlocked.push("streak_7d");
        if (streakDays >= 30 && !earned.has("streak_30d")) newlyUnlocked.push("streak_30d");

        // protein_7d — count logged days where protein met or exceeded target
        const proteinTarget = targets.protein || 0;
        if (proteinTarget > 0 && !earned.has("protein_7d")) {
          const proteinHitDays = (logHistory||[]).filter(d => d.logged && d.protein >= proteinTarget).length;
          if (proteinHitDays >= 7) newlyUnlocked.push("protein_7d");
        }

        // all_macros — all four macros met or exceeded today (passed via context after log insert)
        if (!earned.has("all_macros") && targets.calories > 0) {
          const td = context.todayTotals || totals;
          if (
            td.calories >= targets.calories &&
            td.protein  >= (targets.protein || 0) &&
            td.carbs    >= (targets.carbs   || 0) &&
            td.fat      >= (targets.fat     || 0)
          ) newlyUnlocked.push("all_macros");
        }

        // Workout milestones — query lifetime count from workout_sessions
        let workoutCount = context.workoutCount;
        if (workoutCount === undefined) {
          const { count } = await supabase
            .from("workout_sessions")
            .select("id", { count: "exact", head: true })
            .eq("user_id", uid);
          workoutCount = count || 0;
        }
        if (workoutCount >= 1   && !earned.has("first_workout"))  newlyUnlocked.push("first_workout");
        if (workoutCount >= 10  && !earned.has("workouts_10"))    newlyUnlocked.push("workouts_10");
        if (workoutCount >= 50  && !earned.has("workouts_50"))    newlyUnlocked.push("workouts_50");
        if (workoutCount >= 100 && !earned.has("workouts_100"))   newlyUnlocked.push("workouts_100");

        // first_pr — passed via context.newPR from WorkoutApp after a session with a new record
        if (context.newPR && !earned.has("first_pr")) newlyUnlocked.push("first_pr");

        // Insert new achievements
        for (const achId of newlyUnlocked) {
          await supabase.from("achievements").insert({ user_id: uid, achievement_id: achId });
          const def = ACHIEVEMENTS.find(a => a.id === achId);
          if (def) {
            setAchievementToast({ name: def.name, desc: def.desc, icon: def.icon });
            setTimeout(() => setAchievementToast(null), 4000);
          }
        }

        // Refresh unlocked list
        const { data: updated } = await supabase
          .from("achievements")
          .select("achievement_id,unlocked_at")
          .eq("user_id", uid);
        setUnlockedAchievements(updated || []);
      } catch(_) {}
    })();
  }

  // V159 FIX 5: re-evaluate achievements once logHistory is populated (after Block B)
  // The call at line 1423 runs before Block B loads data; this fires once when it arrives.
  useEffect(() => {
    if (!profileLoaded || achieveInitRef.current) return;
    if ((logHistory||[]).length > 0) {
      achieveInitRef.current = true;
      checkAchievements();
    }
  }, [profileLoaded, logHistory]); // eslint-disable-line react-hooks/exhaustive-deps

  // ─── SUPABASE: SAVE PROFILE ────────────────────────────────────────────────
  const saveProfile = useCallback(async (overrides={}) => {
    if (!session) return;
    setSyncing(true); setSyncErr(false);
    // V26 CRITICAL FIX: If overrides doesn't explicitly include targets, do NOT
    // include targets in the upsert payload at all. This prevents stale closures
    // or zero-state targets from being written to Supabase when saveProfile is
    // called for non-target changes (persona, settings, etc.).
    const payload = {
      id:         session.user.id,
      username:   overrides.username ?? session.user.email,
      height:     overrides.height     ?? height,
      weight:     overrides.weight     ?? weight,
      age:        overrides.age        ?? age,
      gender:     overrides.gender     ?? gender,
      goal:       overrides.goal       ?? goal,
      persona:    overrides.persona    ?? persona,
      country:    overrides.country    ?? country,
      goal_mode:   overrides.goalMode   ?? goalMode,
      simple_goal: overrides.simpleGoal ?? simpleGoal,
      physique_goal: overrides.physiqueGoal ?? physiqueGoal,
      wake_time:       overrides.wakeTime      ?? wakeTime,
      bed_time:        overrides.bedTime       ?? bedTime,
      auto_audit_time: overrides.autoAuditTime ?? autoAuditTime,
      day_history:   overrides.dayHistory ?? dayHistory,
      target_weight: overrides.targetWeight !== undefined ? overrides.targetWeight : targetWeight,
      updated_at: new Date().toISOString(),
    };
    // Only include targets in payload if explicitly passed in overrides
    // This is the critical fix: prevents zero targets from being written to Supabase
    // when saveProfile is called for unrelated changes (persona, settings, etc.)
    if (overrides.targets !== undefined) {
      payload.targets = overrides.targets;
    } else if (targets.calories > 0) {
      // Only write current targets if they are non-zero (genuine data)
      payload.targets = targets;
    }
    // If targets.calories === 0 and no override, omit targets entirely from the upsert
    if (process.env.NODE_ENV !== "production") { console.log("[TARGETS DEBUG] saveProfile writing targets.calories:", payload.targets?.calories ?? "OMITTED"); }
    const {error} = await supabase.from("profiles").upsert(payload, {onConflict:"id"});
    if(error){ Sentry.captureException(error, { extra: { context: "saveProfile" } }); if (process.env.NODE_ENV !== "production") { console.error("[saveProfile]",error); } setSyncErr(true); }
    setSyncing(false);
  },[session,height,weight,age,gender,goal,persona,country,physiqueGoal,goalMode,simpleGoal,wakeTime,bedTime,autoAuditTime,targets,dayHistory,targetWeight]);

  // ─── SUPABASE: LOGS ────────────────────────────────────────────────────────
  async function insertLog(item) {
    if (!session) return;
    if (insertingRef.current) return;   // duplicate-tap guard
    insertingRef.current = true;
    try {
    const row = {
      user_id:   session.user.id,
      name:      item.name,
      calories:  item.calories,
      protein:   item.protein,
      carbs:     item.carbs,
      fat:       item.fat,
      fibre:     item.fibre  || 0,
      sugar:     item.sugar  || 0,
      sodium:    item.sodium || 0,
      meal_type: mealType,
      source:    item.source||null,
      source_food_id: item.source_food_id || null,
      source_table:   item.source_table   || null,
      logged_grams:   item.logged_grams   || null,
      log_date:  viewingDate || TODAY_ISO(),
      logged_at: new Date().toISOString(),
    };
    // ── Offline queue (Part 2) ──────────────────────────────────────────────
    if(!navigator.onLine){
      enqueue("logs","insert",row,session.user.id);
      const tempRow={...row,id:"pending_"+Date.now()};
      setLogs(prev=>{
        const next=[tempRow,...prev];
        const snap=next.reduce((a,l)=>({
          calories:a.calories+(parseFloat(l.calories)||0),
          protein:a.protein+(parseFloat(l.protein)||0),
          carbs:a.carbs+(parseFloat(l.carbs)||0),
          fat:a.fat+(parseFloat(l.fat)||0),
          fibre:a.fibre+(parseFloat(l.fibre)||0),
        }),{calories:0,protein:0,carbs:0,fat:0,fibre:0});
        snapshotDay(snap);
        return next;
      });
      return tempRow;
    }
    const {data, error} = await supabase.from("logs").insert(row).select().single();
    if(error){ Sentry.captureException(error, { extra: { context: "insertLog" } }); if (process.env.NODE_ENV !== "production") { console.error("[insertLog]",error); } setSyncErr(true); showToast("Failed to save food log. Please try again."); return null; }
    setLogs(prev=>{
      const next = [data,...prev];
      // Compute fresh totals from the new log list for snapshot
      const snap = next.reduce((a,l)=>({
        calories: a.calories + (parseFloat(l.calories)||0),
        protein:  a.protein  + (parseFloat(l.protein) ||0),
        carbs:    a.carbs    + (parseFloat(l.carbs)   ||0),
        fat:      a.fat      + (parseFloat(l.fat)     ||0),
        fibre:    a.fibre    + (parseFloat(l.fibre)   ||0),
      }), {calories:0,protein:0,carbs:0,fat:0,fibre:0});
      snapshotDay(snap);
      return next;
    });
    // V26 FIX 7: AI onboarding nudge after first food log
    if (logs.length === 0) {
      const nudgeKey = `onboarding_audit_nudge_shown_${session.user.id}`;
      try {
        if (!localStorage.getItem(nudgeKey)) {
          localStorage.setItem(nudgeKey, "1");
          setTimeout(() => {
            setActiveNudge({
              id: "onboarding_audit",
              title: "First meal logged!",
              body: "Your AI coach can now analyse your day. Run your first free audit.",
              primaryLabel: "Run Audit",
              onPrimary: () => { setActiveNudge(null); setScreen("intelligence"); },
              secondaryLabel: "Maybe later",
              onSecondary: () => setActiveNudge(null),
            });
          }, 1500);
        }
      } catch(_) {}
    }
    // V28: Track first log date for hint expiry
    try {
      if (!localStorage.getItem(`first_log_date_${session.user.id}`)) {
        localStorage.setItem(`first_log_date_${session.user.id}`, new Date().toISOString());
      }
    } catch(_) {}
    // V123: Check achievements after log insert; compute new totals so all_macros check is accurate
    const newTotals = [data, ...logs].reduce((a, l) => ({
      calories: a.calories + (parseFloat(l.calories)||0),
      protein:  a.protein  + (parseFloat(l.protein) ||0),
      carbs:    a.carbs    + (parseFloat(l.carbs)   ||0),
      fat:      a.fat      + (parseFloat(l.fat)     ||0),
    }), { calories:0, protein:0, carbs:0, fat:0 });
    checkAchievements({ totalLogs: logs.length + 1, todayTotals: newTotals });
    return data;
    } finally { insertingRef.current = false; }
  }

  async function deleteLog(id) {
    setLogs(prev=>{
      const next = prev.filter(l=>l.id!==id);
      const snap = next.reduce((a,l)=>({
        calories: a.calories + (parseFloat(l.calories)||0),
        protein:  a.protein  + (parseFloat(l.protein) ||0),
        carbs:    a.carbs    + (parseFloat(l.carbs)   ||0),
        fat:      a.fat      + (parseFloat(l.fat)     ||0),
        fibre:    a.fibre    + (parseFloat(l.fibre)   ||0),
      }), {calories:0,protein:0,carbs:0,fat:0,fibre:0});
      snapshotDay(snap);
      return next;
    });
    if(!navigator.onLine){ enqueue("logs","delete",{id},session?.user?.id); return; }
    const {error} = await supabase.from("logs").delete().eq("id",id).eq("user_id",session.user.id);
    if(error){ Sentry.captureException(error, { extra: { context: "deleteLog" } }); if (process.env.NODE_ENV !== "production") { console.error("[deleteLog]",error); } setSyncErr(true); showToast("Failed to delete item. Please try again."); }
  }

  // ─── UPDATE MEAL TYPE ─────────────────────────────────────────────────────
  // Lets the user reassign a logged item to a different meal slot.
  // Optimistic update first (instant UI), then Supabase write in background.
  async function updateMealType(id, newType) {
    setLogs(prev => prev.map(l => l.id === id ? {...l, meal_type: newType} : l));
    if(!navigator.onLine){ enqueue("logs","update",{id,meal_type:newType},session?.user?.id); return; }
    try {
      const {error} = await supabase
        .from("logs")
        .update({ meal_type: newType })
        .eq("id", id);
      if (error) {
        Sentry.captureException(error, { extra: { context: "updateMealType" } }); if (process.env.NODE_ENV !== "production") { console.error("[updateMealType]", error); }
        setSyncErr(true);
      }
    } catch(e) {
      Sentry.captureException(e, { extra: { context: "updateMealType" } }); if (process.env.NODE_ENV !== "production") { console.error("[updateMealType]", e); }
      setSyncErr(true);
    }
  }
  // ─── UPDATE LOG ITEM ──────────────────────────────────────────────────────
  // Lets the user correct any field on a logged item.
  // Optimistic update first (instant UI), then Supabase write in background.
  // snapshotDay called after to keep daily totals accurate.
  async function updateLog(id, updates) {
    setLogs(prev => {
      const next = prev.map(l => l.id === id ? {...l, ...updates} : l);
      const snap = next.reduce((a,l) => ({
        calories: a.calories + (parseFloat(l.calories)||0),
        protein:  a.protein  + (parseFloat(l.protein) ||0),
        carbs:    a.carbs    + (parseFloat(l.carbs)   ||0),
        fat:      a.fat      + (parseFloat(l.fat)     ||0),
        fibre:    a.fibre    + (parseFloat(l.fibre)   ||0),
      }), {calories:0,protein:0,carbs:0,fat:0,fibre:0});
      snapshotDay(snap);
      return next;
    });
    try {
      const {error} = await supabase.from("logs").update(updates).eq("id", id);
      if (error) { Sentry.captureException(error, { extra: { context: "updateLog" } }); if (process.env.NODE_ENV !== "production") { console.error("[updateLog]", error); } setSyncErr(true); }
    } catch(e) {
      Sentry.captureException(e, { extra: { context: "updateLog" } }); if (process.env.NODE_ENV !== "production") { console.error("[updateLog]", e); }
      setSyncErr(true);
    }
  }

  // Fetch source food for enhanced edit screen
  async function fetchEditSource(logItem) {
    // Direct lookup by source_food_id
    if (logItem?.source_food_id && logItem?.source_table) {
      try {
        const table = logItem.source_table === 'branded_foods' ? 'branded_foods' : 'foods';
        const cols = table === "branded_foods"
          ? "id,name,brand,calories,protein,carbs,fat,fibre,sugar,sodium,serving_g,serving_label,barcode"
          : "id,name,calories_per_100g,protein_per_100g,carbs_per_100g,fat_per_100g,fibre_per_100g,sugar_per_100g,sodium_per_100g";
        const { data } = await supabase.from(table).select(cols).eq("id", logItem.source_food_id).single();
        if (data) { setEditSourceFood({ ...data, _table: table }); return; }
      } catch(_) {}
    }
    // Fallback: search by name for foods without source_food_id
    try {
      const baseName = (logItem?.name || "").replace(/\s*\(\d+g?\)\s*$/,'').trim();
      if (!baseName || baseName.length < 2) { setEditSourceFood(null); return; }
      const { data: foodsMatch } = await supabase.from('foods').select("id,name,calories_per_100g,protein_per_100g,carbs_per_100g,fat_per_100g,fibre_per_100g,sugar_per_100g,sodium_per_100g")
        .ilike('name', `%${baseName}%`).limit(1);
      if (foodsMatch?.length > 0) {
        setEditSourceFood({ ...foodsMatch[0], _table: 'foods' }); return;
      }
      const { data: brandedMatch } = await supabase.from('branded_foods').select("id,name,brand,calories,protein,carbs,fat,fibre,sugar,sodium,serving_g,serving_label,barcode")
        .ilike('name', `%${baseName}%`).limit(1);
      if (brandedMatch?.length > 0) {
        setEditSourceFood({ ...brandedMatch[0], _table: 'branded_foods' }); return;
      }
    } catch(_) {}
    setEditSourceFood(null);
  }

  // OBS-001: fetch yesterday's log entries for the "Yesterday" tab in the food search overlay
  async function fetchYesterdayLogs() {
    if (!session) return [];
    const d = new Date();
    d.setDate(d.getDate() - 1);
    const yISO = d.toISOString().slice(0, 10);
    try {
      const { data } = await supabase.from("logs")
        .select("id,name,calories,protein,carbs,fat,fibre,sugar,sodium,meal_type,logged_grams,source_food_id,source_table")
        .eq("user_id", session.user.id)
        .eq("log_date", yISO)
        .order("meal_type", { ascending: true })
        .order("logged_at", { ascending: true });
      return data || [];
    } catch (_) { return []; }
  }

  // OBS-001: bulk-insert selected yesterday items to today preserving original meal_type
  async function copyFromYesterday(items) {
    if (!session || !items?.length) return false;
    const todayISO = TODAY_ISO();
    const now = new Date().toISOString();
    const rows = items.map(item => ({
      user_id:        session.user.id,
      name:           item.name,
      calories:       item.calories,
      protein:        item.protein,
      carbs:          item.carbs,
      fat:            item.fat,
      fibre:          item.fibre   || 0,
      sugar:          item.sugar   || 0,
      sodium:         item.sodium  || 0,
      meal_type:      item.meal_type,
      source_food_id: item.source_food_id || null,
      source_table:   item.source_table   || null,
      logged_grams:   item.logged_grams   || null,
      log_date:       todayISO,
      logged_at:      now,
    }));
    const { data, error } = await supabase.from("logs").insert(rows).select();
    if (error) {
      Sentry.captureException(error, { extra: { context: "copyFromYesterday" } });
      return false;
    }
    if (data?.length) {
      setLogs(prev => {
        const next = [...data, ...prev];
        const snap = next.reduce((a, l) => ({
          calories: a.calories + (parseFloat(l.calories) || 0),
          protein:  a.protein  + (parseFloat(l.protein)  || 0),
          carbs:    a.carbs    + (parseFloat(l.carbs)    || 0),
          fat:      a.fat      + (parseFloat(l.fat)      || 0),
          fibre:    a.fibre    + (parseFloat(l.fibre)    || 0),
        }), { calories: 0, protein: 0, carbs: 0, fat: 0, fibre: 0 });
        snapshotDay(snap);
        return next;
      });
    }
    return true;
  }

  async function saveMeal(item) {
    if (!session) return;
    setSavingMeal(true);
    const row = {
      user_id:  session.user.id,
      name:     item.name,
      calories: item.calories,
      protein:  item.protein,
      carbs:    item.carbs,
      fat:      item.fat,
      fibre:    item.fibre  || 0,
      sugar:    item.sugar  || 0,
      sodium:   item.sodium || 0,
      meal_type: mealType || null,
    };
    if(!navigator.onLine){
      enqueue("saved_meals","insert",row,session.user.id);
      setSavedMeals(prev=>[{...row,id:"pending_"+Date.now()},...prev]);
    } else {
      const {data, error} = await supabase.from("saved_meals").insert(row).select().single();
      if (!error && data) setSavedMeals(prev=>[data,...prev]);
    }
    setSavingMeal(false);
  }

  async function deleteSavedMeal(id) {
    setSavedMeals(prev=>prev.filter(m=>m.id!==id));
    if(!navigator.onLine){ enqueue("saved_meals","delete",{id},session?.user?.id); return; }
    try {
      await supabase.from("saved_meals").delete().eq("id",id);
    } catch(e) {
      Sentry.captureException(e, { extra: { context: "deleteSavedMeal" } }); if (process.env.NODE_ENV !== "production") { console.error("[deleteSavedMeal]", e); }
    }
  }

  // ─── RECIPE BUILDER HELPERS ──────────────────────────────────────────────
  async function recipeSearchFoods(q) {
    const safe = sanitiseSearch(q);
    if (safe.length < 2) { setRecipeResults([]); return; }
    setRecipeSearching(true);
    try {
      const { data } = await supabase.from("foods")
        .select("id,name,brand,category,cooking_state,calories_per_100g,protein_per_100g,carbs_per_100g,fat_per_100g,fibre_per_100g,sugar_per_100g,sodium_per_100g,serving_size_g,serving_label")
        .ilike("name", `%${safe}%`).order("name",{ascending:true}).limit(8);
      setRecipeResults(data||[]);
    } catch(_) { setRecipeResults([]); }
    setRecipeSearching(false);
  }
  function recipeAddIngredient(row) {
    const grams = parseFloat(row.serving_size_g)||100;
    const s = grams/100;
    setRecipeIngredients(prev=>[...prev,{
      name: `${row.name}${row.brand?` (${row.brand})`:""}${row.cooking_state&&row.cooking_state!=="n/a"?` — ${row.cooking_state}`:""}`,
      grams,
      calories: Math.round((parseFloat(row.calories_per_100g)||0)*s),
      protein:  Math.round((parseFloat(row.protein_per_100g) ||0)*s*10)/10,
      carbs:    Math.round((parseFloat(row.carbs_per_100g)   ||0)*s*10)/10,
      fat:      Math.round((parseFloat(row.fat_per_100g)     ||0)*s*10)/10,
      fibre:    Math.round((parseFloat(row.fibre_per_100g)   ||0)*s*10)/10,
      sugar:    Math.round((parseFloat(row.sugar_per_100g)   ||0)*s*10)/10,
      sodium:   Math.round((parseFloat(row.sodium_per_100g)  ||0)*s*10)/10,
    }]);
    setRecipeResults([]); setRecipeSearch("");
  }
  function recipeUpdateGrams(idx, val) {
    setRecipeIngredients(prev => prev.map((ing, i) => {
      if (i !== idx) return ing;
      const g = parseFloat(val)||0;
      return {...ing, grams:g};
    }));
  }
  function recipeTotals() {
    return recipeIngredients.reduce((a, ing) => {
      const s = ing.grams / 100;
      return {
        calories: a.calories + Math.round((ing.calories/((ing.grams||100)/100))*s),
        protein:  +(a.protein  + (ing.protein /((ing.grams||100)/100))*s).toFixed(1),
        carbs:    +(a.carbs    + (ing.carbs   /((ing.grams||100)/100))*s).toFixed(1),
        fat:      +(a.fat      + (ing.fat     /((ing.grams||100)/100))*s).toFixed(1),
        fibre:    +(a.fibre    + (ing.fibre   /((ing.grams||100)/100))*s).toFixed(1),
        sugar:    +(a.sugar    + (ing.sugar   /((ing.grams||100)/100))*s).toFixed(1),
        sodium:   +(a.sodium   + (ing.sodium  /((ing.grams||100)/100))*s).toFixed(1),
      };
    }, {calories:0,protein:0,carbs:0,fat:0,fibre:0,sugar:0,sodium:0});
  }
  async function saveRecipe() {
    if (!session || !recipeName.trim() || recipeIngredients.length===0) return;
    setRecipeSaving(true);
    const tot = recipeTotals();
    const row = {
      user_id: session.user.id,
      name: recipeName.trim(),
      calories: tot.calories, protein: tot.protein,
      carbs: tot.carbs, fat: tot.fat,
      fibre: tot.fibre, sugar: tot.sugar, sodium: tot.sodium,
    };
    const {data, error} = await supabase.from("saved_meals").insert(row).select().single();
    if (!error && data) {
      setSavedMeals(prev=>[data,...prev]);
      // Mark as recipe in localStorage
      setRecipeIds(prev => {
        const next = new Set(prev); next.add(data.id);
        try { localStorage.setItem("np_recipe_ids", JSON.stringify([...next])); } catch(_){}
        return next;
      });
      setShowRecipeBuilder(false);
      setRecipeIngredients([]); setRecipeName("");
    }
    setRecipeSaving(false);
  }
  async function logSavedMeal(meal, mt) {
    // Log a saved meal or recipe directly into today's log
    const prevMealType = mealType;
    // Temporarily set meal type for insertLog
    setMealType(mt);
    // Use a small delay to let state settle
    await new Promise(r=>setTimeout(r,0));
    await insertLog({
      name:meal.name, calories:meal.calories, protein:meal.protein,
      carbs:meal.carbs, fat:meal.fat, fibre:meal.fibre||0,
      sugar:meal.sugar||0, sodium:meal.sodium||0,
      source_food_id: null, source_table: 'saved_meals', logged_grams: null,
    });
    setRecipeLogModal(null); setRecipeLogType("");
    setMealType(prevMealType);
  }

  // ─── SUPPLEMENTS ─────────────────────────────────────────────────────────
  async function loadSupplements(uid) {
    try {
      const [stackRes, logRes] = await Promise.all([
        supabase.from("supplement_stacks").select("id,name,dose,timing,notes,affects_macros,active")
          .eq("user_id", uid).eq("active", true).order("timing"),
        supabase.from("supplement_logs").select("id,supplement_id")
          .eq("user_id", uid).eq("log_date", TODAY_ISO()),
      ]);
      setSuppStack(stackRes.data || []);
      const taken = new Set((logRes.data||[]).map(r => r.supplement_id));
      const logMap = {};
      (logRes.data||[]).forEach(r => { logMap[r.supplement_id] = r.id; });
      setSuppTakenToday(taken);
      setSuppLogIds(logMap);
    } catch(e) { if (process.env.NODE_ENV !== "production") { console.warn("[loadSupplements]", e.message); } }
  }

  // ─── NUDGE SYSTEM ─────────────────────────────────────────────────────────
  // Evaluates all 6 nudge conditions on app load (after profileLoaded = true).
  // Shows maximum ONE nudge per app open (highest-priority that triggers).
  // Each nudge uses localStorage to ensure it shows at most once per day/week.
  // Priority: supplements > hydration > daily log > weight > briefing > workout

  const NUDGE_KEYS = {
    hydration: "nudge_hydration_last_shown",
    log:       "nudge_log_last_shown",
    weight:    "nudge_weight_last_shown",
    briefing:  "nudge_briefing_last_shown",
    workout:   "nudge_workout_last_shown",
  };

  async function checkNudges() {
    if (!profileLoaded || !hasTargets || !session) return;
    const now        = new Date();
    const hour       = now.getHours();
    const todayStr   = TODAY_ISO();
    const dayOfWeek  = now.getDay(); // 0 = Sunday

    const shownToday   = (key) => { try { return localStorage.getItem(key) === todayStr; } catch(_) { return false; } };
    const markShownToday = (key) => { try { localStorage.setItem(key, todayStr); } catch(_) {} };
    // Respect per-nudge preference (nudge_pref_{id} in localStorage; default = enabled)
    const nudgePrefEnabled = (id) => { try { const v = localStorage.getItem(`nudge_pref_${id}`); return v === null ? true : v !== "false"; } catch(_) { return true; } };

    let nudge = null;

    // ── Priority 1: Supplement reminder ───────────────────────────────────────
    if (!nudge && nudgePrefEnabled("supplement") && suppStack.length > 0) {
      const TIMING_WINDOWS = {
        "Morning":      [8,  10],
        "Pre-Workout":  [16, 18],
        "Post-Workout": [19, 20],
        "Evening":      [20, 22],
        "Bedtime":      [21, 23],
      };
      for (const [timing, [start, end]] of Object.entries(TIMING_WINDOWS)) {
        if (hour >= start && hour < end) {
          const due = suppStack.filter(s => s.timing === timing && !suppTakenToday.has(s.id));
          if (due.length > 0) {
            const key = `nudge_supplement_${timing.replace(/\s+/g,"_").toLowerCase()}_last_shown`;
            if (!shownToday(key)) {
              nudge = {
                id: "supplement",
                title: `${timing} supplements`,
                body: `Time to take your ${timing.toLowerCase()} supplements: ${due.map(s => s.name).join(", ")}.`,
                primaryLabel: "View supplements",
                secondaryLabel: "Remind me later",
                onPrimary:   () => { markShownToday(key); setActiveNudge(null); setScreen("supplements"); },
                onSecondary: () => { markShownToday(key); setActiveNudge(null); },
              };
              break;
            }
          }
        }
      }
    }

    // ── Priority 2: Hydration (15:00–16:00, below 50% of daily target) ────────
    if (!nudge && nudgePrefEnabled("hydration") && hour >= 15 && hour < 16 && waterMl < hydrationTarget * 0.5) {
      if (!shownToday(NUDGE_KEYS.hydration)) {
        nudge = {
          id: "hydration",
          title: "Behind on hydration",
          body: `You've had ${waterMl}ml of your ${hydrationTarget}ml target. Drink 500ml now to get back on track.`,
          primaryLabel: "Log 500ml",
          secondaryLabel: "Dismiss",
          onPrimary:   () => { markShownToday(NUDGE_KEYS.hydration); setActiveNudge(null); syncWater(500); },
          onSecondary: () => { markShownToday(NUDGE_KEYS.hydration); setActiveNudge(null); },
        };
      }
    }

    // ── Priority 3: Daily log reminder (after 12:00, zero entries today) ──────
    if (!nudge && nudgePrefEnabled("log") && hour >= 12 && logs.length === 0) {
      if (!shownToday(NUDGE_KEYS.log)) {
        nudge = {
          id: "log",
          title: "Haven't logged today yet",
          body: "You haven't logged any food today. Even logging one meal helps the AI give you accurate coaching.",
          primaryLabel: "Log food now",
          secondaryLabel: "Dismiss",
          onPrimary:   () => { markShownToday(NUDGE_KEYS.log); setActiveNudge(null); setScreen("dashboard"); },
          onSecondary: () => { markShownToday(NUDGE_KEYS.log); setActiveNudge(null); },
        };
      }
    }

    // ── Priority 4: Weekly weight log reminder (Sunday, no entry in 7 days) ───
    if (!nudge && nudgePrefEnabled("weight") && dayOfWeek === 0 && !shownToday(NUDGE_KEYS.weight)) {
      const sevenDaysAgo = new Date(now.getTime() - 7 * 86400000).toISOString();
      const hasRecentWeight = (weightLogs || []).some(w => (w.logged_at || "") > sevenDaysAgo);
      if (!hasRecentWeight) {
        nudge = {
          id: "weight",
          title: "Log your weight",
          body: "You haven't logged your weight this week. Tracking weekly helps the AI give you accurate 30-day projections.",
          primaryLabel: "Log it now",
          secondaryLabel: "Later",
          onPrimary:   () => { markShownToday(NUDGE_KEYS.weight); setActiveNudge(null); setScreen("progress"); },
          onSecondary: () => { markShownToday(NUDGE_KEYS.weight); setActiveNudge(null); },
        };
      }
    }

    // ── Priority 5: Weekly briefing (Sunday after 18:00, not run this week) ───
    if (!nudge && nudgePrefEnabled("briefing") && dayOfWeek === 0 && hour >= 18 && !shownToday(NUDGE_KEYS.briefing)) {
      const weekMs     = 7 * 86400000;
      const briefingAge = weeklyTs ? (Date.now() - weeklyTs) : Infinity;
      if (briefingAge > weekMs) {
        nudge = {
          id: "briefing",
          title: "Time for your weekly briefing",
          body: "You have 7 days of data ready. Run your weekly briefing to see your patterns and get priorities for next week.",
          primaryLabel: "Run briefing now",
          secondaryLabel: "Later",
          onPrimary: () => {
            markShownToday(NUDGE_KEYS.briefing);
            setActiveNudge(null);
            setScreen("intelligence");
            runWeeklyBriefing();
          },
          onSecondary: () => { markShownToday(NUDGE_KEYS.briefing); setActiveNudge(null); },
        };
      }
    }

    // ── Priority 6: Workout streak reminder (no workout in 48h, 3+ total) ─────
    if (!nudge && nudgePrefEnabled("workout")) {
      const key = NUDGE_KEYS.workout;
      const lastShown = (() => { try { return parseInt(localStorage.getItem(key) || "0"); } catch(_) { return 0; } })();
      if (Date.now() - lastShown >= 86400000) {
        try {
          const twoDaysAgo = new Date(now.getTime() - 2 * 86400000).toISOString().slice(0, 10);
          const [recentRes, countRes] = await Promise.all([
            supabase.from("workout_sessions").select("id")
              .eq("user_id", session.user.id).gte("date", twoDaysAgo).limit(1),
            supabase.from("workout_sessions").select("id", { count: "exact", head: true })
              .eq("user_id", session.user.id),
          ]);
          const noRecentWorkout = (recentRes.data || []).length === 0;
          const totalWorkouts   = countRes.count || 0;
          if (noRecentWorkout && totalWorkouts >= 3) {
            nudge = {
              id: "workout",
              title: "Your streak is at risk",
              body: "You haven't trained in 2 days. Your muscles are recovered and ready — don't break the habit.",
              primaryLabel: "Log a workout",
              secondaryLabel: "Rest day",
              onPrimary: () => {
                try { localStorage.setItem(key, String(Date.now())); } catch(_) {}
                setActiveNudge(null);
                window.location.assign("/workout"); // V24 FIX 2: assign works in Capacitor WebView
              },
              onSecondary: () => {
                try { localStorage.setItem(key, String(Date.now())); } catch(_) {}
                setActiveNudge(null);
              },
            };
          }
        } catch(_) { /* workout fetch failed — skip nudge silently */ }
      }
    }

    if (nudge) setActiveNudge(nudge);
  }

  async function handleExportData(format) {
    setExportLoading(format); setExportErr("");
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 30000);
    try {
      const { data: { session } } = await supabase.auth.getSession();
      if (!session) { clearTimeout(timeout); setExportErr("Sign in to export your data."); setExportLoading(null); return; }
      const res = await fetch(`${API_BASE}/api/export-data?format=${format}`, {
        headers: { Authorization: `Bearer ${session.access_token}` },
        signal: controller.signal,
      });
      clearTimeout(timeout);
      if (!res.ok) {
        const j = await res.json().catch(() => ({ error: "Export failed" }));
        setExportErr(j.error || "Export failed. Try again.");
        setExportLoading(null);
        return;
      }
      const blob = await res.blob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `lithe-export.${format}`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    } catch(e) {
      clearTimeout(timeout);
      setExportErr(e.name === 'AbortError' ? "Request timed out. Please try again." : "Export failed: " + e.message);
    }
    setExportLoading(null);
  }

  async function handleDeleteAccount() {
    if (deleteConfirmText !== "DELETE") return;
    setDeleteLoading(true); setDeleteErr("");
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 30000);
    try {
      const { data: { session: sess } } = await supabase.auth.getSession();
      const res = await fetch(`${API_BASE}/api/delete-account`, {
        method: "POST",
        headers: { "Content-Type": "application/json", "Authorization": `Bearer ${sess?.access_token}` },
        signal: controller.signal,
      });
      clearTimeout(timeout);
      const json = await res.json();
      if (!res.ok) throw new Error(json.error || "Deletion failed");
      await supabase.auth.signOut();
    } catch(e) {
      clearTimeout(timeout);
      setDeleteErr(e.name === 'AbortError' ? "Request timed out. Please try again." : e.message);
      setDeleteLoading(false);
    }
  }

  async function addSupplement() {
    if (!session || !suppForm.name.trim()) return;
    setSuppLoading(true);
    try {
      const row = {
        user_id: session.user.id,
        name:    suppForm.name.trim(),
        dose:    suppForm.dose.trim() || null,
        timing:  suppForm.timing,
        notes:   suppForm.notes.trim() || null,
        affects_macros: false,
      };
      if(!navigator.onLine){
        enqueue("supplement_stacks","insert",row,session.user.id);
        setSuppStack(prev=>[...prev,{...row,id:"pending_"+Date.now(),active:true}]);
      } else {
        const { data, error } = await supabase.from("supplement_stacks")
          .insert(row).select("id,name,dose,timing,notes,affects_macros,active").single();
        if (!error && data) setSuppStack(prev => [...prev, data]);
      }
      setShowSuppAdd(false);
      setSuppForm({name:"",dose:"",timing:"Morning",notes:""});
      setSuppSearch(""); setSuppSearchRes([]);
    } catch(e) { if (process.env.NODE_ENV !== "production") { console.warn("[addSupplement]", e.message); } }
    setSuppLoading(false);
  }

  async function deleteSupplement(id) {
    setSuppStack(prev => prev.filter(s => s.id !== id));
    await supabase.from("supplement_stacks").update({active:false}).eq("id", id);
  }

  async function toggleSuppTaken(supp) {
    const isTaken = suppTakenToday.has(supp.id);
    if (isTaken) {
      const logId = suppLogIds[supp.id];
      setSuppTakenToday(prev => { const n = new Set(prev); n.delete(supp.id); return n; });
      setSuppLogIds(prev => { const n = {...prev}; delete n[supp.id]; return n; });
      if (logId) await supabase.from("supplement_logs").delete().eq("id", logId);
    } else {
      const { data } = await supabase.from("supplement_logs")
        .insert({ user_id: session.user.id, supplement_id: supp.id, log_date: TODAY_ISO() })
        .select("id").single();
      setSuppTakenToday(prev => new Set([...prev, supp.id]));
      if (data) setSuppLogIds(prev => ({...prev, [supp.id]: data.id}));
    }
  }

  async function searchSuppDB(q) {
    const safe = sanitiseSearch(q);
    if (safe.length < 2) { setSuppSearchRes([]); return; }
    setSuppSearching(true);
    try {
      const { data } = await supabase.from("foods")
        .select("name,serving_label,category")
        .ilike("name", `%${safe}%`)
        .limit(8);
      const sorted = (data||[]).sort((a,b)=>
        (a.category==="Supplements"?0:1)-(b.category==="Supplements"?0:1)
      );
      setSuppSearchRes(sorted);
    } catch(_) { setSuppSearchRes([]); }
    setSuppSearching(false);
  }

  // ─── PROMPT SANITISER ────────────────────────────────────────────────────
  function sanitiseForPrompt(str) {
    if (!str || typeof str !== 'string') return '';
    return str
      .replace(/[\n\r\t]+/g, ' ')   // S107: collapse control chars to spaces
      .replace(/[<>]/g, '')
      .replace(/\{|\}/g, '')
      .replace(/system:/gi, '')
      .replace(/SYSTEM:/g, '')
      .replace(/\[INST\]/gi, '')
      .replace(/<<SYS>>/gi, '')
      .trim()
      .slice(0, 500);
  }

  // ─── SHARED AI CONSTANTS ──────────────────────────────────────────────────
  // AI_SAFETY_LAW imported from ./llm — shared constant available to all files

  const AI_PERSONA_VOICE = {
    Motivational: `You are a high-energy coach who genuinely believes in this person and knows their exact goal. You call out every failing with specific numbers — but you frame each one as something fixable tonight or tomorrow. You celebrate the small wins loudly. You speak in plain English — no science terms, no jargon. Short punchy sentences mixed with longer ones. Exclamation marks used when earned by a specific number or win. You always reference the user's actual target weight and physique goal directly — not generic fitness language. Every section ends with forward momentum and one clear action. BANNED: "leucine", "MPS", "glycogen", "substrate", "anabolic", "catabolic", "pro-rata", "thermogenesis", "catabolism". Also banned: generic praise with no data behind it — "great job", "fantastic", "you're doing amazing", "I'm excited".`,
    Balanced: `You are a knowledgeable personal trainer who explains things clearly and honestly. You are not cold and not a cheerleader — you sit right in the middle. You tell the user exactly what is happening to their body in plain English, why it matters for their specific goal, and what to do about it. You acknowledge what they did right and what needs fixing. You reference their actual target weight and the real-world impact on their training. No science jargon — if a concept needs explaining, explain it in one plain sentence. BANNED: "leucine", "MPS", "glycogen", "substrate utilisation", "anabolic", "catabolic", "pro-rata", "thermogenesis". Also banned: empty warmth — "well done", "great effort", "keep it up" without a specific data point.`,
    Critical: `You are a drill sergeant with a bad boy edge who genuinely cares but has zero patience for excuses. You call out every failing directly with the specific numbers. Short punchy sentences — full stops that land like punches. You always acknowledge the one thing they did right before finishing. You reference their actual target weight and what they risk losing if they don't fix today. Plain English only — no science terms. Commands not suggestions. The user should feel a bit uncomfortable and immediately want to fix it. BANNED: "leucine", "MPS", "glycogen", "substrate", "anabolic", "catabolic", "pro-rata", "consider", "perhaps", "might want to", "if you feel", "potentially", "it may be worth".`,
  };

  async function runSuppSchedulePlanner() {
    if (!session || suppStack.length === 0) return;
    if (!effectiveIsPremium) return;
    setSuppScheduleLoad(true); setSuppScheduleMsg("");
    try {
      const stackList = suppStack.map(s =>
        `${s.name}${s.dose ? ` (${s.dose})` : ""} — currently: ${s.timing}`
      ).join("\n");
      const raw = await llmFetch({
        model: LLM_MODEL_LIGHT, max_tokens: 300, temperature: 0.2,
        messages: [
          { role: "system", content: `${AI_PERSONA_VOICE[persona] || AI_PERSONA_VOICE.Balanced} You are a clinical sports nutritionist specialising in supplement timing and interactions. Analyse this supplement stack and assign the optimal timing for each item. INTERACTION_LAW: Flag known interactions — Calcium blocks iron (separate by 2+ hours), Zinc and copper compete (do not schedule together), Caffeine-containing supplements before 14:00 only, Magnesium and zinc best before bed, Fat-soluble vitamins (A D E K) must be taken with a meal containing fat, Iron best on empty stomach or with vitamin C. For each supplement note: timing, whether to take with food, and any interaction warnings. PLAIN_ENGLISH_LAW: No science jargon. Banned: leucine, MPS, glycogen, substrate, anabolic, catabolic, pro-rata, thermogenesis, metabolic efficiency, satiety signals, lean mass preservation, metabolic rate, basal metabolic rate, muscle protein synthesis, glycogen resynthesis, leucine threshold, substrate utilisation, normal metabolic state, kickstart your metabolism. UNDER_TARGET_LAW: The daily calorie target already contains the deficit to reach the goal. Being UNDER target = slightly ahead of schedule = POSITIVE. Being OVER target = slightly behind schedule = needs correction. Never frame under-target intake as "missing", "slowing progress", "a shortfall", or any negative language. PRO_RATA_LAW: Use the injected PRO_RATA_STATUS to frame RIGHT NOW. If the user is ON TRACK for this time of day, say so. Only flag a gap as urgent if significantly behind pro-rata AND fewer than 4 hours remaining. PERSONA_LAW: Apply the selected persona voice consistently across every sentence. Never break character. ${AI_SAFETY_LAW} UK_LAW: Write in UK English. Use UK spelling throughout.` },
          { role: "user", content: `USER PROFILE: ${weight}kg, goal: ${sanitiseForPrompt(goal)||"general health"}, physique goal: ${sanitiseForPrompt(physiqueGoal)||"not set"}.
USER_SCHEDULE: Wake time ${wakeTime || '07:00'}, Bed time ${bedTime || '22:00'}
TIMING LAW: Schedule supplements to respect wake and bed times. Never recommend supplements within 30 minutes of bed time unless they are sleep-specific (magnesium glycinate, ashwagandha, melatonin). Schedule caffeine-containing supplements before 14:00 to avoid sleep disruption.\n\nSTACK:\n${stackList}\n\nValid timings: Morning, Pre-Workout, Post-Workout, With Meals, Evening, Bedtime.\nReturn ONLY a JSON array: [{"name":"...","timing":"..."}]. No explanation. No markdown.` },
        ],
      });
      const cleaned = raw.replace(/```json|```/g,"").trim();
      const arr = JSON.parse(cleaned.slice(cleaned.indexOf("["), cleaned.lastIndexOf("]")+1));
      const validTimings = ["Morning","Pre-Workout","Post-Workout","With Meals","Evening","Bedtime"];
      for (const item of arr) {
        const match = suppStack.find(s => s.name.toLowerCase() === item.name.toLowerCase());
        if (!match || !validTimings.includes(item.timing)) continue;
        await supabase.from("supplement_stacks").update({timing: item.timing}).eq("id", match.id);
        setSuppStack(prev => prev.map(s => s.id === match.id ? {...s, timing: item.timing} : s));
      }
      setSuppScheduleMsg("Schedule updated by AI.");
      setTimeout(() => setSuppScheduleMsg(""), 4000);
    } catch(e) {
      setSuppScheduleMsg("Could not plan schedule. Try again.");
      if (process.env.NODE_ENV !== "production") { console.warn("[suppSchedule]", e); }
    }
    setSuppScheduleLoad(false);
  }

  // ─── WEIGHT LOG ────────────────────────────────────────────────────────────
  async function logWeight(kgStr) {
    if (!session) return;
    const kg = parseFloat(kgStr);
    if (!kg || kg < 20 || kg > 500) return;
    setWeightLogLoading(true);
    const row = { user_id:session.user.id, weight_kg:kg, logged_at:new Date().toISOString() };
    if(!navigator.onLine){
      enqueue("weight_logs","insert",row,session.user.id);
      setWeightLogs(prev=>[{...row,id:"pending_"+Date.now()},...prev].slice(0,14));
      setWeightInput(""); setWeight(String(kg));
    } else {
      const {data, error} = await supabase.from("weight_logs").insert(row).select().single();
      if (error) {
        Sentry.captureException(error, { extra: { context: "logWeight" } }); if (process.env.NODE_ENV !== "production") { console.error("[logWeight]", error); }
        setSyncErr(true);
        showToast("Failed to save weight. Please try again.");
      } else if (data) {
        setWeightLogs(prev=>[data,...prev].slice(0,14));
        setWeightInput("");
        setWeight(String(kg));
        await supabase.from("profiles").upsert(
          { id: session.user.id, weight: String(kg), updated_at: new Date().toISOString() },
          { onConflict: "id" }
        );
        snapshotDay();
        showToast("Weight saved ✓", "success");
      }
    }
    setWeightLogLoading(false);
  }

  // ─── COPY YESTERDAY ────────────────────────────────────────────────────────
  // Step 1: open modal — fetch yesterday's logs and show meal slot picker
  async function openCopyModal() {
    if (!session) return;
    if (!mealType) { setLogErr("⚠ Select a meal type first."); return; }
    setCopyLoading(true); setCopyOk(""); setLogErr("");
    const yesterday = new Date(); yesterday.setDate(yesterday.getDate()-1);
    const yISO = yesterday.toISOString().slice(0,10);
    try {
      const {data:yLogs, error} = await supabase
        .from("logs").select("name,calories,protein,carbs,fat,fibre,sugar,sodium,source,meal_type,source_food_id,source_table,logged_grams")
        .eq("user_id", session.user.id).eq("log_date", yISO)
        .order("logged_at", {ascending:true});
      if (error) throw error;
      if (!yLogs || yLogs.length===0) { setLogErr("No logs found for yesterday."); setCopyLoading(false); return; }
      setCopyYestLogs(yLogs);
      setCopySelSlot(null);
      setCopySelItems(new Set());
      setCopyModal("slots");
    } catch(e) { setLogErr("Copy failed: "+e.message); }
    setCopyLoading(false);
  }

  // Step 2: user picks a slot — show items for that slot
  function selectCopySlot(slot) {
    setCopySelSlot(slot);
    // Pre-select all items in this slot
    const slotItems = copyYestLogs
      .map((l,i) => ({l,i}))
      .filter(({l}) => (l.meal_type||"Other") === slot);
    setCopySelItems(new Set(slotItems.map(({i}) => i)));
    setCopyModal("items");
  }

  // Step 3: confirm — insert selected items
  async function confirmCopyItems() {
    setCopyLoading(true);
    let count = 0;
    try {
      for (const idx of copySelItems) {
        const l = copyYestLogs[idx];
        await insertLog({
          name:l.name, calories:l.calories, protein:l.protein,
          carbs:l.carbs, fat:l.fat, fibre:l.fibre||0, sugar:l.sugar||0, sodium:l.sodium||0,
          source:l.source,
          source_food_id: l.source_food_id || null,
          source_table:   l.source_table   || null,
          logged_grams:   l.logged_grams   || null,
        });
        count++;
      }
      setCopyOk(`✓ Copied ${count} item${count!==1?"s":""}`);
    } catch(e) { setLogErr("Copy failed: "+e.message); }
    setCopyModal(null);
    setCopyLoading(false);
  }

  // ─── COPY ALL FROM YESTERDAY ──────────────────────────────────────────────
  async function copyAllFromYesterday() {
    if (!session) return;
    setCopyLoading(true); setCopyOk(""); setLogErr("");
    const yesterday = new Date(); yesterday.setDate(yesterday.getDate()-1);
    const yISO = yesterday.toISOString().slice(0,10);
    try {
      const {data:yLogs, error} = await supabase
        .from("logs").select("name,calories,protein,carbs,fat,fibre,sugar,sodium,source,meal_type,source_food_id,source_table,logged_grams")
        .eq("user_id", session.user.id).eq("log_date", yISO)
        .order("logged_at", {ascending:true});
      if (error) throw error;
      if (!yLogs || yLogs.length===0) { setLogErr("No logs found for yesterday."); setCopyLoading(false); return; }
      if (!window.confirm(`Copy all ${yLogs.length} items from yesterday to today?`)) { setCopyLoading(false); return; }
      let count = 0;
      for (const l of yLogs) {
        await insertLog({
          name:l.name, calories:l.calories, protein:l.protein,
          carbs:l.carbs, fat:l.fat, fibre:l.fibre||0, sugar:l.sugar||0, sodium:l.sodium||0,
          source:l.source, meal_type:l.meal_type,
          source_food_id: l.source_food_id || null,
          source_table:   l.source_table   || null,
          logged_grams:   l.logged_grams   || null,
        });
        count++;
      }
      setCopyOk(`✓ Copied ${count} item${count!==1?"s":""} from yesterday`);
    } catch(e) { setLogErr("Copy failed: "+e.message); }
    setCopyLoading(false);
  }

  // ─── AUTH HANDLERS ─────────────────────────────────────────────────────────
  async function handleLogin(e) {
    e&&e.preventDefault();
    if(!authEmail||!authEmail.trim()){setAuthErr("Please enter your email address");return;}
    if(!authPass){setAuthErr("Please enter your password");return;}
    setAuthLoad(true); setAuthErr("");
    const {error} = await supabase.auth.signInWithPassword({email:authEmail,password:authPass});
    if(error) setAuthErr(error.message);
    setAuthLoad(false);
  }

  async function handleSignup(e) {
    e&&e.preventDefault();
    if(!authEmail||!authPass||!authName){setAuthErr("All fields required.");return;}
    if(authPass.length<8){setAuthErr("Password must be 8+ characters.");return;}
    setAuthLoad(true); setAuthErr("");
    const {data,error} = await supabase.auth.signUp({email:authEmail,password:authPass,options:{data:{display_name:authName}}});
    if(error){setAuthErr(error.message);}
    else if(data?.user?.identities?.length===0){setAuthErr("Email already registered. Try logging in.");}
    else{
      // Record GDPR and Terms consent timestamps on the profiles row.
      // Columns must exist: ALTER TABLE profiles ADD COLUMN IF NOT EXISTS gdpr_accepted_at timestamptz;
      //                     ALTER TABLE profiles ADD COLUMN IF NOT EXISTS terms_accepted_at timestamptz;
      const consentAt = new Date().toISOString();
      if(data?.user?.id){
        try {
          await supabase.from("profiles").upsert(
            { id: data.user.id, gdpr_accepted_at: consentAt, terms_accepted_at: consentAt },
            { onConflict: "id" }
          );
        } catch(_) {} // fails silently if columns not yet migrated
      }
      setAuthErr("Check your email to confirm your account, then log in.");
      setResendCountdown(60);
    }
    setAuthLoad(false);
  }

  async function handleResend() {
    setResendOk("");
    try { await supabase.auth.resend({ type: "signup", email: authEmail }); } catch(_) {}
    setResendOk("Email sent!");
    setTimeout(() => setResendOk(""), 2000);
    setResendCountdown(60);
  }

  async function handleReset(e) {
    e&&e.preventDefault();
    if(!authEmail){setAuthErr("Enter your email address first.");return;}
    setAuthLoad(true); setAuthErr(""); setResetOk("");
    const {error} = await supabase.auth.resetPasswordForEmail(authEmail, {
      redirectTo: "https://www.lithe.fit",
    });
    if(error) setAuthErr(error.message);
    else setResetOk("Password reset email sent. Check your inbox.");
    setAuthLoad(false);
  }

  // V25 FIX 6: logout queue confirmation state
  const [logoutConfirm, setLogoutConfirm] = useState(false);

  // V24 FIX 3: programmatic state reset instead of window.location.reload()
  // Keeps the React tree mounted — no blank screen flash on Capacitor Android.
  // V25 FIX 6: check offline queue before signing out — prompt if pending items.
  async function handleLogout() {
    const pending = getQueueLength();
    if (pending > 0 && !logoutConfirm) {
      setLogoutConfirm(true);
      return; // wait for user confirmation
    }
    setLogoutConfirm(false);
    clearQueue();
    await supabase.auth.signOut();
    // Full state reset — mirrors SIGNED_OUT handler + clears all user data
    if (process.env.NODE_ENV !== "production") { console.log("[TARGETS DEBUG] handleLogout — wiping targets to zero"); }
    loadedRef.current = null;
    setSession(null);
    setAuthReady(true);
    setProfileLoading(false);
    setProfileLoaded(false);
    setScreen("settings");
    setTargets({calories:0,protein:0,carbs:0,fat:0,fibre:30,sugar:30,sodium:2300,bmr:0,tdeeRaw:0});
    setLogs([]);
    setDayHistory([]);
    setWeightLogs([]);
    setSuppStack([]);
    setSuppTakenToday(new Set());
    setSuppLogIds({});
    setSavedMeals([]);
    setLogHistory([]);
    setTodayWorkouts([]);
    setBodyMeasurements([]);
    setCpHeadline(""); setCpMetabolic(""); setCpTactical(""); setCpOutlook(""); setCpAction(""); setCpResp("");
    setWbSummary(""); setWbPros([]); setWbNegatives([]); setWbPriorities([]);
    setWeeklyTs(0);
    setIntelByDay({});
    setTargetWeight(null);
    setIsPremium(false);
    setActiveNudge(null);
    setShowLaunch(true);
  }


  // ─── BODY MEASUREMENTS: SAVE ──────────────────────────────────────────────
  async function saveBodyMeasurement(form) {
    if (!session) return;
    const filledFields = BODY_FIELDS.filter(f => form[f.key] !== undefined && form[f.key] !== "");
    if (filledFields.length === 0) { alert("Please enter at least one measurement."); return; }
    const outOfRange = filledFields.find(f => { const v = parseFloat(form[f.key]); return isNaN(v) || v <= 0 || v > 500; });
    if (outOfRange) { alert(`${outOfRange.label} must be a number between 0 and 500.`); return; }
    setBodyMeasLoading(true);
    try {
      const row = { user_id: session.user.id, date: TODAY_ISO(), logged_at: new Date().toISOString() };
      BODY_FIELDS.forEach(f => {
        if (form[f.key] !== undefined && form[f.key] !== "") {
          row[f.key] = parseFloat(form[f.key]);
        }
      });
      if(!navigator.onLine){
        enqueue("body_measurements","insert",row,session.user.id);
        setBodyMeasurements(prev=>[{...row,id:"pending_"+Date.now()},...prev].slice(0,30));
        setBodyMeasForm({}); setShowBodyMeas(false);
      } else {
        const { data, error } = await supabase.from("body_measurements").insert(row).select().single();
        if (error) throw error;
        setBodyMeasurements(prev => [data, ...prev].slice(0, 30));
        setBodyMeasForm({});
        setShowBodyMeas(false);
      }
    } catch(e) { Sentry.captureException(e, { extra: { context: "saveBodyMeasurement" } }); if (process.env.NODE_ENV !== "production") { console.error("[saveBodyMeasurement]", e); } }
    setBodyMeasLoading(false);
  }

  // ─── SANITISE SEARCH INPUT ────────────────────────────────────────────────
  // Strips characters that could manipulate PostgREST .or() / .ilike() filters.
  function sanitiseSearch(raw) {
    return String(raw || "").replace(/[%_\\'"()]/g, " ").trim();
  }

  // ─── SUPABASE FOOD DB SEARCH ──────────────────────────────────────────────
  // Called on every keystroke (debounced 300ms). Searches foods table by name.
  // Returns up to 8 results including raw/cooked variants.
  async function searchFoodsDB(query, mode) {
    const safe = sanitiseSearch(query);
    if (safe.length < 2) { setDbSuggestions([]); return; }
    setDbSearching(true);
    try {
      const merged = await searchFoodsDBForMerge(query);
      // V27: Filter by mode — "all" = whole foods only (no brand), "branded" = branded only, else unfiltered
      if (mode === "branded") {
        setDbSuggestions(merged.filter(r => !!r.brand));
      } else if (mode === "all") {
        setDbSuggestions(merged.filter(r => !r.brand));
      } else {
        setDbSuggestions(merged);
      }
    } catch(e) {
      if (process.env.NODE_ENV !== "production") { console.warn("[searchFoodsDB]", e.message); }
      setDbSuggestions([]);
    }
    setDbSearching(false);
  }

  // Convert a foods-table row into the same shape as an nlpModal candidate.
  // Shape is intentionally identical to brandedRowToCandidate (minus brand field)
  // so both sources flow into nlpModal and confirmModalLog without branching.
  function dbRowToCandidate(row) {
    return {
      dbId:         row.id,
      name:         String(row.name || '') + (row.cooking_state && row.cooking_state !== 'n/a' ? ' — ' + row.cooking_state.charAt(0).toUpperCase() + row.cooking_state.slice(1) : ''),
      kcal100:      Math.round(parseFloat(row.calories_per_100g || 0) * 10) / 10,
      p100:         Math.round(parseFloat(row.protein_per_100g  || 0) * 10) / 10,
      c100:         Math.round(parseFloat(row.carbs_per_100g    || 0) * 10) / 10,
      f100:         Math.round(parseFloat(row.fat_per_100g      || 0) * 10) / 10,
      fi100:        Math.round(parseFloat(row.fibre_per_100g    || 0) * 10) / 10,
      su100:        Math.round(parseFloat(row.sugar_per_100g    || 0) * 10) / 10,
      na100:        Math.round(parseFloat(row.sodium_per_100g   || 0) * 10) / 10,
      grams:        parseFloat(row.serving_size_g) || 100,
      servingLabel: row.serving_label || null,
      category:     row.category || "",
      source:       'db',
    };
  }

  // Also search DB in fetchNLP and prepend DB results to candidates
  // Convert a branded_foods row (per-serving macros) to the candidate shape.
  // branded_foods stores calories/protein/carbs/fat per serving, not per 100g.
  // Back-calculate per-100g so the existing logging pipeline works unchanged.
  function brandedRowToCandidate(row) {
    const g = parseFloat(row.serving_g) || 100;
    const scale = g > 0 ? (100 / g) : 1;
    return {
      dbId:         row.id,
      name:         row.name,
      brand:        row.brand || "",
      kcal100:      Math.round(parseFloat(row.calories || 0) * scale * 10) / 10,
      p100:         Math.round(parseFloat(row.protein  || 0) * scale * 10) / 10,
      c100:         Math.round(parseFloat(row.carbs    || 0) * scale * 10) / 10,
      f100:         Math.round(parseFloat(row.fat      || 0) * scale * 10) / 10,
      fi100:        Math.round(parseFloat(row.fibre    || 0) * scale * 10) / 10,
      su100:        Math.round(parseFloat(row.sugar    || 0) * scale * 10) / 10,
      na100:        Math.round(parseFloat(row.sodium   || 0) * scale * 10) / 10,
      grams:        g,
      servingLabel: row.serving_label || null,
      category:     row.category || "",
      source:       "branded",
    };
  }

  // Runs foods + branded_foods queries and merges results with smart ranking.
  //
  // STEP 1 — Brand detection: ilike('brand', 'query%') — prefix only.
  //   "eggs%" does NOT match "Greggs" (root bug fix from previous version).
  //
  // STEP 2 — Result order by mode:
  //   Brand search (e.g. "greggs"):
  //     Group A: branded_foods where brand ilike query%
  //     Group B: branded_foods where name  ilike %query%
  //     Group C: foods          where name  ilike %query%
  //   Generic search (e.g. "eggs"):
  //     Group A: foods where name ilike query%  (starts with — most relevant)
  //     Group B: foods where name ilike %query% (contains but doesn't start with)
  //     Group C: branded_foods where name ilike query%  (starts with only)
  //     Group D: OPF (handled upstream in fetchNLP, not here)
  //
  // STEP 3 — Within each group, 3-tier rank:
  //   Tier 0: exact match  (name === query)
  //   Tier 1: starts with  (name starts with query)
  //   Tier 2: contains     (query anywhere in name)
  //
  // STEP 4 — Deduplicate by name (case-insensitive).
  // STEP 5 — Cap at 20 results.
  async function searchFoodsDBForMerge(query) {
    const safe = sanitiseSearch(query);
    if (safe.length < 2) return [];
    const q = safe.toLowerCase();
    // V47: Also try without spaces (for apostrophe-stripped names like "McDonald s" → "McDonalds")
    const safeNoSpace = safe.replace(/\s+/g, "");
    try {
      const foodsSelectCols = "id,name,brand,category,cooking_state,calories_per_100g,protein_per_100g,carbs_per_100g,fat_per_100g,fibre_per_100g,sugar_per_100g,sodium_per_100g,serving_size_g,serving_label,search_terms";

      // STEP 1 — brand detection (check both with and without apostrophe)
      const { data: brandCheck } = await supabase
        .from("branded_foods")
        .select("brand")
        .or(`brand.ilike.${safe}%,brand.ilike.${safeNoSpace}%`)
        .limit(1);
      const isBrandSearch = (brandCheck?.length ?? 0) > 0;

      // STEP 3 helper — 3-tier rank sort within a group
      // Tier 0: exact match → Tier 1: starts with → Tier 2: contains
      function rankSort(candidates) {
        return candidates.slice().sort((a, b) => {
          const an = a.name.toLowerCase();
          const bn = b.name.toLowerCase();
          const aRank = an === q ? 0 : an.startsWith(q) ? 1 : 2;
          const bRank = bn === q ? 0 : bn.startsWith(q) ? 1 : 2;
          return aRank - bRank;
        });
      }

      let merged;

      if (isBrandSearch) {
        // ── Brand mode ─────────────────────────────────────────────────────
        // Group A: branded where brand starts with query
        // Group B: branded where name contains query (but brand didn't start with query)
        // Group C: generic foods where name contains query
        const brandedResult = await supabase
          .from("branded_foods")
          .select("id,brand,name,category,calories,protein,carbs,fat,fibre,sugar,sodium,serving_g,serving_label")
          .or(`brand.ilike.${safe}%,name.ilike.%${safe}%,brand.ilike.${safeNoSpace}%,name.ilike.%${safeNoSpace}%`)
          .order("brand", { ascending: true })
          .limit(15);

        let foodsResult = await supabase
          .from("foods")
          .select(foodsSelectCols)
          .or(`name.ilike.%${safe}%,search_terms.ilike.%${safe}%`)
          .order("name", { ascending: true })
          .limit(10);
        if (foodsResult.error) {
          foodsResult = await supabase
            .from("foods")
            .select(foodsSelectCols)
            .ilike("name", `%${safe}%`)
            .order("name", { ascending: true })
            .limit(10);
        }

        const bRows       = brandedResult.data || [];
        const groupA      = bRows.filter(r =>  r.brand?.toLowerCase().startsWith(q));
        const groupB      = bRows.filter(r => !r.brand?.toLowerCase().startsWith(q));
        const genericRows = foodsResult.data   || [];

        merged = [
          ...rankSort(groupA.map(brandedRowToCandidate)),
          ...rankSort(groupB.map(brandedRowToCandidate)),
          ...rankSort(genericRows.map(dbRowToCandidate)),
        ];

      } else {
        // ── Generic mode ───────────────────────────────────────────────────
        // Fetch all matching generic foods in one query, split in JS for perf
        let foodsResult = await supabase
          .from("foods")
          .select(foodsSelectCols)
          .or(`name.ilike.%${safe}%,search_terms.ilike.%${safe}%`)
          .order("name", { ascending: true })
          .limit(15);
        if (foodsResult.error) {
          foodsResult = await supabase
            .from("foods")
            .select(foodsSelectCols)
            .ilike("name", `%${safe}%`)
            .order("name", { ascending: true })
            .limit(15);
        }

        // Branded: search both name and brand columns
        const brandedStartsResult = await supabase
          .from("branded_foods")
          .select("id,brand,name,category,calories,protein,carbs,fat,fibre,sugar,sodium,serving_g,serving_label")
          .or(`name.ilike.%${safe}%,brand.ilike.%${safe}%,name.ilike.%${safeNoSpace}%,brand.ilike.%${safeNoSpace}%`)
          .order("name", { ascending: true })
          .limit(5);

        const allGeneric      = foodsResult.data || [];
        // Group A: generic where name starts with query (highest relevance)
        const genericStarts   = allGeneric.filter(r => r.name?.toLowerCase().startsWith(q)).map(dbRowToCandidate);
        // Group B: generic where name contains query but doesn't start with it
        const genericContains = allGeneric.filter(r => !r.name?.toLowerCase().startsWith(q)).map(dbRowToCandidate);
        // Group C: branded where item name starts with query
        const brandedStarts   = (brandedStartsResult.data || []).map(brandedRowToCandidate);

        merged = [
          ...rankSort(genericStarts),    // Group A — generic starts-with (best)
          ...rankSort(genericContains),  // Group B — generic contains
          ...rankSort(brandedStarts),    // Group C — branded starts-with only
          // Group D — OPF results appended by fetchNLP after this returns
        ];
      }

      // STEP 4 — deduplicate by name (case-insensitive)
      const seen = new Set();
      const deduped = merged.filter(c => {
        const key = c.name.toLowerCase();
        if (seen.has(key)) return false;
        seen.add(key);
        return true;
      });

      // STEP 5 — cap at 20
      return deduped.slice(0, 20);
    } catch(_) { return []; }
  }

  // Submit a food suggestion
  async function submitFoodSuggestion() {
    if (!session) return;
    const { name, brand, calories, protein, carbs, fat, cookingState } = suggestForm;
    if (!name.trim() || !calories || !protein || !carbs || !fat) {
      setSuggestErr("Name, calories, protein, carbs and fat are required.");
      return;
    }
    setSuggestErr(""); setSuggestOk("");
    try {
      const { error } = await supabase.from("food_suggestions").insert({
        user_id:           session.user.id,
        name:              name.trim(),
        brand:             brand.trim() || null,
        cooking_state:     cookingState,
        calories_per_100g: parseFloat(calories),
        protein_per_100g:  parseFloat(protein),
        carbs_per_100g:    parseFloat(carbs),
        fat_per_100g:      parseFloat(fat),
      });
      if (error) throw error;
      setSuggestOk("Thanks! Your suggestion has been submitted for review.");
      setSuggestForm({name:"",brand:"",calories:"",protein:"",carbs:"",fat:"",cookingState:"raw"});
      setTimeout(() => { setShowSuggestForm(false); setSuggestOk(""); }, 3000);
    } catch(e) {
      setSuggestErr("Submission failed: " + e.message);
    }
  }

  // ─── HERO SUMMARY ─────────────────────────────────────────────────────────
  async function runHeroSummary({
    calConsumed, calTarget, calRemaining,
    proteinEaten, proteinTarget,
    carbsEaten, carbsTarget,
    fatEaten, fatTarget,
    fibreEaten, fibreTarget,
    currentPersona,
  }) {
    // Zero-data guard — avoid API call with nothing to analyse
    if (!calConsumed || calConsumed === 0) {
      const hour = new Date().getHours();
      return hour < 10
        ? "Fresh start — hit protein first today."
        : hour < 14
        ? "Nothing logged yet — start tracking now."
        : "Day half gone and nothing logged — log now.";
    }

    const now = new Date();
    const hour = now.getHours();
    const minute = now.getMinutes();

    // Time-of-day context — critical for accuracy
    const timeContext = hour < 11
      ? `It is ${hour}:00. Early morning. Day has barely started.`
      : hour < 14
      ? `It is ${hour}:00. Midday. Roughly half the day done.`
      : hour < 18
      ? `It is ${hour}:00. Afternoon. Most meals should be logged.`
      : hour < 21
      ? `It is ${hour}:00. Evening. Day nearly over. Dinner may not be logged yet.`
      : `It is ${hour}:00. Late evening. Day essentially done.`;

    // Percentage consumed
    const pct = Math.round((calConsumed / calTarget) * 100);

    // Expected progress based on eating window (07:00–21:00, 14 hours)
    const wakeHour = 7; const sleepHour = 21;
    const eatingWindowHours = sleepHour - wakeHour; // 14
    const hoursIntoDay = Math.max(0, (hour + minute / 60) - wakeHour);
    const expectedPct = Math.min(100, Math.max(0, Math.round((hoursIntoDay / eatingWindowHours) * 100)));
    const actualPct = Math.round((calConsumed / calTarget) * 100);
    const pctDiff = actualPct - expectedPct;
    const isSignificantlyBehind = pctDiff < -15;
    const isSignificantlyAhead = pctDiff > 15;
    const isOnTrack = Math.abs(pctDiff) <= 15;

    // Biggest macro gap remaining
    const gaps = [
      { name: "Protein", remaining: proteinTarget - proteinEaten },
      { name: "Carbs",   remaining: carbsTarget - carbsEaten     },
      { name: "Fat",     remaining: fatTarget - fatEaten         },
      { name: "Fibre",   remaining: fibreTarget - fibreEaten     },
    ].filter(g => g.remaining > 0);
    const biggestGap = gaps.sort((a,b) =>
      (b.remaining/[proteinTarget,carbsTarget,fatTarget,fibreTarget][
        ["Protein","Carbs","Fat","Fibre"].indexOf(b.name)
      ]) -
      (a.remaining/[proteinTarget,carbsTarget,fatTarget,fibreTarget][
        ["Protein","Carbs","Fat","Fibre"].indexOf(a.name)
      ])
    )[0];

    const HERO_SYSTEM = {
      Balanced: `You are a clinical nutrition analyst.
      ABSOLUTE LIMIT: ONE sentence. MAXIMUM 12 words. Do not exceed this under any circumstances.
      Be precise, factual, time-aware.
      CRITICAL: Account for time of day — if the user is significantly behind pace, flag it.
      No encouragement. No filler. Just the most important insight right now.
      RULES: Max 12 words. One sentence. No ellipsis. End with a full stop.`,
      Motivational: `You are a high-energy fitness coach.
      ABSOLUTE LIMIT: ONE sentence. MAXIMUM 12 words. Do not exceed this under any circumstances.
      Make it energising and action-focused.
      RULES: Max 12 words. One sentence. End with an exclamation mark.`,
      Critical: `You are a blunt drill sergeant.
      ABSOLUTE LIMIT: ONE sentence. MAXIMUM 12 words. Do not exceed this under any circumstances.
      Raw numbers only. No softening whatsoever.
      RULES: Max 12 words. One sentence. Numbers only.`,
    };

    const userPrompt =
      `${timeContext}\n` +
      `Calories: ${calConsumed}/${calTarget}kcal (${pct}% consumed, ` +
      `${calRemaining}kcal remaining).\n` +
      `Expected progress by now (eating window 07:00–21:00): ~${expectedPct}%.\n` +
      `${isSignificantlyBehind ? `WARNING: User is significantly behind pace (${pctDiff}% below expected). Should have eaten ~${expectedPct}% of calories by now.` : ""}` +
      `${isSignificantlyAhead ? `WARNING: User is ahead of pace (${pctDiff}% above expected).` : ""}` +
      `${isOnTrack ? `User is on track for the day.` : ""}\n` +
      `Protein: ${proteinEaten}/${proteinTarget}g. ` +
      `Carbs: ${carbsEaten}/${carbsTarget}g. ` +
      `Fat: ${fatEaten}/${fatTarget}g. ` +
      `Fibre: ${fibreEaten}/${fibreTarget}g.\n` +
      `${biggestGap ? `Biggest % gap: ${biggestGap.name} (${biggestGap.remaining}g remaining).` : ""}\n` +
      `Write one sentence only. Maximum word count is absolute — do not exceed it.`;

    const sysPrompt = HERO_SYSTEM[currentPersona] || HERO_SYSTEM.Balanced;

    try {
      const raw = await llmFetch({
        model:       LLM_MODEL_LIGHT,
        max_tokens:  20,
        temperature: 0.4,
        messages: [
          { role: "system", content: sysPrompt },
          { role: "user",   content: userPrompt },
        ],
      });
      // Strip to first sentence only as safety net
      const cleaned = cleanAIResponse(raw);
      const firstSentence = cleaned.split(/[.!?]/)[0];
      return firstSentence
        ? firstSentence + (cleaned.includes("!") ? "!" : ".")
        : cleaned;
    } catch (e) {
      console.warn("Hero summary failed:", e.message);
      return "";
    }
  }

  // ─── MEAL SUGGESTIONS ─────────────────────────────────────────────────────
  async function getMealSuggestions() {
    if (!effectiveIsPremium) { setPaywallReason("meal_suggestions"); setShowPaywall(true); return; }
    setMealSugLoading(true); setMealSugErr(""); setMealSuggestions([]);
    try {
      const remaining = {
        calories: Math.max(0, Math.round(targets.calories - totals.calories)),
        protein:  Math.max(0, Math.round(targets.protein  - totals.protein)),
        carbs:    Math.max(0, Math.round(targets.carbs    - totals.carbs)),
        fat:      Math.max(0, Math.round(targets.fat      - totals.fat)),
      };
      if (remaining.calories < 100) {
        setMealSugErr("You've nearly hit your calorie target — nothing left to suggest.");
        setMealSugLoading(false); return;
      }

      // Time of day context
      const hr = new Date().getHours();
      const timeOfDay =
        hr >= 5  && hr < 10 ? "breakfast (05:00-10:00)" :
        hr >= 10 && hr < 12 ? "mid-morning snack (10:00-12:00)" :
        hr >= 12 && hr < 15 ? "lunch (12:00-15:00)" :
        hr >= 15 && hr < 18 ? "afternoon snack (15:00-18:00)" :
        hr >= 18 && hr < 21 ? "dinner (18:00-21:00)" :
        hr >= 21             ? "light evening snack — nothing heavy, user is close to bed" :
        "very early morning snack";

      // 7-day food history context — what the user actually eats
      const recentFoods = (logHistory||[])
        .filter(d => d.logged)
        .slice(-7)
        .map(d => `${d.date}: ~${Math.round(d.calories)} kcal, P:${Math.round(d.protein)}g`)
        .join("; ");

      // Today's logged meals for context (avoid repeating what they already had)
      const todayLogged = logs
        .filter(l => l.log_date === TODAY_ISO())
        .map(l => l.name)
        .filter(Boolean)
        .slice(0, 6)
        .join(", ") || "nothing yet";

      const raw = await llmFetch({
        model: LLM_MODEL_LIGHT,
        max_tokens: 450,
        temperature: 0.7,
        messages: [{
          role: "system",
          content: `${AI_PERSONA_VOICE[persona] || AI_PERSONA_VOICE.Balanced} You are a sports nutrition expert. Suggest 3 specific meals or snacks appropriate for the time of day and the user's eating patterns. Return ONLY valid JSON: {"suggestions":[{"name":"...","description":"...","calories":0,"protein":0,"carbs":0,"fat":0}]}. No explanation, no markdown. CRITICAL: suggestions must be appropriate for the current time of day — do not suggest heavy meals late at night or complex cooking at breakfast. Keep it realistic and practical. ${AI_SAFETY_LAW} PERSONA_MEAL_LAW: Motivational — name meals with energy ("Power Oat Bowl", "Recovery Stack"), describe what the meal DOES for the goal. Balanced — name meals plainly, describe macronutrient mechanism. Critical — no-nonsense names, one-sentence description stating what the meal fixes. UK_LAW: All suggested foods must be readily available in UK supermarkets. No American-only products. ` +
          `REMAINING_BUDGET_LAW: Every suggestion must fit within the remaining calorie, protein, carb, fat budget. State how each meal closes the gaps. ` +
          `PLAIN_ENGLISH_LAW: No science jargon. Banned: leucine, MPS, glycogen, substrate, anabolic, catabolic, pro-rata, thermogenesis, metabolic efficiency, satiety signals, lean mass preservation, metabolic rate, basal metabolic rate, muscle protein synthesis, glycogen resynthesis, leucine threshold, substrate utilisation, normal metabolic state, kickstart your metabolism. ` +
          `SPECIFICITY_LAW: Every suggestion must reference the specific remaining macro numbers. ` +
          `UNDER_TARGET_LAW: If the remaining calorie budget is positive, the user is ahead of schedule — never frame remaining calories as a deficit, shortfall, or missed target. Suggest meals that fit the budget positively. `
        },{
          role: "user",
          content: `TIME OF DAY: ${timeOfDay}
REMAINING BUDGET: ${remaining.calories} kcal | P: ${remaining.protein}g | C: ${remaining.carbs}g | F: ${remaining.fat}g
PHYSIQUE GOAL: ${sanitiseForPrompt(physiqueGoal)||"general fitness"}
ALREADY EATEN TODAY: ${todayLogged}
REMAINING_FIBRE: ${Math.max(0, Math.round((targets.fibre||30) - (totals.fibre||0)))}g
SUGAR_LOGGED: ${Math.round(totals.sugar||0)}g of ${targets.sugar||30}g limit
SODIUM_LOGGED: ${Math.round(totals.sodium||0)}mg of ${targets.sodium||2300}mg
RECENT EATING PATTERN (last 7 days): ${recentFoods||"no history yet"}

Suggest 3 meals or snacks that: (1) fit the remaining macro budget, (2) are appropriate for ${timeOfDay.split(" ")[0]}, (3) complement what has already been eaten today, (4) reflect the user's typical eating style from their recent history.`
        }]
      });
      const cleaned = cleanAIResponse(raw);
      const parsed = JSON.parse(cleaned);
      setMealSuggestions(parsed.suggestions || []);
    } catch(e) {
      setMealSugErr("Could not generate suggestions. Try again.");
      Sentry.captureException(e, { extra: { context: "getMealSuggestions" } }); if (process.env.NODE_ENV !== "production") { console.error("[getMealSuggestions]", e); }
    }
    setMealSugLoading(false);
  }

  // ─── V27 FIX 8: Post-workout nutrition advisor ───────────────────────────
  async function runPostWorkoutAdvisor(workout) {
    if (!session || !effectiveIsPremium) return;
    const nudgeKey = `post_workout_nudge_${workout.id || workout.name}_${TODAY_ISO()}`;
    try { if (localStorage.getItem(nudgeKey)) return; } catch(_) {}
    try {
      const muscleGroups = (workout.exercises || [])
        .flatMap(ex => { const lx = (ex.muscles || []); return lx.length ? lx : [ex.category || "General"]; })
        .filter((v,i,a) => a.indexOf(v) === i).join(", ") || "General";
      const timeOfDay = new Date().getHours() < 12 ? "morning" : new Date().getHours() < 17 ? "afternoon" : "evening";
      const raw = await llmFetch({
        model: LLM_MODEL_LIGHT,
        max_tokens: 350,
        temperature: 0.4,
        messages: [
          { role: "system", content: `${AI_PERSONA_VOICE[persona] || AI_PERSONA_VOICE.Balanced} You are a sports nutritionist giving post-workout recovery advice. Structure: (1) WHAT HAPPENED — what the workout did to the body in plain terms, reference specific muscles and calories burned. (2) WHAT TO EAT NOW — specific foods and amounts in the next 30-60 minutes, based on remaining protein and carb budget. Name UK supermarket products. (3) TOMORROW — what to expect and whether to train or rest. PLAIN_ENGLISH_LAW: No science jargon. Banned: leucine, MPS, glycogen, substrate, anabolic, catabolic, thermogenesis. SPECIFICITY_LAW: Reference specific numbers from the data. UK_LAW: All food suggestions must be UK-available. ${AI_SAFETY_LAW} ${INJURY_LAW} UNDER_TARGET_LAW: If the user is under their calorie target, frame this as ahead of schedule — never as a failure or a risk to recovery. Only flag a calorie gap as a concern if the user is significantly over target.` },
          { role: "user", content: `WORKOUT: ${workout.name || "Workout"}, ${workout.duration || 0} mins, ~${workout.calories_burned || 0} kcal burned\nMUSCLE_GROUPS: ${muscleGroups}\nPROTEIN_LOGGED_TODAY: ${Math.round(totals.protein)}g of ${targets.protein}g target\nCALORIES_REMAINING: ${Math.round(targets.calories - totals.calories)} kcal remaining today\nTIME_OF_DAY: ${timeOfDay}\nCARBS_REMAINING: ${Math.max(0, Math.round(targets.carbs - totals.carbs))}g\n\nGive a single short paragraph (3-4 sentences max). Be specific — name actual foods and amounts. Focus on protein and carb timing. Do not repeat information the user already knows.` },
        ],
      });
      const message = (raw || "").trim();
      if (message) {
        setPostWorkoutNudge({ message, workoutName: workout.name || "Workout" });
        try { localStorage.setItem(nudgeKey, "1"); } catch(_) {}
        setTimeout(() => setPostWorkoutNudge(null), 30000); // auto-dismiss after 30s
      }
    } catch(_) {}
  }

  // ─── GENERATE TARGETS ──────────────────────────────────────────────────────
  // V55: LLM-only macro generation. No JS calcTargets fallback.
  //   Step 1: activity multiplier classification (unchanged from V54).
  //   Step 2: elite sports nutritionist prompt returning expanded schema:
  //     { calories, protein, carbs, fat, fibre, weeks_to_goal, rationale }
  //   On success: populates targetBriefing modal (user must Accept to save).
  //   On failure: hard error + isGenerating=false. No silent fallback.
  async function generateTargets(fromSettings = false, overrideMult = null) {
    const h=parseFloat(height),w=parseFloat(weight),a=parseInt(age);
    // From Settings: goal may be blank — that is acceptable, physique goal drives the LLM.
    // From Onboard: goal is required because it is the only input we have.
    if(!h||!w||!a){setOnboardErr("Fill height, weight, and age first.");return;}
    if(!fromSettings && !overrideMult && !goal.trim()){setOnboardErr("Describe your goal and activity level.");return;}
    setIsGenerating(true); setOnboardLoading(true); setOnboardErr(""); setTargetBriefing(null);

    // ── Step 1: classify activity multiplier ──────────────────────────────
    // V191: skip LLM classifier when wizard provides an explicit multiplier
    let mult = overrideMult;
    if (mult === null) {
      const sedentary=isSedentary(goal);
      mult = sedentary?1.375:1.55;
      try {
        const raw = await llmFetch({
          model:LLM_MODEL_DEFAULT, max_tokens:60, temperature:0.2,
          messages:[{role:"user",content:`Activity classifier. Return ONLY: {"activity_multiplier":<1.2-1.9>}\n\n"${goal}"\nScale: 1.2=sedentary 1.375=light 1.55=moderate 1.725=hard 1.9=athlete`}],
        });
        const m=raw.match(/\{[\s\S]*?\}/);
        if(!m) throw new Error("No JSON");
        let{activity_multiplier}=JSON.parse(m[0]);
        if(sedentary) activity_multiplier=Math.min(activity_multiplier,1.375);
        mult=activity_multiplier;
      } catch(e) {
        // Activity classifier failure is non-fatal -- continue with default mult
        setOnboardErr(`Activity classifier unavailable -- ${sedentary?"1.375x office":"1.55x moderate"} used.`);
      }
    }

    // ── Step 2: AI macro generation (V55 — LLM only, no JS fallback) ─────
    try {
      const MACRO_SYSTEM =
        `OUTPUT RULE: Respond with ONLY a valid JSON object. No preamble, no explanation, no text before or after the JSON. Start your response with { and end with }. Any text outside the JSON will break the parser. ` +
        `You are an elite, ruthless clinical sports nutritionist. ` +
        `Analyze the user's Age, Weight, Height, Gender, Activity Level, and exact Physique Goal. ` +
        `Calculate their TDEE using the Mifflin-St Jeor formula scaled by the provided activity multiplier. ` +
        `Do not overestimate TDEE. ` +
        `If the user requires fat loss or recomposition, you MUST apply a strict, meaningful caloric deficit (500+ kcal below TDEE). ` +
        `Determine the scientifically optimal caloric target and the exact macro split (Protein, Fats, Fibre) required to achieve their specific physique. ` +
        `Do not use generic BMI defaults. Use advanced sports science protocols tailored purely to their data. ` +
        `Protein must remain high: minimum 2.0g/kg bodyweight, up to 2.6g/kg for aggressive recomposition. ` +
        `You MUST cap dietary fat between 0.8g and 1.0g per kg of body weight — no exceptions. This preserves the caloric budget for protein and training fuels. ` +
        `Do NOT output carbs — carbohydrates will be calculated mathematically from the remaining caloric budget after protein and fat are set. ` +
        `weeks_to_goal: calculate the realistic ETA based on the caloric offset and 0.5kg/week max safe fat loss rate. ` +
        `rationale: exactly 2 sentences. ${AI_PERSONA_VOICE[persona] || AI_PERSONA_VOICE.Balanced} Write directly to the user in the second person ("You need...", "If you fail..."). Never refer to "the client". ${AI_SAFETY_LAW} ` +
        `OUTPUT FORMAT LAW: Output a single valid JSON object (start with { end with }), then on the very next line output the recommended target weight in this exact format: TARGET_WEIGHT: Xkg where X is a whole number or one decimal place. ` +
        `No markdown. No backticks. No extra text. ` +
        `Required JSON schema: {"calories":<integer>,"protein":<integer>,"fat":<integer>,"fibre":<integer>,"weeks_to_goal":<integer>,"rationale":"<2 sentences>"}` +
        `\nThe TARGET_WEIGHT line is mandatory — always include it on the line immediately after the closing }.`;

      const macroPrompt =
        `CLIENT PROFILE:\n` +
        `  Age: ${a} years | Weight: ${w}kg | Height: ${h}cm | Gender: ${gender==="M"?"Male":"Female"}\n` +
        `  Activity multiplier: ${mult.toFixed(2)}x\n` +
        `  Fat cap: max ${Math.round(w * 1.0)}g/day (1.0g/kg) | Min protein: ${Math.round(w * 2.0)}g/day (2.0g/kg)\n` +
        `  Activity description: "${sanitiseForPrompt(goal).slice(0,160)}"\n` +
        (physiqueGoal ? `  Physique target: "${sanitiseForPrompt(physiqueGoal).slice(0,160)}"\n` : `  Physique target: not specified -- apply a meaningful deficit\n`) +
        (suppStack.length > 0 ? `  Supplement stack: ${suppStack.map(s=>s.name).join(", ")}\n` : "") +
        `\nAnalyze this client. Output the JSON object, then TARGET_WEIGHT line. Start with {`;

      const rawMacros = await llmFetch({
        model:       LLM_MODEL_DEFAULT,
        max_tokens:  320,
        temperature: 0.35,
        messages: [
          { role: "system", content: MACRO_SYSTEM },
          { role: "user",   content: macroPrompt  },
        ],
      });

      // Parse — widest JSON block strategy with fallback
      const cleaned = rawMacros.replace(/```json|```/g,"").trim();
      const start = cleaned.indexOf("{"), end = cleaned.lastIndexOf("}");
      if (start === -1 || end === -1) throw new Error("No JSON block in response");
      let parsed;
      try {
        parsed = JSON.parse(cleaned.slice(start, end + 1));
      } catch(parseErr) {
        // Fallback: try cleanAIResponse which handles think tags and preamble
        const fallbackCleaned = cleanAIResponse(rawMacros);
        parsed = JSON.parse(fallbackCleaned);
      }

      // Validate LLM outputs — carbs deliberately excluded from schema
      const { calories, protein, fat, fibre, weeks_to_goal, rationale } = parsed;
      if (!calories || calories < 800  || calories > 6000) throw new Error(`Implausible calories: ${calories}`);
      if (!protein  || protein  < 30   || protein  > 500)  throw new Error(`Implausible protein: ${protein}`);
      if (!fat      || fat      < 10   || fat      > 300)  throw new Error(`Implausible fat: ${fat}`);
      if (!weeks_to_goal || weeks_to_goal < 1)             throw new Error(`Implausible weeks_to_goal: ${weeks_to_goal}`);
      if (!rationale || typeof rationale !== "string")     throw new Error("Missing rationale");

      // Fix 1: JS Math Lock — carbs derived from caloric remainder, not LLM guesswork
      const calculatedCarbs = Math.round((calories - (protein * 4) - (fat * 9)) / 4);
      if (calculatedCarbs < 0) throw new Error(`Macro equation invalid: carbs calculated as ${calculatedCarbs}g. Protein/fat too high for calorie budget. Retry.`);

      const bmr = Math.round((10*w)+(6.25*h)-(5*a)+(gender==="M"?5:-161));
      const t = {
        calories:  Math.round(calories),
        protein:   Math.round(protein),
        carbs:     calculatedCarbs,
        fat:       Math.round(fat),
        fibre:     Math.round(fibre || Math.min(40, Math.max(25, (calories/1000)*14))),
        sugar:     30,
        sodium:    2300,
        bmr,
        tdeeRaw:   Math.round(bmr * mult),
      };

      // Extract TARGET_WEIGHT from the response (structured line after closing JSON brace)
      let suggestedTargetWeight = null;
      const twMatch = rawMacros.match(/TARGET_WEIGHT:\s*(\d{2,3}(?:\.\d)?)\s*kg/i);
      if (twMatch) {
        suggestedTargetWeight = parseFloat(twMatch[1]);
        // Auto-save — user explicitly asked the AI to generate their targets,
        // so auto-accepting the AI's target weight recommendation is appropriate here.
        setTargetWeight(suggestedTargetWeight);
        await saveProfile({ targetWeight: suggestedTargetWeight });
      }

      // BUG 3 FIX: natural language fallback if structured TARGET_WEIGHT line absent
      if (!suggestedTargetWeight) {
        const weightMatch = rawMacros.match(
          /(?:aim for|target weight|goal weight|reach|get to|down to|up to)\s+(\d{2,3}(?:\.\d)?)\s*kg/i
        );
        if (weightMatch) {
          const nlSuggested = parseFloat(weightMatch[1]);
          const nlKey = `target_weight_suggestion_${nlSuggested}`;
          const alreadyShown = (() => { try { return localStorage.getItem(nlKey) === "1"; } catch(_) { return false; } })();
          if (!alreadyShown && nlSuggested !== targetWeight) {
            setActiveNudge({
              id: "target_weight",
              title: "AI suggested target weight",
              body: `Based on your physique goal, the AI recommends a target weight of ${nlSuggested}kg. Save this?`,
              primaryLabel: `Save ${nlSuggested}kg`,
              secondaryLabel: "Not now",
              onPrimary: async () => {
                await saveProfile({ targetWeight: nlSuggested });
                setTargetWeight(nlSuggested);
                try { localStorage.setItem(nlKey, "1"); } catch(_) {}
                setActiveNudge(null);
              },
              onSecondary: () => {
                try { localStorage.setItem(nlKey, "1"); } catch(_) {}
                setActiveNudge(null);
              },
            });
          }
        }
      }

      // Populate briefing modal — do NOT save targets yet. User must Accept & Execute.
      setTargetBriefing({
        targets:              t,
        weeksToGoal:          Math.round(weeks_to_goal),
        rationale:            rationale.trim(),
        mult,
        suggestedTargetWeight,
        // snapshot profile fields for the Accept handler
        _h: String(h), _w: String(w), _a: String(a),
      });

    } catch(macroErr) {
      // Hard failure — no fallback, no silent injection of default numbers
      setOnboardErr(`AI Generation Failed: ${macroErr.message.slice(0,80)}. Check connection and retry.`);
    }

    setIsGenerating(false);
    setOnboardLoading(false);
  }

  // V190: Post-wizard delight screen — shows once per user after first onboarding.
  function finishWizard() {
    if (!session) { setScreen("dashboard"); return; }
    const key = `onboarding_complete_${session.user.id}`;
    try {
      if (!localStorage.getItem(key)) {
        localStorage.setItem(key, "1");
        setShowWizardDone(true);
        return;
      }
    } catch(_) {}
    setScreen("dashboard");
  }

  async function handleSkipTargets() {
    // Use hardcoded safe neutral defaults — avoids 2000+ kcal TDEE miscalculations
    // from potentially empty/default profile fields during onboarding.
    // User can update these in Settings after onboarding completes.
    const t = {
      calories: 2000,
      protein:  150,
      carbs:    200,
      fat:      65,
      fibre:    25,
      water:    2500,
      sugar:    30,
      sodium:   2300,
      bmr:      0,
      tdeeRaw:  0,
    };
    setTargets(t);
    await saveProfile({ targets: t, persona });
    finishWizard();
  }

  // ─── FOOD LOGGING ──────────────────────────────────────────────────────────
  // fetchNLP — OPF text search only. No MOCK_DB.
  // Builds a candidate list from OPF results — user must tap to confirm.
  // Serving suggestion: if OPF provides serving_size / serving_quantity /
  // product_quantity, the candidate carries a suggested weight the user can
  // accept or override in the Qty field.
  function resolveGrams(qtyStr) {
    const raw = (qtyStr || "").trim().toLowerCase();
    if (!raw) return 100;
    // Has explicit unit suffix → treat as grams/ml directly
    if (/[a-z]/.test(raw)) return parseFloat(raw) || 100;
    const num = parseFloat(raw);
    return isNaN(num) ? 100 : num;
  }

  async function fetchNLP(overrideFood) {
    const food = String(overrideFood || nlpFood || "").trim();
    if (!food) { setLogErr("Enter a food item."); return; }
    if (!mealType) { setLogErr("Select a meal type first."); return; }
    setSuggestions([]); setNlpCandidates([]); setNlpModal(null); setDbSuggestions([]); setLogLoading(true); setLogErr(""); setLogOk("");

    // V42: LLM translation layer -- extract clean search term from raw input
    let searchTerm = food;
    try {
      searchTerm = await extractSearchTerm(food);
    } catch (_) {
      searchTerm = food;
    }

    // V54: Single-word query detection for tighter post-processing filter
    const queryWords = String(searchTerm || "").trim().toLowerCase().split(/\s+/);
    const isSingleWord = queryWords.length === 1;
    const queryNorm = String(searchTerm || "").trim().toLowerCase();

    // Search Supabase DB first
    const dbResults = await searchFoodsDBForMerge(searchTerm);

    try {
      const ofAbort = new AbortController();
      const ofTimer = setTimeout(() => ofAbort.abort(), 20000);
      let res;
      try {
        res = await fetch(OPF_SEARCH(searchTerm, country), { signal: ofAbort.signal });
      } catch(fetchErr) {
        clearTimeout(ofTimer);
        if (fetchErr.name === "AbortError") throw new Error("Food database is taking too long. Check your connection or try again.");
        throw fetchErr;
      }
      clearTimeout(ofTimer);
      if (!res.ok) throw new Error(`OPF HTTP ${res.status}`);
      const data = await res.json();
      let products = (data.products || []).filter(p => p.product_name?.trim());
      if (!products.length && !dbResults.length) throw new Error("no_results");
      if (!products.length) { setNlpCandidates(dbResults); setLogLoading(false); return; }

      // V58: 3-tier hierarchical sort on raw products before filtering.
      // Tier 1: exact name match → index 0.
      // Tier 2: fewer words in product_name wins.
      // Tier 3: unique_scans_n descending (popularity tiebreak).
      products = products.sort((a, b) => {
        const aN = (a.product_name || "").trim().toLowerCase();
        const bN = (b.product_name || "").trim().toLowerCase();
        const aExact = aN === queryNorm ? 1 : 0;
        const bExact = bN === queryNorm ? 1 : 0;
        if (aExact !== bExact) return bExact - aExact;           // Tier 1
        const aWords = aN.split(/\s+/).length;
        const bWords = bN.split(/\s+/).length;
        if (aWords !== bWords) return aWords - bWords;           // Tier 2
        const aSc = parseFloat(a.unique_scans_n) || 0;
        const bSc = parseFloat(b.unique_scans_n) || 0;
        return bSc - aSc;                                        // Tier 3
      });

      const get = (n, ...keys) => {
        for (const k of keys) { const v = parseFloat(n[k]); if (!isNaN(v) && v > 0) return v; }
        return 0;
      };

      // Strict filter:
      // - Reject if product_name is missing
      // - Reject if energy-kcal_100g is missing OR 0
      // - Reject if proteins_100g is missing (treat as 0 = reject)
      // V54 single-word penalty:
      // - If query is a single word, reject product names with >3 words
      //   (prevents "Food In A Bottle Banana Flavour Drink" matching "banana").
      //   Exception: exact matches always pass regardless of word count.
      const candidates = [];
      for (const p of products) {
        if (!p.product_name?.trim()) continue;
        const n    = p.nutriments || {};
        const kcal = parseFloat(n["energy-kcal_100g"]);
        const prot = parseFloat(n["proteins_100g"]);
        if (!kcal || kcal === 0) continue;
        if (isNaN(prot)) continue;

        // V54 single-word garbage filter
        if (isSingleWord) {
          const nameNorm = p.product_name.trim().toLowerCase();
          const nameWords = nameNorm.split(/\s+/).length;
          const isExact = nameNorm === queryNorm;
          // Allow exact matches through; penalise verbose multi-word results
          if (!isExact && nameWords > 3) continue;
        }

        const serving = opfServingSuggestion(p);
        const defaultGrams = serving ? serving.grams : 100;

        candidates.push({
          name:         p.product_name.replace(/\b\w/g, c => c.toUpperCase()),
          kcal100:      kcal,
          p100:         prot,
          c100:         get(n, "carbohydrates_100g","carbohydrates"),
          f100:         get(n, "fat_100g","fat"),
          fi100:        get(n, "fiber_100g","fiber","fibers_100g"),
          su100:        get(n, "sugars_100g","sugars"),
          na100:        get(n, "sodium_100g","sodium") * 1000,
          grams:        defaultGrams,
          servingLabel: serving ? serving.label : null,
        });
        if (candidates.length >= 6) break;
      }

      // Merge: DB + branded results first, then OPF, dedupe by name
      const dbNames = new Set(dbResults.map(r => r.name.toLowerCase()));
      const merged = [...dbResults, ...candidates.filter(c => !dbNames.has(c.name.toLowerCase()))];
      if (!merged.length) {
        setLogErr(`No results found for "${searchTerm}". Try a more specific name, scan the barcode, or use Manual entry.`);
      } else {
        setNlpCandidates(merged.slice(0, 20));
        // V26 FIX 17: Save successful search to history
        saveSearchQuery(food);
      }
    } catch(e) {
      if (dbResults.length) {
        setNlpCandidates(dbResults);
      } else {
        const reason = e.message === "no_results"
          ? `"${searchTerm}" not found in Open Food Facts${searchTerm !== food ? ` (cleaned from "${food}")` : ""}. Try a more specific name or scan the barcode.`
          : `OPF search failed (${e.message}). Check your connection or use Manual entry.`;
        setLogErr(reason);
      }
    }
    setLogLoading(false);
  }

  // V43: confirmNlpCandidate opens the quantity modal instead of logging directly
  function confirmNlpCandidate(c) {
    setNlpModal(c);
    setNlpModalQty(String(c.grams || 100));
  }

  // V43: confirmModalLog -- called from the modal's Confirm button
  async function confirmModalLog(servingsOverride) {
    if (!nlpModal) return;
    // DEF-003: explicit zero guard — do not silently fall back to 100
    const baseQty = parseFloat(nlpModalQty);
    if (!baseQty || baseQty <= 0) {
      setNlpModalError("Please enter a quantity greater than 0");
      return;
    }
    // DEF-004: upper-bound cap
    if (baseQty > 2000) {
      setNlpModalError("Unusually large quantity — please check before logging");
      return;
    }
    setNlpModalError("");
    const servMult = parseFloat(servingsOverride) || 1;
    const totalQty = Math.round(baseQty * servMult * 10) / 10;
    const s = totalQty / 100;
    const displayName = servMult > 1
      ? `${nlpModal.name} (${baseQty}g ×${servMult})`
      : `${nlpModal.name} (${totalQty}g)`;
    await insertLog({
      name:     displayName,
      calories: +(nlpModal.kcal100 * s).toFixed(1),
      protein:  +(nlpModal.p100    * s).toFixed(1),
      carbs:    +(nlpModal.c100    * s).toFixed(1),
      fat:      +(nlpModal.f100    * s).toFixed(1),
      fibre:    +(nlpModal.fi100   * s).toFixed(1),
      sugar:    +(nlpModal.su100   * s).toFixed(1),
      sodium:   +(nlpModal.na100   * s).toFixed(1),
      source:   "OPF",
      source_food_id: nlpModal.dbId || null,
      source_table:   nlpModal.source === 'branded' ? 'branded_foods' : nlpModal.source === 'db' ? 'foods' : 'opf',
      logged_grams:   totalQty,
    });
    setLogOk(`\u2713 ${displayName}`);
    // Save search term to NLP history
    if (nlpFood.trim()) {
      const term = nlpFood.trim();
      setNlpHistory(prev => {
        const next = [term, ...prev.filter(h => h.toLowerCase() !== term.toLowerCase())].slice(0, 8);
        try { localStorage.setItem("np_nlp_history", JSON.stringify(next)); } catch(_){}
        return next;
      });
    }
    setNlpModal(null); setNlpModalQty("100"); setNlpModalError("");
    setNlpFood(""); setServingPreset(""); setNlpCandidates([]);
  }

  // ─── showCameraToast() ────────────────────────────────────────────────────
  // Displays a temporary toast for 4 seconds, then clears. Used for HTTPS warning.
  function showCameraToast(msg) {
    setCameraToast(msg);
    setTimeout(() => setCameraToast(""), 4000);
  }

  // ─── stopCamera() ─────────────────────────────────────────────────────────
  function stopCamera() {
    if (rafRef.current) { cancelAnimationFrame(rafRef.current); rafRef.current = null; }
    if (streamRef.current) {
      streamRef.current.getTracks().forEach(t => t.stop());
      streamRef.current = null;
    }
    setCameraActive(false);
    setCameraErr("");
    setVideoReady(false);
  }

  // ─── startCameraScanner() V16.2 ──────────────────────────────────────────
  //
  // GATE 1 — window.isSecureContext (PRIMARY)
  //   This is the canonical Web API for detecting secure contexts. It is a
  //   synchronous boolean, always accurate, and available in all modern browsers.
  //   It is FALSE for: http://192.168.x.x, http://10.0.x.x, any HTTP LAN IP.
  //   It is TRUE for: https://* and http://localhost (localhost is a special case
  //   exempted by the spec).
  //   V16.1 checked !navigator.mediaDevices instead. That's an indirect signal —
  //   some browsers (Chrome Android) define navigator.mediaDevices even on HTTP
  //   LAN IPs but then block getUserMedia silently, which is why the button
  //   "did nothing" on mobile. isSecureContext catches this correctly.
  //
  // GATE 2 — BarcodeDetector.getSupportedFormats()
  //   Async check that confirms the API is GPU-backed and initialised, not just
  //   present as a stub. Returns the list of supported barcode types so we can
  //   intersect with the formats we want. On some Android devices BarcodeDetector
  //   is present but getSupportedFormats() returns [] — we handle that case.
  //
  // GATE 3 — navigator.permissions.query diagnostic
  //   'denied'  → surface exact browser path to unblock. Do NOT call getUserMedia.
  //   'prompt'  → getUserMedia will trigger native dialog. Proceed.
  //   'granted' → proceed directly, no dialog needed.
  //   Not available → catch block proceeds to getUserMedia anyway.
  //   WHY THIS MATTERS ON MOBILE: on Android Chrome, if the page was backgrounded
  //   during a previous getUserMedia call that was in-flight, Chrome silently
  //   transitions the permission to 'denied' for the current session without
  //   showing a new prompt. Querying first lets us detect this and show a message
  //   instead of silently failing.
  //
  // GATE 4 — getUserMedia with constraint fallback ladder
  //   Some mobile devices report OverconstrainedError when asked for 1280×720 on
  //   the rear camera (particularly older Android flagships with restricted res).
  //   We retry with progressively relaxed constraints before giving up:
  //     Try A: { facingMode: environment, width:1280, height:720 }
  //     Try B: { facingMode: environment, width:640,  height:480 }
  //     Try C: { facingMode: environment } — bare, let browser decide resolution
  //   If all three fail: surface the error with the final error name and message.
  async function startCameraScanner() {
    setCameraErr("");
    setCameraSecureErr(false);

    // ── GATE 1: window.isSecureContext ────────────────────────────────────────
    if (!window.isSecureContext) {
      const origin = window.location.origin;
      setCameraSecureErr(true);
      showCameraToast("📡 Camera blocked. Switch to HTTPS or localhost.");
      setCameraErr(
        `Insecure context: "${origin}".` +
        `\nBarcodeDetector and getUserMedia require a secure context.` +
        `\nFix options:` +
        `\n  • Use http://localhost:3000 instead of a LAN IP.` +
        `\n  • Run: HTTPS=true npm start  (Create React App)` +
        `\n  • Run: expo start --https  (Expo)` +
        `\n  • Put Nginx/Caddy in front with a self-signed cert.`
      );
      return;
    }

    // navigator.mediaDevices guard — belt-and-suspenders after isSecureContext
    if (!navigator.mediaDevices?.getUserMedia) {
      setCameraErr(
        "navigator.mediaDevices.getUserMedia is not available. " +
        "This browser may not support camera access. Try Chrome 83+."
      );
      return;
    }

    // ── GATE 2: BarcodeDetector capability + format check ────────────────────
    if (!("BarcodeDetector" in window)) {
      setCameraErr(
        `BarcodeDetector API not found.` +
        `\nSupported: Chrome 83+, Chrome Android 83+, Edge 83+.` +
        `\nNot supported: Safari, Firefox. Use manual barcode entry below.`
      );
      return;
    }
    try {
      const supported = await window.BarcodeDetector.getSupportedFormats();
      if (supported.length === 0) {
        setCameraErr(
          "BarcodeDetector is present but reports no supported formats on this device. " +
          "Use manual barcode entry."
        );
        return;
      }
      // Intersect with food barcode formats — warn if key formats are missing
      const FOOD_FORMATS = ["ean_13","ean_8","upc_a","upc_e"];
      const available    = FOOD_FORMATS.filter(f => supported.includes(f));
      if (available.length === 0) {
        setCameraErr(
          `Device supports ${supported.join(", ")} but not EAN/UPC formats needed for food. ` +
          "Use manual entry."
        );
        return;
      }
      // Initialise detector with only confirmed-available formats
      detectorRef.current = new window.BarcodeDetector({
        formats: [...available, "code_128", "code_39"].filter(f => supported.includes(f)),
      });
    } catch(e) {
      setCameraErr(`BarcodeDetector init failed: ${e.message}`);
      return;
    }

    // ── GATE 3: navigator.permissions.query diagnostic ────────────────────────
    // Returns the permission state AND logs it to cameraErr briefly so mobile
    // users can see what the browser actually thinks the permission is.
    let permState = "unknown";
    try {
      const perm = await navigator.permissions.query({ name: "camera" });
      permState  = perm.state;  // "granted" | "prompt" | "denied"

      if (perm.state === "denied") {
        setCameraErr(
          `Camera permission: DENIED.` +
          `\nThe browser has blocked camera access for this origin.` +
          `\nTo fix on Android Chrome:` +
          `\n  1. Tap the lock/info icon in the address bar.` +
          `\n  2. Tap Permissions → Camera → Allow.` +
          `\n  3. Reload the page.` +
          `\nTo fix on desktop Chrome: Settings → Privacy → Site settings → Camera → find "${window.location.origin}" → Allow.`
        );
        return;
      }
      // state === "prompt": getUserMedia will trigger the browser dialog — proceed
      // state === "granted": no dialog needed — proceed directly
    } catch(_) {
      // navigator.permissions.query not supported (Firefox, iOS Safari, some
      // old Android WebViews) — proceed to getUserMedia and let it handle it.
      permState = "query-unsupported";
    }

    // ── GATE 4: getUserMedia with constraint fallback ladder ──────────────────
    const CONSTRAINT_LADDER = [
      { facingMode:{ ideal:"environment" }, width:{ ideal:1280 }, height:{ ideal:720 } },
      { facingMode:{ ideal:"environment" }, width:{ ideal:640  }, height:{ ideal:480 } },
      { facingMode:{ ideal:"environment" } },
    ];
    let stream = null;
    let lastErr = null;
    for (const videoConstraints of CONSTRAINT_LADDER) {
      try {
        stream = await navigator.mediaDevices.getUserMedia({ video:videoConstraints, audio:false });
        break;  // success — exit ladder
      } catch(e) {
        lastErr = e;
        if (e.name === "NotAllowedError") break;  // denied — no point retrying
        if (e.name === "NotFoundError")   break;  // no camera — no point retrying
        // OverconstrainedError or other — try next rung
      }
    }

    if (!stream) {
      const name = lastErr?.name || "UnknownError";
      const msg  = lastErr?.message || "No details available";
      if (name === "NotAllowedError") {
        setCameraErr(
          "Camera access was denied. Please enable camera permissions for Lithe in your Android settings."
        );
      } else if (name === "NotFoundError") {
        setCameraErr("No camera device found. Connect a camera or use manual barcode entry.");
      } else {
        setCameraErr(
          `Camera failed after all constraint attempts.` +
          `\nError: ${name} — ${msg}` +
          `\nPermission state: ${permState}` +
          `\nOrigin: ${window.location.origin}`
        );
      }
      return;
    }

    // Stream acquired. Store it in the ref and flip cameraActive.
    // DO NOT touch videoRef here — the <video> element is conditionally rendered
    // on cameraActive, so it does not exist in the DOM yet at this point.
    // The useEffect(,[cameraActive]) hook below runs after React commits the
    // <video> mount and is the correct place to assign srcObject.
    streamRef.current = stream;
    setVideoReady(false);
    setCameraActive(true);

    // ── Scan loop ─────────────────────────────────────────────────────────────
    const scan = async () => {
      if (!videoRef.current || videoRef.current.readyState < 2) {
        rafRef.current = requestAnimationFrame(scan); return;
      }
      try {
        const codes = await detectorRef.current.detect(videoRef.current);
        if (codes.length > 0) {
          const digits = codes[0].rawValue.replace(/\D/g, "");
          if (digits.length >= 8) {
            stopCamera();
            setBarcode(digits);
            await lookupProduct(digits);
            return;
          }
        }
      } catch(_) {}
      rafRef.current = requestAnimationFrame(scan);
    };
    rafRef.current = requestAnimationFrame(scan);
  }

  // ─── BARCODE STATE MACHINE — lookupProduct / confirmLog ──────────────────
  //
  // lookupProduct(code): called by the scan loop (camera) or the manual entry
  //   button. Fetches OPF data, stores raw per-100g nutrients in scannedProduct,
  //   and transitions to "review" state WITHOUT logging anything.
  //
  // confirmLog(): called when the user presses "Add to Log" in the review screen.
  //   Reads barcodeQty/barcodeUnit, scales the stored per-100g values, calls
  //   insertLog(), then resets to "idle".
  //
  // stopCamera is called inside lookupProduct (before the fetch) so the camera
  // releases its track immediately on detection — no wasted power during review.

  async function lookupProduct(code) {
    if (!mealType) { setLogErr("⚠ Select a meal type first."); return; }
    setLogLoading(true); setLogErr("");
    try {
      // V28: Check branded_foods DB first before hitting Open Food Facts
      try {
        const { data: branded } = await supabase
          .from("branded_foods")
          .select("id,name,brand,calories,protein,carbs,fat,fibre,sugar,sodium,serving_g,serving_label,barcode")
          .eq("barcode", code)
          .single();
        if (branded) {
          const g = parseFloat(branded.serving_g) || 100;
          const scale = g > 0 ? (100 / g) : 1;
          setScannedProduct({
            name:         `${branded.name}${branded.brand ? ` (${branded.brand})` : ""}`,
            kcal100:      Math.round(parseFloat(branded.calories || 0) * scale * 10) / 10,
            p100:         Math.round(parseFloat(branded.protein  || 0) * scale * 10) / 10,
            c100:         Math.round(parseFloat(branded.carbs    || 0) * scale * 10) / 10,
            f100:         Math.round(parseFloat(branded.fat      || 0) * scale * 10) / 10,
            fi100:        Math.round(parseFloat(branded.fibre    || 0) * scale * 10) / 10,
            su100:        Math.round(parseFloat(branded.sugar    || 0) * scale * 10) / 10,
            na100:        Math.round(parseFloat(branded.sodium   || 0) * scale * 10) / 10,
            servingGrams: g,
            servingLabel: branded.serving_label || null,
          });
          setBarcodeQty(String(g));
          setBarcodeStep("review");
          saveBarcodeHistory(code, {
            name: branded.name,
            calories: parseFloat(branded.calories || 0),
            protein:  parseFloat(branded.protein  || 0),
            carbs:    parseFloat(branded.carbs    || 0),
            fat:      parseFloat(branded.fat      || 0),
          });
          setLogLoading(false);
          return; // Found in branded DB — skip OPF entirely
        }
      } catch(_) { /* No match or query error — fall through to OPF */ }

      // V83: Check foods table by barcode
      try {
        const { data: wholeFood } = await supabase
          .from("foods")
          .select("id,name,calories_per_100g,protein_per_100g,carbs_per_100g,fat_per_100g,fibre_per_100g,sugar_per_100g,sodium_per_100g")
          .eq("barcode", code)
          .limit(1);
        if (wholeFood?.length > 0) {
          const wf = wholeFood[0];
          setScannedProduct({
            name:         wf.name || "Food Item",
            kcal100:      parseFloat(wf.calories_per_100g || 0),
            p100:         parseFloat(wf.protein_per_100g  || 0),
            c100:         parseFloat(wf.carbs_per_100g    || 0),
            f100:         parseFloat(wf.fat_per_100g      || 0),
            fi100:        parseFloat(wf.fibre_per_100g    || 0),
            su100:        parseFloat(wf.sugar_per_100g    || 0),
            na100:        parseFloat(wf.sodium_per_100g   || 0),
            servingGrams: null,
            servingLabel: null,
          });
          setBarcodeQty("100");
          setBarcodeStep("review");
          saveBarcodeHistory(code, {
            name: wf.name,
            calories: parseFloat(wf.calories_per_100g || 0),
            protein:  parseFloat(wf.protein_per_100g  || 0),
            carbs:    parseFloat(wf.carbs_per_100g    || 0),
            fat:      parseFloat(wf.fat_per_100g      || 0),
          });
          setLogLoading(false);
          return; // Found in foods table — skip OPF
        }
      } catch(_) { /* No barcode column or no match — fall through to OPF */ }

      // V84: try country subdomain first, fall back to world if not found
      const tryOPF = async (subdom) => {
        const ctrl = new AbortController();
        const timer = setTimeout(() => ctrl.abort(), 20000);
        try {
          const r = await fetch(OPF_URL(code, subdom), { signal: ctrl.signal });
          clearTimeout(timer);
          return await r.json();
        } catch(e) {
          clearTimeout(timer);
          if (e.name === "AbortError") throw new Error("Food database is taking too long. Check your connection or try again.");
          throw e;
        }
      };
      let data = await tryOPF(country);
      if (data.status !== 1 && country !== "world") {
        try { const d2 = await tryOPF("world"); if (d2.status === 1) data = d2; } catch(_) {}
      }
      if (data.status !== 1) {
        setLogErr("Product not found in our database. You can search by name or enter macros manually.");
        setLogLoading(false);
        return;
      }
      // V83: Cross-reference OPF result against local branded_foods by name
      const opfName = (data.product.product_name || "").toLowerCase().trim();
      if (opfName && opfName.length > 3) {
        try {
          const { data: nameMatch } = await supabase
            .from("branded_foods")
            .select("id,name,brand,calories,protein,carbs,fat,fibre,sugar,sodium,serving_g,serving_label,barcode")
            .ilike("name", `%${opfName.slice(0, 25)}%`)
            .limit(1);
          if (nameMatch?.length > 0) {
            const bf = nameMatch[0];
            const g = parseFloat(bf.serving_g) || 100;
            const scale = g > 0 ? (100 / g) : 1;
            setScannedProduct({
              name:         `${bf.name}${bf.brand ? ` (${bf.brand})` : ""}`,
              kcal100:      Math.round(parseFloat(bf.calories || 0) * scale * 10) / 10,
              p100:         Math.round(parseFloat(bf.protein  || 0) * scale * 10) / 10,
              c100:         Math.round(parseFloat(bf.carbs    || 0) * scale * 10) / 10,
              f100:         Math.round(parseFloat(bf.fat      || 0) * scale * 10) / 10,
              fi100:        Math.round(parseFloat(bf.fibre    || 0) * scale * 10) / 10,
              su100:        Math.round(parseFloat(bf.sugar    || 0) * scale * 10) / 10,
              na100:        Math.round(parseFloat(bf.sodium   || 0) * scale * 10) / 10,
              servingGrams: g,
              servingLabel: bf.serving_label || null,
            });
            setBarcodeQty(String(g));
            setBarcodeStep("review");
            saveBarcodeHistory(code, {
              name: bf.name,
              calories: parseFloat(bf.calories || 0),
              protein:  parseFloat(bf.protein  || 0),
              carbs:    parseFloat(bf.carbs    || 0),
              fat:      parseFloat(bf.fat      || 0),
            });
            setLogLoading(false);
            return; // Prefer local branded data over OPF
          }
        } catch(_) { /* name cross-ref failed — continue with OPF data */ }
      }
      const n    = data.product.nutriments;
      const name = data.product.product_name || "Unknown Product";
      const barcodeServing = opfServingSuggestion(data.product);
      setScannedProduct({
        name,
        kcal100:      parseFloat(n["energy-kcal_100g"] || n["energy-kcal"]) || 0,
        p100:         parseFloat(n["proteins_100g"]     || n["proteins"])    || 0,
        c100:         parseFloat(n["carbohydrates_100g"]|| n["carbohydrates"])|| 0,
        f100:         parseFloat(n["fat_100g"]          || n["fat"])         || 0,
        fi100:        parseFloat(n["fiber_100g"]        || n["fibers_100g"]  || n["fiber"]) || 0,
        su100:        parseFloat(n["sugars_100g"]       || n["sugars"])      || 0,
        na100:        (parseFloat(n["sodium_100g"]      || n["sodium"])      || 0) * 1000,
        servingGrams: barcodeServing ? barcodeServing.grams : null,
        servingLabel: barcodeServing ? barcodeServing.label : null,
      });
      // Pre-fill qty with detected serving size instead of 100g
      if (barcodeServing) setBarcodeQty(String(barcodeServing.grams));
      else setBarcodeQty("100");
      setBarcodeStep("review");
      // V26 FIX 18: Save barcode to history
      saveBarcodeHistory(code, {
        name,
        calories: parseFloat(n["energy-kcal_100g"] || n["energy-kcal"]) || 0,
        protein:  parseFloat(n["proteins_100g"]     || n["proteins"])    || 0,
        carbs:    parseFloat(n["carbohydrates_100g"]|| n["carbohydrates"])|| 0,
        fat:      parseFloat(n["fat_100g"]          || n["fat"])         || 0,
      });
    } catch(e) {
      setLogErr("Lookup failed: " + e.message);
    }
    setLogLoading(false);
  }

  async function confirmLog(servingsOverride) {
    if (!scannedProduct) return;
    if (!mealType) { setLogErr("⚠ Select a meal type first."); return; }
    const baseQty = parseFloat(barcodeQty) || 100;
    const servMult = parseFloat(servingsOverride) || 1;
    const totalQty = Math.round(baseQty * servMult * 10) / 10;
    const s   = totalQty / 100;
    const displayName = servMult > 1
      ? `${scannedProduct.name} (${baseQty}${barcodeUnit} ×${servMult})`
      : `${scannedProduct.name} (${totalQty}${barcodeUnit})`;
    await insertLog({
      name:     displayName,
      calories: scannedProduct.kcal100 * s,
      protein:  scannedProduct.p100    * s,
      carbs:    scannedProduct.c100    * s,
      fat:      scannedProduct.f100    * s,
      fibre:    scannedProduct.fi100   * s,
      sugar:    scannedProduct.su100   * s,
      sodium:   scannedProduct.na100   * s,
      source_food_id: null,
      source_table:   'opf',
      logged_grams:   totalQty,
    });
    setLogOk(`✓ ${displayName}`);
    setScannedProduct(null);
    setBarcode("");
    setBarcodeQty("100");
    setBarcodeStep("idle");
    // V47: Stop camera and return to natural mode after barcode log
    try { stopCamera(); } catch(_) {}
    setLogMode("nlp");
  }

  async function saveManual() {
    if(!mealType){setLogErr("⚠ Select a meal type first.");return;}
    if(!manual.name.trim()){setLogErr("Enter a food name.");return;}
    await insertLog({
      name:     manual.name,
      calories: parseFloat(manual.calories)||0,
      protein:  parseFloat(manual.protein) ||0,
      carbs:    parseFloat(manual.carbs)   ||0,
      fat:      parseFloat(manual.fat)     ||0,
      fibre:    parseFloat(manual.fibre)   ||0,
      sugar:    parseFloat(manual.sugar)   ||0,
      sodium:   parseFloat(manual.sodium)  ||0,
      source_food_id: null, source_table: null, logged_grams: null,
    });
    setManual({name:"",calories:"",protein:"",carbs:"",fat:"",fibre:"",sugar:"",sodium:"",volume:""});
    setLogOk(`✓ ${manualUnit==="ml"?"Drink":"Entry"} added`);
  }

  // ─── SAVE DAY TO HISTORY ───────────────────────────────────────────────────
  // saveDayToHistory: persists today's calorie total to the day_history JSONB
  // column on the profiles table. Uses a direct targeted upsert rather than
  // routing through saveProfile() — avoids any stale-closure risk on the full
  // profile payload and makes the intent unambiguous.
  // Replaces an existing entry for today if present; appends otherwise.
  // Keeps last 30 days; anything older is trimmed from the front.
  // snapshotDay — auto-upserts today's totals into day_history.
  // Called silently after any food/water/weight mutation — no user action needed.
  // Uses a functional state read via setDayHistory callback to always get fresh state.
  // waterOverride: pass the NEW water value when called from syncWater to avoid
  // stale-closure bug where setWaterMl(next) hasn't committed yet at call time.
  // V25 FIX 3: Supabase upsert moved outside the state updater callback.
  async function snapshotDay(overrideTotals, waterOverride) {
    if (!session) return;
    const today = TODAY_ISO();
    const snap  = overrideTotals || totals;
    const entry = {
      date:     today,
      calories: Math.round(snap.calories),
      target:   targets.calories,
      protein:  Math.round(snap.protein),
      carbs:    Math.round(snap.carbs   || 0),
      fibre:    Math.round(snap.fibre   || 0),
      water:    waterOverride !== undefined ? waterOverride : waterMl,
      fat:      Math.round(snap.fat     || 0),
    };
    let updatedSnapshot = null;
    setDayHistory(prev => {
      const updated = prev.find(d => d.date === today)
        ? prev.map(d => d.date === today ? entry : d)
        : [...prev, entry].slice(-30);
      updatedSnapshot = updated;
      return updated;
    });
    // Persist asynchronously outside state updater — fire-and-forget
    if (updatedSnapshot) {
      supabase.from("profiles")
        .upsert({ id: session.user.id, day_history: updatedSnapshot }, { onConflict: "id" })
        .then(({ error }) => { if (error && process.env.NODE_ENV !== "production") { console.error("[snapshotDay]", error); } });
    }
  }

  // ─── AI SERVICE — parseCpResp ──────────────────────────────────────────────
  // V47: Only used when loading last_audit from Supabase (stored JSON string).
  // Live audit results go directly into setCpMetabolic / setCpTactical / setCpOutlook.
  // Tries JSON first; falls back to ### split for audits stored before V14.5.
  function parseCpResp(raw) {
    if (!raw) return null;
    const cleaned = raw.replace(/```json|```/g, "").trim();
    try {
      const obj = JSON.parse(cleaned);
      // V40 5-field format
      if (obj.headline || obj.right_now || obj.recovery) return obj;
      // Old 3-field format — map to new field names
      if (obj.metabolic_review || obj.tactical_recovery) return {
        headline: "", right_now: obj.metabolic_review || "", recovery: obj.tactical_recovery || "",
        outlook: obj.outlook || "", action: "",
      };
    } catch (_) {}
    const parts = raw.split(/###|\n###/).map(s => s.trim()).filter(Boolean);
    return {
      headline: "", right_now: parts[0] || "", recovery: parts[1] || "",
      outlook: parts[2] || "", action: "",
    };
  }

  // ─── AI SERVICE — splitAuditResponse ──────────────────────────────────────
  // Parses the raw LLM string into { metabolic_review, tactical_recovery, outlook }.
  // Three strategies in order of confidence. Never returns null — always gives
  // the caller something meaningful to display in all three UI boxes.
  // V40: 5-field audit response parser (headline, right_now, recovery, outlook, action)
  // Backward compat: also handles old 3-field format (metabolic_review, tactical_recovery, outlook)
  function splitAuditResponse(raw) {
    const EMPTY_5 = { headline:"", right_now:"", recovery:"", outlook:"", action:"" };
    if (!raw || typeof raw !== "string") {
      return { ...EMPTY_5, right_now: "No response received from the AI endpoint.", recovery: "Check that /api/chat is reachable.", outlook: "Retry once the endpoint is confirmed reachable." };
    }

    let s = raw
      .replace(/<think>[\s\S]*?<\/think>/gi, "")
      .replace(/\[THINK\][\s\S]*?\[\/THINK\]/gi, "")
      .replace(/\[THINKING\][\s\S]*?\[\/THINKING\]/gi, "")
      .replace(/<reasoning>[\s\S]*?<\/reasoning>/gi, "")
      .replace(/```json/gi, "").replace(/```/g, "").trim();

    const firstBrace = s.indexOf("{");
    const lastBrace  = s.lastIndexOf("}");
    if (firstBrace !== -1 && lastBrace > firstBrace) {
      const candidate = s.slice(firstBrace, lastBrace + 1);
      try {
        const obj = JSON.parse(candidate);
        // New 5-field format
        if (obj.headline || obj.right_now || obj.recovery) {
          return _sanitiseAuditFields({
            headline:  String(obj.headline  || "").trim(),
            right_now: String(obj.right_now || "").trim(),
            recovery:  String(obj.recovery  || "").trim(),
            outlook:   String(obj.outlook   || "").trim(),
            action:    String(obj.action    || "").trim(),
          });
        }
        // Old 3-field backward compat
        if (obj.metabolic_review || obj.tactical_recovery) {
          return _sanitiseAuditFields({
            headline:  "",
            right_now: String(obj.metabolic_review  || "").trim(),
            recovery:  String(obj.tactical_recovery || "").trim(),
            outlook:   String(obj.outlook           || "").trim(),
            action:    "",
          });
        }
      } catch (_) {}
    }

    // Regex key extraction fallback
    function extractKey(text, key) {
      const pattern = new RegExp(`"${key}"\\s*:\\s*"((?:[^"\\\\]|\\\\.)*)"`, "s");
      const m = text.match(pattern);
      return m ? m[1].replace(/\\n/g, "\n").replace(/\\"/g, '"') : "";
    }
    // Try new keys first
    const hl = extractKey(s, "headline");
    const rn = extractKey(s, "right_now");
    const rc = extractKey(s, "recovery");
    const ol = extractKey(s, "outlook");
    const ac = extractKey(s, "action");
    if (rn || rc || ol) {
      return _sanitiseAuditFields({ headline: hl.trim(), right_now: rn.trim(), recovery: rc.trim(), outlook: ol.trim(), action: ac.trim() });
    }
    // Try old keys
    const mr = extractKey(s, "metabolic_review");
    const tr = extractKey(s, "tactical_recovery");
    const ol2 = extractKey(s, "outlook") || ol;
    if (mr || tr) {
      return _sanitiseAuditFields({ headline: "", right_now: mr.trim(), recovery: tr.trim(), outlook: ol2.trim(), action: "" });
    }

    if (process.env.NODE_ENV !== "production") {
      console.warn("[splitAuditResponse] Could not parse. Raw:", s.slice(0, 300));
    }
    return _sanitiseAuditFields({ ...EMPTY_5, right_now: s.slice(0, 500) || "Empty response from model.", recovery: "Audit unavailable — please try again.", outlook: "If this persists, the AI service may be temporarily busy." });
  }

  // V25 FIX 10: final sanitisation for all audit output fields
  function _sanitiseAuditFields(obj) {
    const SAFE_FALLBACK = "Analysis unavailable. Please run the audit again.";
    for (const key of ["metabolic_review", "tactical_recovery", "outlook"]) {
      let val = String(obj[key] || "");
      val = val.replace(/[{}\[\]]/g, "").replace(/(?<![\\])\"/g, "").trim(); // strip stray JSON chars
      if (val.length > 500) val = val.slice(0, 500) + "…";
      obj[key] = val || SAFE_FALLBACK;
    }
    return obj;
  }

  // ─── AI SERVICE — runCopilot (Daily Audit tab) ────────────────────────────
  // V53: Pro-Rata Audit Law — three time windows with distinct tone constraints.
  //   Morning  05:00-11:59 : "Building" phase. No "failure"/"Accidental Keto" framing.
  //                          Focus on proactive fuelling for remaining ~14h.
  //   MidDay   12:00-17:00 : 50% benchmark. Flag deficit only if significantly behind pace.
  //   Evening  17:01-23:59 : Full audit. All language permitted. Final-state critique.
  // All profile variables (height, weight, weightGoal, physiqueGoal, persona) injected
  // dynamically — zero hard-coded values in system prompt logic.
  async function runCopilot() {
    if (process.env.NODE_ENV !== "production") console.log('[runCopilot] called with:', { persona, tdeeRaw: targets.tdeeRaw, goalMode, simpleGoal, targetsCal: targets.calories });
    // V24 FIX 8b: daily audit cap — free users get 3 per day
    if (!effectiveIsPremium) {
      const capKey = `audit_count_${session?.user?.id}_${TODAY_ISO()}`;
      try {
        const count = parseInt(localStorage.getItem(capKey) || "0", 10);
        if (count >= 3) {
          setPaywallReason("daily_limit");
          setShowPaywall(true);
          return;
        }
        localStorage.setItem(capKey, String(count + 1));
      } catch(_) {} // localStorage unavailable — allow gracefully
    }
    setCpLoading(true);
    setCpHeadline(""); setCpMetabolic(""); setCpTactical(""); setCpOutlook(""); setCpAction("");

    // ── Layer 1: Pace-based time window classification ──────────────────
    const currentHour = new Date().getHours();
    const currentMinute = new Date().getMinutes();
    const currentTimeStr = `${String(currentHour).padStart(2,"0")}:${String(currentMinute).padStart(2,"0")}`;
    const bedHour  = parseInt((bedTime||"23:00").split(":")[0], 10)  || 22;
    const wakeHour = parseInt((wakeTime||"07:00").split(":")[0], 10) || 7;
    const wakingWindowH   = Math.max(1, bedHour - wakeHour);
    const hoursElapsed    = Math.max(0, currentHour - wakeHour);
    const paceFraction    = Math.min(1, hoursElapsed / wakingWindowH);
    const hoursRemaining  = Math.max(1, bedHour - currentHour);

    // V101: paceFraction-based windows — adapts to user's actual wake/bed schedule
    const timeWindow =
      paceFraction < 0.33 ? "MORNING" :
      paceFraction < 0.67 ? "MIDDAY"  : "EVENING";

    const checkInLabel =
      timeWindow === "MORNING" ? "morning fuel check" :
      timeWindow === "MIDDAY"  ? "midday pace check"  :
                                 "end-of-day assessment";

    const timeWindowLabel = {
      MORNING: `MORNING (${currentTimeStr}) -- Day is BUILDING. ~${hoursRemaining}h remaining. ${Math.round(paceFraction*100)}% of waking day elapsed.`,
      MIDDAY:  `MID-DAY (${currentTimeStr}) -- 50% benchmark checkpoint. ~${hoursRemaining}h remaining. ${Math.round(paceFraction*100)}% of waking day elapsed.`,
      EVENING: `EVENING (${currentTimeStr}) -- Final audit window. Day is effectively closed. ${Math.round(paceFraction*100)}% of waking day elapsed.`,
    }[timeWindow];

    // ── Layer 2: Raw gap values ───────────────────────────────────────────
    const calConsumed = Math.round(totals.calories);
    const calDelta    = targets.calories - calConsumed;
    const isOver      = calDelta < 0;
    const proteinGap  = Math.round(targets.protein - totals.protein);
    const carbsGap    = Math.round(targets.carbs   - totals.carbs);
    const WATER_TARGET = hydrationTarget;
    const waterGap    = Math.max(0, WATER_TARGET - waterMl);

    // Expected calories at this point in the day based on linear pace
    const caloriesPaceTarget = Math.round(targets.calories * paceFraction);
    // "Significantly behind pace" = more than 25% of daily target short of expected pace
    const significantlyBehindPace =
      timeWindow === "MIDDAY" && calConsumed < (caloriesPaceTarget - targets.calories * 0.25);
    // V50: Clear pro-rata status for prompt injection
    const dayProgressPct = Math.round(paceFraction * 100);
    const proRataStatus = calConsumed >= caloriesPaceTarget
      ? `ON TRACK — ${calConsumed} kcal eaten, expected ~${caloriesPaceTarget} kcal by now`
      : `SLIGHTLY BEHIND PACE — ${calConsumed} kcal eaten, expected ~${caloriesPaceTarget} kcal by now`;
    const proRataProtein = Math.round(paceFraction * targets.protein);
    const proRataWater = Math.round(paceFraction * WATER_TARGET);
    const proteinProRataStatus = Math.round(totals.protein) >= proRataProtein
      ? `AHEAD — ${Math.round(totals.protein)}g eaten, expected ${proRataProtein}g by now`
      : `BEHIND — ${Math.round(totals.protein)}g eaten, expected ${proRataProtein}g by now`;
    const waterProRataStatus = waterMl >= proRataWater
      ? `AHEAD — ${waterMl}ml consumed, expected ${proRataWater}ml by now`
      : `BEHIND — ${waterMl}ml consumed, expected ${proRataWater}ml by now`;
    const actionTimeLabel = currentHour < 18 ? "DO THIS TODAY" : "DO THIS TOMORROW";

    // ── Pre-compute action — hardcoded in JS, model only applies persona voice ──
    const _calsBehind    = caloriesPaceTarget - calConsumed;
    const _proteinBehind = proRataProtein - Math.round(totals.protein);
    const _waterBehind   = proRataWater - waterMl;
    const actionPriority = _proteinBehind > 15
      ? `PROTEIN — user is ${Math.round(_proteinBehind)}g behind pro-rata protein target`
      : _waterBehind > 300
      ? `WATER — user needs to DRINK ${Math.round(_waterBehind)}ml more water. Action must say DRINK not EAT. Suggest drinking water now with a specific amount in ml.`
      : _calsBehind > 200
      ? `CALORIES — user is ${Math.round(_calsBehind)} kcal behind pro-rata calorie target`
      : `ON TRACK — all macros are at or ahead of pro-rata. Action should maintain momentum, not fix gaps.`;
    const actionForbidden = _proteinBehind <= 0
      ? `FORBIDDEN: Do not recommend eating protein urgently — protein is ahead of schedule.`
      : '';
    // Build the action text directly in JS — model just applies persona voice
    let actionInstruction;
    if (_proteinBehind > 15) {
      actionInstruction = `Eat ${Math.round(Math.min(_proteinBehind, 50))}g of protein now — chicken, eggs, Greek yoghurt, or a shake.`;
    } else if (_waterBehind > 500) {
      actionInstruction = `Drink ${Math.round(Math.min(_waterBehind, 750))}ml of water now — you still have ${Math.round(_waterBehind)}ml to hit your daily target.`;
    } else if (_calsBehind > 300) {
      actionInstruction = `Have a balanced meal in the next hour — aim for protein, carbs, and some fat to close the ${Math.round(_calsBehind)} kcal gap.`;
    } else {
      const nextMealTime = currentHour < 12 ? '13:00' : currentHour < 16 ? '18:00' : '20:00';
      actionInstruction = `Everything is on track — keep going. Have your next full meal by ${nextMealTime} with a good mix of protein, carbs, and fat.`;
    }

    // ── Layer 2c: Metabolic State Classification ──────────────────────────
    const netCarbs = Math.round(totals.carbs || 0);
    const metabolicState =
      netCarbs < 50   ? "Very Low Carb" :
      netCarbs <= 100 ? "Low Carb State"  :
      "Normal Carb State";

    const recentHistory = [...(dayHistory || [])]
      .filter(d => d.date < TODAY_ISO() && typeof d.carbs === "number")
      .sort((a, b) => b.date.localeCompare(a.date))
      .slice(0, 6);
    let consecutiveLowCarbDays = 0;
    for (const d of recentHistory) {
      if (d.carbs < 100) { consecutiveLowCarbDays++; } else { break; }
    }
    if (netCarbs < 100) consecutiveLowCarbDays++;
    const refeedAlert = consecutiveLowCarbDays >= 3;

    // ── Layer 3: Physiological pacing constraints ─────────────────────────
    const waterHourlyQuota = Math.round(waterGap / hoursRemaining);
    const waterCommand     = Math.min(500, waterHourlyQuota);
    const waterShort       = waterMl < WATER_TARGET;

    const proteinShort   = proteinGap > 15;
    const proteinDayFail = proteinGap > 80 && currentHour >= (bedHour - 3);
    const proteinCommand = proteinDayFail ? null : Math.min(40, Math.max(0, proteinGap));
    const carbBlackout   = currentHour >= (bedHour - 2) && carbsGap < 0;
    const fatGap         = Math.round((targets.fat || 0) - totals.fat);
    const fatShort       = fatGap > 10;

    // ── History-aware macro urgency ───────────────────────────────────────
    // Uses dayHistory (7-day daily totals) to estimate how much of each macro
    // the user typically logs in the REMAINING portion of the day.
    // Method: compute avg daily total for each macro from past 7 days, then
    // multiply by (1 - paceFraction) to estimate the expected remaining intake.
    // If that expected remainder covers >= 75% of today's gap, mark ON TRACK.
    const sevenAgoForHistory = new Date(); sevenAgoForHistory.setDate(sevenAgoForHistory.getDate() - 7);
    const sevenAgoISOHist = sevenAgoForHistory.toISOString().slice(0,10);
    const histDays = (dayHistory||[]).filter(d => d.date >= sevenAgoISOHist && d.calories > 0);

    function expectedRemainingMacro(macro) {
      if (histDays.length < 3) return null; // need at least 3 days of data
      const avg = histDays.reduce((s,d) => s + (parseFloat(d[macro])||0), 0) / histDays.length;
      // Expected remaining = avg daily total * fraction of day still remaining
      return Math.round(avg * (1 - paceFraction));
    }

    const histProteinRemaining = expectedRemainingMacro("protein");
    const histFatRemaining     = expectedRemainingMacro("fat");
    const histCarbsRemaining   = expectedRemainingMacro("carbs");

    const proteinOnTrack = proteinShort && !proteinDayFail &&
      histProteinRemaining !== null && histProteinRemaining >= proteinGap * 0.75;
    const fatOnTrack = fatShort &&
      histFatRemaining !== null && histFatRemaining >= fatGap * 0.75;
    const carbsOnTrack = carbsGap > 15 && !carbBlackout &&
      histCarbsRemaining !== null && histCarbsRemaining >= carbsGap * 0.75;

    // ── Layer 4: Pre-rendered tactical lines ─────────────────────────────
    // Lines are written as plain English instructions the model must follow.
    // ON TRACK lines explicitly forbid eat-now commands for that macro.
    const proteinSeverity = proteinShort ? (proteinDayFail ? 3 : proteinOnTrack ? 1 : 2) : 0;
    const carbSeverity    = carbBlackout ? 2 : 0;
    const waterSeverity   = waterShort   ? 1 : 0;
    const totalSeverity   = proteinSeverity + carbSeverity + waterSeverity;

    const tacLines = [
      proteinShort && (
        proteinDayFail
          ? `PROTEIN CRITICAL: ${proteinGap}g unrecoverable at ${currentHour}:00. Write off today. Tomorrow: 50g before 10:00.`
          : proteinOnTrack
          ? `PROTEIN ON TRACK: Gap is ${proteinGap}g. Based on your 7-day history you typically consume ~${histProteinRemaining}g protein in the remaining ${Math.round((1-paceFraction)*100)}% of your day. This gap is on track to close naturally. DO NOT issue an eat-now command for protein. Acknowledge it is on track.`
          : `PROTEIN URGENT: ${Math.round(totals.protein)}g of ${targets.protein}g consumed. Gap: ${proteinGap}g. Eat ${proteinCommand}g now. Distribute remaining ${Math.max(0,proteinGap-proteinCommand)}g across next ${hoursRemaining}h.`
      ),
      fatShort && !fatOnTrack && timeWindow !== "MORNING" &&
        `FAT URGENT: ${Math.round(totals.fat)}g of ${targets.fat}g consumed. Gap: ${fatGap}g. Include fat-dense foods in next meal.`,
      fatShort && fatOnTrack && timeWindow !== "MORNING" &&
        `FAT ON TRACK: Gap is ${fatGap}g. History shows ~${histFatRemaining}g fat typically consumed in remaining day. DO NOT command fat intake now.`,
      carbsGap > 15 && !carbBlackout && !carbsOnTrack && timeWindow !== "MORNING" &&
        `CARBS NOTE: ${Math.round(totals.carbs)}g of ${targets.carbs}g. Gap: ${Math.round(carbsGap)}g. Carb underage is not a failure -- do not flag as urgent.`,
      carbsGap > 15 && !carbBlackout && carbsOnTrack && timeWindow !== "MORNING" &&
        `CARBS ON TRACK: Gap is ${Math.round(carbsGap)}g. History shows ~${histCarbsRemaining}g carbs typically consumed in remaining day. DO NOT command carb intake.`,
      carbBlackout &&
        `CARB BLACKOUT: ${currentHour}:00. Carbs ${Math.abs(carbsGap)}g over target. Zero carbs until sleep.`,
      waterShort && (
        waterCommand === 0
          ? `WATER BLACKOUT: no further intake commanded.`
          : `WATER URGENT: ${waterMl}ml of ${WATER_TARGET}ml. Gap: ${waterGap}ml. Drink 500ml now.`
      ),
      !waterShort && !proteinShort && !carbBlackout && !fatShort &&
        `ALL CLEAR: All macros and hydration on track.`,
    ].filter(Boolean).join("\n");


    // ── CHANGE 1 & 2: Data maturity + recent history context ─────────────────
    // dataMaturity: controls audit depth instruction in system prompt
    const uniqueLoggedDays = new Set((dayHistory||[]).filter(d=>d.calories>0).map(d=>d.date)).size;
    const dataMaturity =
      uniqueLoggedDays < 5  ? "new"          :
      uniqueLoggedDays < 14 ? "establishing" :
      "established";

    // 7-day average calories + protein vs targets
    // V101 fix: use logHistory (from logs table via fetchThirtyDayLogs) — same source
    // as the Progress tab. dayHistory (profiles.day_history JSONB) was stale/incomplete.
    // V102 fix: exclude today from 7-day average — today is incomplete and skews the avg
    const today_iso = TODAY_ISO();
    const last7Days = (logHistory||[]).filter(d => d.logged && d.date !== today_iso && d.calories > 0).slice(-7);
    const hist7Count   = last7Days.length;
    const hist7AvgCal  = hist7Count > 0 ? Math.round(last7Days.reduce((s,d)=>s+(d.calories||0),0) / hist7Count) : 0;
    const hist7AvgProt = hist7Count > 0 ? Math.round(last7Days.reduce((s,d)=>s+(d.protein||0),0)  / hist7Count) : 0;
    const hist7CalDelta  = hist7AvgCal  - targets.calories;
    const hist7ProtDelta = hist7AvgProt - targets.protein;

    // Tracking consistency: logged days out of last 7 calendar days
    const last7CalendarDays = Array.from({length:7},(_,i)=>{
      const d=new Date(); d.setDate(d.getDate()-i); return d.toISOString().slice(0,10);
    });
    const daysWithLogs = last7CalendarDays.filter(d =>
      (logHistory||[]).some(h => h.date===d && h.logged)
    ).length;

    // Weight trend from last 4 weightLog entries
    const wLogForTrend = [...(weightLogs||[])].sort((a,b)=>new Date(a.logged_at)-new Date(b.logged_at)).slice(-4);
    let weightTrendBlock = "  Weight trend: insufficient weight data (fewer than 2 entries)";
    if (wLogForTrend.length >= 2) {
      const wFirst = parseFloat(wLogForTrend[0].weight_kg);
      const wLast  = parseFloat(wLogForTrend[wLogForTrend.length-1].weight_kg);
      const wDelta = +(wLast - wFirst).toFixed(2);
      const daySpan = Math.max(1, Math.round(
        (new Date(wLogForTrend[wLogForTrend.length-1].logged_at) - new Date(wLogForTrend[0].logged_at)) / 86400000
      ));
      const weeklyRate = +((wDelta / daySpan) * 7).toFixed(2);
      const trendLabel = Math.abs(wDelta) < 0.3 ? "STALLED" : wDelta > 0 ? "GAINING" : "LOSING";
      weightTrendBlock =
        `  Weight trend: ${trendLabel} | ${wFirst.toFixed(1)}kg -> ${wLast.toFixed(1)}kg over ${daySpan} days` +
        ` | Rate: ${weeklyRate > 0 ? "+" : ""}${weeklyRate}kg/week (based on last ${wLogForTrend.length} weigh-ins)`;
    }

    const RECENT_HISTORY_PROMPT =
`RECENT HISTORY
  7-day avg calories : ${hist7AvgCal > 0 ? hist7AvgCal : "no data"} kcal/day | Target: ${targets.calories} kcal/day | Delta: ${hist7CalDelta > 0 ? "+" : ""}${hist7CalDelta} kcal
  7-day avg protein  : ${hist7AvgProt > 0 ? hist7AvgProt : "no data"} g/day | Target: ${targets.protein}g/day | Delta: ${hist7ProtDelta > 0 ? "+" : ""}${hist7ProtDelta}g
  History confidence : ${hist7Count}/7 days with data in last 7-day window${hist7Count <= 1 ? " -- SINGLE DAY ONLY. Do NOT present this as a trend. See 7-DAY HISTORY LAW." : hist7Count < 3 ? " -- insufficient for reliable trend. Caveat any projection." : ""}
  Tracking consistency: ${daysWithLogs}/7 days logged in the last 7 calendar days
${weightTrendBlock}
  DATA MATURITY: ${dataMaturity.toUpperCase()} (${uniqueLoggedDays} days logged total)`;

    // ── Layer 5: JSON output contract ─────────────────────────────────────
    // V54: Three new rules added to contract:
    //   HYDRATION COMMAND LAW: no micro-math (no "Xml/h"). Bulk commands only.
    //   PHYSIQUE GOAL LAW: never parrot the user's physique goal string verbatim.
    //   DEFICIT LAW: 300-500 kcal deficit is the optimal recomposition zone --
    //     only flag as "muscle loss risk" if deficit significantly exceeds target.
    const JSON_CONTRACT =
      `OUTPUT: Single raw JSON object. Start with {, end with }. No markdown, no backticks, no preamble.\n` +
      `Schema: {"headline":"string","right_now":"string","recovery":"string","outlook":"string","action":"string"}. Plain sentences, no nested objects.\n` +
      `headline: One punchy sentence — the single verdict on today. What is the most important thing the data shows. Persona voice fully applied. No numbers needed here — this is the emotional hook.\n` +
      `right_now: What today's eating has done to the body right now. Reference every major gap or win with specific numbers. What is ahead of schedule, what is behind. Plain English. 4-6 sentences.\n` +
      `recovery: What to do before bed tonight and what to set up for tomorrow morning. Specific foods, specific amounts, specific times using the user's actual wake and bed time. Acknowledge the wins first. 3-5 sentences.\n` +
      `outlook: What the weekly pattern means for the goal. Reference the 7-day average vs target. What happens if today's pattern continues. Real-world impact on training and body. 3-4 sentences.\n` +
      `action: One single non-negotiable action. If morning/afternoon — for the rest of TODAY. If evening — for TOMORROW MORNING. Short. Specific time. Specific amount. No more than 2 sentences.\n` +
      `DO_THIS_TODAY_LAW: The ACTION_PRIORITY field in the prompt tells you exactly what to focus on — follow it precisely. If ACTION_PRIORITY says PROTEIN — write a protein-urgent action. If ACTION_PRIORITY says WATER — write a water action. If ACTION_PRIORITY says CALORIES — write a food/meal action. If ACTION_PRIORITY says ON TRACK — write a momentum-maintaining action, not a catch-up action. If the FORBIDDEN line says protein is ahead — do not mention eating protein urgently under any circumstances. WATER ACTIONS must always say "Drink Xml of water" — never "Eat water". Water is drunk not eaten.\n` +
      `RULES: No blood tests/medical labs. Metric only. No bullet points in values. No per-hour water math — bulk commands only ("Drink 500ml now"). PHYSIQUE GOAL RULE — MANDATORY: Never quote, reference, name, or paraphrase the physique_goal string. Do not mention any name, celebrity, athlete, or public figure from the physique goal. Use only generic language: "your physique goal" or "the look you are working towards". Quoting any part of physique_goal in the output is a violation. Use *_STATUS fields as authoritative. 7-day history required for outlook — if <3 days, say so.\n` +
      `SAFETY: Never diagnose, never recommend <1200 kcal/day. If disordered pattern detected, say "warrants review with a registered dietitian" and move on.\n` +
      `HIGHLIGHT MARKERS: In right_now, recovery, outlook, and action only — wrap the 1-2 most critical numbers per field in **double asterisks**: the calorie position and the single most urgent macro gap or action amount. Maximum 2 markers per field. Leave all other numbers plain. Example: "You have consumed **1,847 kcal** against your 2,332 target." No markers in headline.`;

    // ── Layer 6: Pro-Rata Audit Law — time-window constraints block ───────
    // Injected into BOTH system prompt and user prompt so model cannot ignore it.
    const PRO_RATA_MACROS_BLOCK = `PRO_RATA_MACROS:\n- Calories: ${proRataStatus}\n- Protein: ${proteinProRataStatus}\n- Water: ${waterProRataStatus}`;
    const PRO_RATA_LAW = timeWindow === "MORNING"
      ? `TIME_CONTEXT:\n- Current time: ${currentTimeStr}\n- Wake: ${wakeTime||"07:00"}, Bed: ${bedTime||"22:00"}\n- Day progress: ${dayProgressPct}% through waking hours (${hoursRemaining}h remaining)\n- Pro-rata calorie target by now: ${caloriesPaceTarget} kcal\n- Pro-rata status: ${proRataStatus}\n- IMPORTANT: The user has ${hoursRemaining} hours left to eat today. Do NOT treat current intake as the final day total.\n- This is MORNING — frame everything as building phase. No "failure" language. Low carbs at breakfast is normal. Focus on fuelling strategy for the rest of today.\n- ${actionTimeLabel}: Action must reference the rest of TODAY, not tomorrow morning.\n${PRO_RATA_MACROS_BLOCK}`
      : timeWindow === "MIDDAY"
      ? `TIME_CONTEXT:\n- Current time: ${currentTimeStr}\n- Wake: ${wakeTime||"07:00"}, Bed: ${bedTime||"22:00"}\n- Day progress: ${dayProgressPct}% through waking hours (${hoursRemaining}h remaining)\n- Pro-rata calorie target by now: ${caloriesPaceTarget} kcal\n- Pro-rata status: ${proRataStatus}\n- IMPORTANT: The user has ${hoursRemaining} hours left to eat today. Day is recoverable.\n- This is MIDDAY — assess pace. Flag protein/water gaps only if significantly behind.\n- ${actionTimeLabel}: Action must reference the rest of TODAY.\n${PRO_RATA_MACROS_BLOCK}`
      : `TIME_CONTEXT:\n- Current time: ${currentTimeStr}\n- Wake: ${wakeTime||"07:00"}, Bed: ${bedTime||"22:00"}\n- Day progress: ${dayProgressPct}% through waking hours (${hoursRemaining}h remaining)\n- Day is effectively over. Assess as final.\n- Do NOT say "you still have time." Prescribe tomorrow's strategy.\n- ${actionTimeLabel}: Action must reference TOMORROW MORNING.\n${PRO_RATA_MACROS_BLOCK}`;

    // ── Layer 7: Persona system prompts — V101 full rewrite ─────────────
    // MACRO PACING LAW governs Box 2 across all personas.
    // INSIGHT LAW with meal timing examples in all personas.
    // SUPPLEMENT LAW in all personas.
    // Banned word lists per persona enforce voice differentiation.

    // ── Shared laws block — trimmed for token efficiency ──
    const SHARED_LAWS =
        `INSIGHT: Tell the user what the data MEANS for their body and their goal, not what the numbers say. Reference meal timing and patterns.\n` +
        `SUPPLEMENT LAW: Never reference specific supplements, supplement timings, or supplement doses in the daily audit. The audit covers food, water, and training only.\n` +
        `TARGET WEIGHT: ${targetWeight ? `User target is ${targetWeight}kg. Reference this in outlook.` : `No target weight set.`}\n` +
        `Use *_STATUS fields as authoritative — never recalculate. Hitting target = ON TRACK. Missing = BEHIND.\n` +
        `Every sentence must reference a specific number. Stay in character throughout. Plain English only — no science jargon.\n` +
        `CONSISTENCY LAW: Cover these findings in order: (1) current body state from today's eating, (2) protein gap and what it means for the goal, (3) calorie position and what it means, (4) hydration and its impact, (5) workout credit or lack of it. No persona skips a finding. The FACTS are identical — only the VOICE changes.\n` +
        `UNDER_TARGET_LAW: The daily calorie target already contains the deficit to reach the goal. Being UNDER target = slightly ahead of schedule = POSITIVE. Being OVER target = slightly behind schedule = needs correction. Never frame under-target intake as "missing", "slowing progress", "a shortfall", or any negative language.\n` +
        `EXTRAPOLATION_LAW: Never multiply today's single-day gap by 7 and present it as a standalone number without labelling it clearly as a weekly total.\n` +
        `ACCURACY_LAW: Never calculate your own percentages or derive numbers not explicitly provided. Only use numbers that appear verbatim in the data.\n` +
        `WATER_LAW: Water intake cannot be carried over to tomorrow. If water is low, say "drink more tonight before bed".\n` +
        `STATE_LANGUAGE_LAW: Never say "Normal carb state is active" — describe plainly: "Your carb intake is normal today". Never say "ketogenic state" or "your body is in ketosis" — say "your carb intake is low today" or "you've eaten fewer carbs than usual today". Never say "thermoregulation" — say "affecting your energy and recovery".\n` +
        `TODAY_VS_WEEKLY_LAW: Always use "today" and "this week" explicitly to distinguish single-day data from the 7-day average.\n` +
        `TIME_AWARENESS_LAW: Always factor in what time of day it is. If it is morning (before 12:00), the user has most of the day ahead — do not treat current intake as a failure, assess against the pro-rata target for this time of day. If it is evening (after 18:00), gaps are real. Reference hours remaining explicitly.\n` +
        `PRO_RATA_LAW: Use the injected PRO_RATA_STATUS to frame RIGHT NOW. If the user is ON TRACK for this time of day, say so. Only flag a gap as urgent if significantly behind pro-rata AND fewer than 4 hours remaining. PACE FRAMING RULE: If PRO_RATA_STATUS is SLIGHTLY BEHIND PACE, frame the gap as manageable — "slightly behind pace" not "significantly behind" or "far below target". If PRO_RATA_STATUS is ON TRACK, you must acknowledge this explicitly in RIGHT NOW — never treat an on-track user as if they are failing. A SLIGHTLY BEHIND PACE user with fewer than 2 hours remaining should be treated as a real gap. A SLIGHTLY BEHIND PACE user with more than 4 hours remaining should be treated as recoverable. WORD BAN: Never use the word "significantly" anywhere in the output when PRO_RATA_STATUS is SLIGHTLY BEHIND PACE — this applies to calories, protein, fat, carbs, and water gaps equally. Use "slightly behind", "a little behind", or "not quite there yet" instead.\n` +
        `PRO_RATA_MACRO_LAW: Never say a macro is "behind" or "missing" if its pro-rata status shows it is AHEAD for this time of day. Only flag a macro as a concern if it is genuinely behind the pro-rata expectation for the current time.\n` +
        `TIME_LANGUAGE_LAW: Never say "going to bed" or "before bed" if it is before 16:00. Never say "tomorrow morning" in RECOVERY if it is still morning — focus on the rest of today instead.\n` +
        `${AI_SAFETY_LAW}\n` +
        `UK_LAW: Write in UK English. Use UK spelling throughout (e.g. "fibre" not "fiber", "colour" not "color"). Reference UK dietary guidelines where applicable.\n` +
        `PERSONA_LAW: Apply the selected persona voice consistently across every sentence. Never break character.\n`;

    // PROMPT_VERSION: V55
    const SYSTEM = {
      // ── CRITICAL ────────────────────────────────────────────────────────
      Critical:
        `You write daily nutrition coaching in a direct, blunt, plain-English style. Short punchy sentences. You call out every failing with its specific number and consequence. You acknowledge one thing done right. You give commands not suggestions. No science jargon whatsoever — never use "leucine", "MPS", "glycogen", "substrate", "anabolic", "catabolic", "pro-rata".\n\n` +
        `EXAMPLE OF YOUR WRITING STYLE:\n"345 calories. That is what you gave your body today. You are trying to get to ${targetWeight||75}kg looking lean and athletic — and you ate 345 calories. 18g of protein when your body needs 180g means your body has been breaking itself down today, not building. Not a drop of water. The only thing you did right today was log it. Now fix it."\n\n` +
        `TASK: ${checkInLabel}. Profile: ${height}cm, ${targets.calories}kcal / P:${targets.protein}g / C:${targets.carbs}g / F:${targets.fat}g. Target weight: ${targetWeight || "not set"}kg. Goal: "${sanitiseForPrompt(physiqueGoal)||"not set"}"\n` +
        `metabolic_review (4-6 sentences): What today's eating has done to the body. Numbers. What it means for ${targetWeight||"the"}kg goal.\n` +
        `tactical_recovery (4-6 sentences): How to recover before bed at ${bedTime||"23:00"}. Specific foods and amounts. Commands.\n` +
        `outlook (4-6 sentences): What happens if this continues. Single command for tomorrow.\n` +
        `${SHARED_LAWS}${PRO_RATA_LAW}\n${JSON_CONTRACT}`,

      // ── BALANCED ────────────────────────────────────────────────────────
      Balanced:
        `You write daily nutrition coaching in a clear, honest, plain-English style. You explain what is happening and why it matters. You acknowledge what went well and what needs fixing. You write in flowing sentences — not bullet points, not lists. No science jargon whatsoever — never use "leucine", "MPS", "glycogen", "substrate", "anabolic", "catabolic", "pro-rata".\n\n` +
        `EXAMPLE OF YOUR WRITING STYLE:\n"Today your body has been notably underfuelled — 345 calories consumed against a 2171 target means your energy, recovery, and fat loss have all taken a hit. The most important gap is protein: with only 18g eaten against a 180g daily target, your body has been more likely to burn through muscle today rather than fat, which works against the ${targetWeight||75}kg goal. No water consumed means everything from your energy levels to joint recovery has been running below where it should be."\n\n` +
        `TASK: ${checkInLabel}. Profile: ${height}cm, ${targets.calories}kcal / P:${targets.protein}g / C:${targets.carbs}g / F:${targets.fat}g. Target weight: ${targetWeight || "not set"}kg. Goal: "${sanitiseForPrompt(physiqueGoal)||"not set"}"\n` +
        `metabolic_review (4-6 sentences): Snapshot of right now. What today's eating has done. What it means for the ${targetWeight||"target"}kg goal.\n` +
        `tactical_recovery (4-6 sentences): How to recover and set up tomorrow. Specific foods. Bed time ${bedTime||"23:00"}, wake ${wakeTime||"07:00"}. What went well.\n` +
        `outlook (4-6 sentences): What happens if this pattern continues. Connect to ${targetWeight||"target"}kg. Single most important change.\n` +
        `${SHARED_LAWS}${PRO_RATA_LAW}\n${JSON_CONTRACT}`,

      // ── MOTIVATIONAL ────────────────────────────────────────────────────
      Motivational:
        `You write daily nutrition coaching in an energetic, plain-English style. Every sentence references a specific number from the data. You frame every problem as something fixable. You write in flowing sentences — not bullet points, not lists. No science jargon whatsoever — never use "leucine", "MPS", "glycogen", "substrate", "anabolic", "catabolic", "pro-rata".\n\n` +
        `EXAMPLE OF YOUR WRITING STYLE:\n"Right now your body is running on fumes — 345 calories eaten with the day almost done means your muscles and energy systems have had almost nothing to work with. You are sitting 1826 calories short of your 2171 target, and with 0ml of water consumed all day, every system in your body has been working harder than it needs to. The good news? You have time before bed to change the story tonight!"\n\n` +
        `TASK: ${checkInLabel}. Profile: ${height}cm, ${targets.calories}kcal / P:${targets.protein}g / C:${targets.carbs}g / F:${targets.fat}g. Target weight: ${targetWeight || "not set"}kg. Goal: "${sanitiseForPrompt(physiqueGoal)||"not set"}"\n` +
        `metabolic_review (4-6 sentences): Open with biggest win and its number. Each gap framed as opportunity still available.\n` +
        `tactical_recovery (4-6 sentences): Forward-looking fuel plan. Wake ${wakeTime||"07:00"}, bed ${bedTime||"23:00"}. One exciting target.\n` +
        `outlook (4-6 sentences): What they are BUILDING towards. Connect to ${targetWeight||"target"}kg. Forward momentum.\n` +
        `${SHARED_LAWS}${PRO_RATA_LAW}\n${JSON_CONTRACT}`,
    };

    // ── Layer 8: User prompt — hard facts only, no instructions ──────────
    const fatOver            = Math.round(totals.fat - targets.fat);
    const carbsUnder         = Math.round(targets.carbs - totals.carbs);
    const accidentalKeto     = fatOver > 20 && carbsUnder > 50;

    // ── Explicit over/under status fields (authoritative for AI) ──────────
    const calsOver   = Math.round(calConsumed - targets.calories);
    const calsStatus = calsOver >= 0
      ? 'OVER target by ' + calsOver + ' kcal'
      : 'UNDER target by ' + Math.abs(calsOver) + ' kcal';
    const proteinOver   = Math.round(totals.protein - targets.protein);
    const proteinStatus = proteinOver >= 0
      ? 'OVER target by ' + proteinOver + 'g'
      : 'UNDER target by ' + Math.abs(proteinOver) + 'g';
    const carbsStatus = carbsUnder >= 0
      ? 'UNDER target by ' + carbsUnder + 'g'
      : 'OVER target by ' + Math.abs(carbsUnder) + 'g';
    const fatStatus = fatOver >= 0
      ? 'OVER target by ' + fatOver + 'g'
      : 'UNDER target by ' + Math.abs(fatOver) + 'g';
    const waterOverVal = Math.round(waterMl - WATER_TARGET);
    const waterStatus  = waterOverVal >= 0
      ? 'OVER target by ' + waterOverVal + 'ml'
      : 'UNDER target by ' + Math.abs(waterOverVal) + 'ml';
    const fibreStatus = (totals.fibre||0) >= (targets.fibre||30)
      ? `ON TRACK — ${Math.round(totals.fibre||0)}g logged vs ${targets.fibre||30}g target`
      : `UNDER target by ${Math.round((targets.fibre||30) - (totals.fibre||0))}g`;
    const sugarStatus = `${Math.round(totals.sugar||0)}g logged${(totals.sugar||0) > 30 ? ' — ELEVATED (above 30g)' : ' — within range'}`;
    const sodiumStatus = `${Math.round(totals.sodium||0)}mg logged${(totals.sodium||0) > 2300 ? ' — ELEVATED (above 2300mg)' : ' — within range'}`;

    // ── FIX 5: Meal log + timing analysis ─────────────────────────────────
    const sortedMeals = logs.slice().sort((a,b) => new Date(a.logged_at) - new Date(b.logged_at)).slice(0, 12);
    const mealLogBlock = sortedMeals.length > 0
      ? sortedMeals.map(l =>
          `  ${l.meal_type} | ${l.name} | ${Math.round(l.calories||0)}kcal | P:${Math.round(l.protein||0)}g | C:${Math.round(l.carbs||0)}g | F:${Math.round(l.fat||0)}g | ${new Date(l.logged_at).toLocaleTimeString("en-GB",{hour:"2-digit",minute:"2-digit"})}`
        ).join("\n")
      : "  No meals logged yet";

    const mealsByHour = logs.reduce((acc, l) => {
      const h = new Date(l.logged_at).getHours();
      const slot = h < 12 ? "morning" : h < 17 ? "afternoon" : "evening";
      acc[slot] = (acc[slot] || 0) + (parseFloat(l.calories) || 0);
      return acc;
    }, {});
    const proteinBySlot = logs.reduce((acc, l) => {
      const h = new Date(l.logged_at).getHours();
      const slot = h < 12 ? "morning" : h < 17 ? "afternoon" : "evening";
      acc[slot] = (acc[slot] || 0) + (parseFloat(l.protein) || 0);
      return acc;
    }, {});

    // ── FIX 6: Pre-compute 30-day projection ──────────────────────────────
    // V102 fix: correct sign convention.
    //   calDeltaDaily = avg - target. Negative = deficit (eating less). Positive = surplus.
    //   Deficit → weight loss. Surplus → weight gain.
    const calDeltaDaily = hist7AvgCal - targets.calories;
    // negative = deficit, positive = surplus
    const projected30dDelta = calDeltaDaily * 30;
    const projectedWeightChange = (projected30dDelta / 7700).toFixed(2);
    // Unambiguous labels for the AI prompt
    const _deficitOrSurplus = calDeltaDaily < 0 ? "DEFICIT" : calDeltaDaily > 0 ? "SURPLUS" : "ON TARGET";
    const _lossOrGain = parseFloat(projectedWeightChange) < 0 ? "loss" : parseFloat(projectedWeightChange) > 0 ? "gain" : "maintain";
    const _absDelta = Math.abs(Math.round(calDeltaDaily));
    const _absTotal = Math.abs(Math.round(projected30dDelta));
    const _absWeight = Math.abs(parseFloat(projectedWeightChange)).toFixed(2);

    // ── Projection context (clear direction labels) ────────────────────
    const todayGap = Math.round(calConsumed - targets.calories);
    const sevenDayGap = Math.round((hist7AvgCal || targets.calories) - targets.calories);
    const sevenDayProjection = sevenDayGap === 0
      ? 'exactly on track — 7-day average matches target perfectly'
      : sevenDayGap < 0
      ? `7-day average is ${Math.abs(sevenDayGap)} kcal/day UNDER target — losing weight slightly FASTER than planned`
      : `7-day average is ${sevenDayGap} kcal/day OVER target — losing weight slightly SLOWER than planned`;

    // ── Supplement context ────────────────────────────────────────────────
    const _suppTakenCount = suppStack.filter(s => suppTakenToday.has(s.id)).length;
    const _suppAdherencePct = suppStack.length > 0 ? Math.round((_suppTakenCount / suppStack.length) * 100) : 0;
    const suppBlock = suppStack.length > 0
      ? `SUPPLEMENT STACK:\n` +
        suppStack.map(s =>
          `  ${suppTakenToday.has(s.id) ? "✓ TAKEN" : "✗ NOT TAKEN"} | ${s.name} | ${s.dose || "dose not set"} | Scheduled: ${s.timing || "timing not set"}`
        ).join("\n") + `\n  ADHERENCE TODAY: ${_suppAdherencePct}% (${_suppTakenCount} of ${suppStack.length} taken)`
      : "";

    const prompt =
`AUDIT -- ${new Date().toLocaleTimeString("en-GB",{hour:"2-digit",minute:"2-digit"})} | ${timeWindowLabel}
SUBJECT PROFILE -- DO NOT SUBSTITUTE THESE VALUES
  Weight : ${weight}kg | Height: ${height}cm
  Schedule: wake ${wakeTime||"07:00"} / bed ${bedTime||"23:00"} | Waking window: ${wakingWindowH}h
  Physique Goal : ${physiqueGoal ? `"${sanitiseForPrompt(physiqueGoal)}"` : "not set"}
  Target Weight : ${targetWeight ? `${targetWeight}kg` : "not set"}
  Persona       : ${persona}

ACTIVITY & TARGETS
  Activity: "${sanitiseForPrompt(goal||"moderate").slice(0,80)}"
  ACTIVE DAILY TARGET: ${targets.calories} kcal | P: ${targets.protein}g | C: ${targets.carbs}g | F: ${targets.fat}g | Fi: ${targets.fibre||30}g

CALORIE_CONTEXT:
  Maintenance calories (TDEE): ${targets.tdeeRaw||"--"} kcal/day
  Daily target: ${targets.calories} kcal/day
  Built-in ${(targets.tdeeRaw||0) > targets.calories ? `deficit of ${Math.round((targets.tdeeRaw||0) - targets.calories)} kcal/day` : (targets.tdeeRaw||0) < targets.calories ? `surplus of ${Math.round(targets.calories - (targets.tdeeRaw||0))} kcal/day` : `maintenance — no offset`} — this is the gap required to reach the physique goal
  Goal mode: ${goalMode === "simple" ? simpleGoal || "not set" : "AI-generated"} (${simpleGoal === 'lose' ? 'calorie deficit applied' : simpleGoal === 'bulk' ? 'calorie surplus applied' : 'maintenance'})
  If user hits their daily target consistently, they are ON TRACK for their goal — the deficit/surplus is already accounted for
  BMR: ${targets.bmr||"--"} kcal (reference only — do NOT use for evaluation)
TODAYS_WORKOUT: ${todayWorkouts.length>0?todayWorkouts.map(w=>`${w.name} — ${w.duration||0} mins, ${w.calories_burned||0} kcal burned`).join("; "):"No workout logged today"}
WORKOUT CREDIT: ${todayWorkouts.filter(w=>w.calories_burned>0).reduce((s,w)=>s+(w.calories_burned||0),0)>0?todayWorkouts.filter(w=>w.calories_burned>0).map(w=>`${w.name} (~${w.calories_burned} kcal burned)`).join(", "):"None today"}
WORKOUT LAW: Reference the user's workout data where relevant. If they have completed a session today, acknowledge it positively. If no workout is logged today, note it briefly without being punitive.
HEALTH DATA: ${(()=>{try{const h=JSON.parse(localStorage.getItem("np_health_history")||"[]");const t=h.find(d=>d.date===TODAY_ISO());if(!t)return"No Health Connect data";return[t.steps!=null?`Steps: ${t.steps}`:null,t.activeCalories!=null?`Active kcal: ${Math.round(t.activeCalories)}`:null,t.heartRate!=null?`Avg HR: ${Math.round(t.heartRate)} bpm`:null,t.sleepHours!=null?`Sleep: ${t.sleepHours.toFixed(1)}h`:null].filter(Boolean).join(" | ");}catch(_){return"N/A";}})()} (from Health Connect -- use for holistic wellbeing commentary only)
${suppBlock}

CRITICAL TARGET LAW -- READ THIS BEFORE ALL EVALUATION:
  The ACTIVE DAILY TARGET already has the appropriate calorie deficit or surplus built into it by the AI target generator based on the user's physique goal.
  The user's job is to HIT the active target -- not to go under it.
  Being UNDER the active target = under-fuelling = the user did not eat enough = this is a MISS, not a win.
  TOLERANCE BANDS (apply to ALL macros -- TIME-ADJUSTED):
  Pro-rata expected intake = full-day target x pace fraction (${Math.round(paceFraction*100)}% of waking day elapsed).
  GREEN: within 10% of pro-rata expected intake = on track. Do NOT flag.
  AMBER: 10-25% below pro-rata expected = note briefly once.
  RED: >25% below pro-rata expected OR >10% above full-day target = flag clearly.
  In MORNING window a user who has consumed 20-40% of targets is likely on track -- do NOT flag as failing.

TODAY'S INTAKE
  Consumed : ${calConsumed} kcal | P: ${Math.round(totals.protein)}g | C: ${Math.round(totals.carbs)}g | F: ${Math.round(totals.fat)}g | Fi: ${Math.round(totals.fibre||0)}g
  Cal      : ${calConsumed} / ${targets.calories} kcal | Pro-rata expected: ${caloriesPaceTarget} kcal | ${(()=>{const expected=caloriesPaceTarget;const pct=expected>0?Math.round(Math.abs(calConsumed-expected)/expected*100):0;if(isOver&&Math.round(Math.abs(calDelta)/Math.max(targets.calories,1)*100)>10)return "RED ("+Math.round(Math.abs(calDelta)/Math.max(targets.calories,1)*100)+"% OVER full target)";return pct<=10?"GREEN ("+pct+"%)":pct<=25?"AMBER ("+pct+"% below pro-rata)":"RED ("+pct+"% below pro-rata)"})()}
  Protein  : ${Math.round(totals.protein)}g / ${targets.protein}g | Pro-rata expected: ${Math.round(targets.protein*paceFraction)}g | ${(()=>{const exp=Math.round(targets.protein*paceFraction);const pct=exp>0?Math.round(Math.abs(Math.round(totals.protein)-exp)/exp*100):0;return pct<=10?"GREEN ("+pct+"%)":pct<=25?"AMBER ("+pct+"%)":"RED ("+pct+"%)"})()}
  Fat      : ${Math.round(totals.fat)}g / ${targets.fat}g | Pro-rata expected: ${Math.round(targets.fat*paceFraction)}g | ${(()=>{const exp=Math.round(targets.fat*paceFraction);const actual=Math.round(totals.fat);const pct=exp>0?Math.round(Math.abs(actual-exp)/exp*100):0;if(actual>targets.fat&&Math.round((actual-targets.fat)/Math.max(targets.fat,1)*100)>10)return "RED (over full target)";return pct<=10?"GREEN ("+pct+"%)":pct<=25?"AMBER ("+pct+"%)":"RED ("+pct+"%)"})()}
  Carbs    : ${Math.round(totals.carbs)}g / ${targets.carbs}g | Pro-rata expected: ${Math.round(targets.carbs*paceFraction)}g | ${(()=>{const exp=Math.round(targets.carbs*paceFraction);const actual=Math.round(totals.carbs);const pct=exp>0?Math.round(Math.abs(actual-exp)/exp*100):0;return pct<=10?"GREEN ("+pct+"%)":pct<=25?"AMBER ("+pct+"%)":"RED ("+pct+"%)"})()}
  Water    : ${waterMl}ml / ${WATER_TARGET}ml target | Gap: ${waterGap}ml | ${Math.round((waterMl/WATER_TARGET)*100)}% of target at ${Math.round(paceFraction*100)}% of waking day
EXPLICIT MACRO STATUS (authoritative — use these, do not recalculate):
  CALORIE_STATUS: ${calsStatus}
  CALORIES_CONSUMED: ${calConsumed} kcal | CALORIE_TARGET: ${targets.calories} kcal | CALORIES_DIFFERENCE: ${calsOver > 0 ? '+' : ''}${calsOver} kcal
  PROTEIN_STATUS: ${proteinStatus}
  CARBS_STATUS: ${carbsStatus}
  FAT_STATUS: ${fatStatus}
  WATER_STATUS: ${waterStatus}
  FIBRE_STATUS: ${fibreStatus}
  SUGAR_STATUS: ${sugarStatus}
  SODIUM_STATUS: ${sodiumStatus}
  PRO_RATA_STATUS: ${proRataStatus}
Use all *_STATUS fields as authoritative. Do not recalculate any macro, calorie, hydration, or workout value from raw data. For macros that are ON TRACK, acknowledge briefly. Reserve detailed coaching for macros notably over or under target.
${accidentalKeto && timeWindow !== "MORNING"
  ? `  ACCIDENTAL KETO ALERT: Fat ${fatOver}g over AND carbs ${carbsUnder}g under. Flag in metabolic_review.`
  : accidentalKeto && timeWindow === "MORNING"
  ? `  Fat/carb imbalance noted -- day is open, frame as correction opportunity.`
  : ""}

MEALS LOGGED TODAY (chronological):
${mealLogBlock}

MEAL TIMING DISTRIBUTION:
  Morning (before 12:00): ${Math.round(mealsByHour.morning || 0)}kcal
  Afternoon (12:00-17:00): ${Math.round(mealsByHour.afternoon || 0)}kcal
  Evening (after 17:00): ${Math.round(mealsByHour.evening || 0)}kcal

PROTEIN DISTRIBUTION:
  Morning: ${Math.round(proteinBySlot.morning || 0)}g | Afternoon: ${Math.round(proteinBySlot.afternoon || 0)}g | Evening: ${Math.round(proteinBySlot.evening || 0)}g

${RECENT_HISTORY_PROMPT}

PROJECTION_CONTEXT:
TODAY: Ate ${calConsumed} kcal vs ${targets.calories} kcal target. Gap today: ${todayGap > 0 ? '+' : ''}${todayGap} kcal.
7-DAY PATTERN: ${sevenDayProjection}
If 7-day average continues for 30 days: ${hist7AvgCal > 0 ? _absWeight + 'kg ' + (sevenDayGap < 0 ? 'faster than planned' : sevenDayGap > 0 ? 'slower than planned' : 'on track') : "N/A"}
RULE: Under target = FASTER progress. Over target = SLOWER progress. The target already contains the deficit. This is absolute — never say the opposite.
IMPORTANT: TODAY and 7-DAY PATTERN are TWO DIFFERENT numbers. The Outlook section references 7-DAY PATTERN only — not today's gap.

${timeWindow === "MIDDAY" ? `PACE CHECK
  Hours awake: ${hoursElapsed}h of ${wakingWindowH}h (${Math.round(paceFraction*100)}%)
  Expected: ${caloriesPaceTarget} kcal | Actual: ${calConsumed} kcal
  ${significantlyBehindPace ? `SIGNIFICANTLY BEHIND -- ${caloriesPaceTarget - calConsumed} kcal short` : "Within acceptable pace variance"}
` : ""}
METABOLIC STATE (pre-computed)
  Current state: ${metabolicState} | Net carbs: ${netCarbs}g | Consecutive low-carb days: ${consecutiveLowCarbDays}
${refeedAlert
  ? `  STRATEGIC REFEED REQUIRED: ${consecutiveLowCarbDays} days in ${metabolicState}. Prescribe 50-100g complex carbs on next training day.`
  : ""}

ACTION_PRIORITY: ${actionPriority}
${actionForbidden}

TACTICAL CONSTRAINTS -- ADDRESS IN ORDER, HIGHEST PRIORITY FIRST
${tacLines}

DO_THIS_TODAY_INSTRUCTION: Write the action field as exactly this, with your persona voice applied: "${actionInstruction}"
The model's only job for the action field is to rephrase this instruction in the correct persona voice — not to decide what the action should be.`;

    try {
      const _sysPrompt = SYSTEM[persona] || SYSTEM.Balanced;
      const ACCURACY_CHECK = `\nFINAL ACCURACY CHECK before writing:\n1. Is today's intake under or over target? Under = ahead of schedule — frame it that way. Never say "get back on track" if they are under target.\n2. Have you used any percentage you calculated yourself? Remove it — only use numbers from the data.\n3. Have you said "glycogen", "leucine", "MPS", "substrate", "anabolic", "catabolic", "pro-rata", "thermogenesis", "kick your metabolism", "rev up your metabolism", "get your metabolism going", "metabolic efficiency", "catabolism", "satiety signals", "lean mass preservation", "metabolic rate", "basal metabolic rate", "muscle protein synthesis", "glycogen resynthesis", "leucine threshold", "substrate utilisation", "normal metabolic state"? Remove every one.\n4. Have you extrapolated today's gap into a weekly total without labelling it? Fix it.\n5. Have you said anything about carrying water over to tomorrow? Remove it.\n6. Have you used "Normal carb state is active" or similar? Replace with plain language.\n7. HEADLINE LAW — MANDATORY: If PRO_RATA_STATUS starts with ON TRACK or SLIGHTLY BEHIND PACE, the headline MUST open with a positive or neutral observation. NEVER open with "you missed", "you fell short", "you failed", "targets missed", or any negative framing when the user is under target. Under-target = ahead of schedule = good. If OVER target, use recovery framing. This check overrides persona voice — even the Critical persona must not open with a failure statement when the user is under target. Example of correct SLIGHTLY BEHIND framing: "You're slightly behind pace today — but the evening is yours to close the gap." Example of INCORRECT framing: "Today's eating is behind schedule." The second example is too negative for a SLIGHTLY BEHIND PACE user.\n8. Is the action field ONE specific instruction with a time and amount? Protein amount must be at least 40g for a morning meal.\n9. When switching from today to the 7-day average in OUTLOOK, did you signal it with "This week's 7-day average is..."?\n10. CATABOLISM SYNONYM CHECK: Never use these phrases or close variants: "burned muscle for energy", "burning muscle", "body is breaking down muscle", "muscle tissue breaking down", "body is eating muscle", "muscle wasting", "your body has broken down", "muscles were broken down". These are catabolism synonyms and are banned. Replace with: "your muscles did not get the support they needed" or "recovery was limited today".\nNow write the JSON.`;
      const TIME_CHECK = `\nTIME CHECK: It is ${currentTimeStr}. ${hoursRemaining}h remaining today. ${timeWindow === "MORNING" ? "It is MORNING — do not treat current intake as a failure. The user has most of the day ahead. RECOVERY must focus on the rest of TODAY not bedtime. Action label: DO THIS TODAY." : timeWindow === "EVENING" ? "It is EVENING — the day is nearly done. Gaps are real. Action label: DO THIS TOMORROW." : "It is MIDDAY — assess pace. Recovery focuses on the rest of today. Action label: DO THIS TODAY."}`;
      const SUPPLEMENT_FINAL_CHECK = `\nSUPPLEMENT CHECK: Scan your response for any mention of supplements, supplement schedule, supplement adherence, or supplement doses. Remove every instance. The audit covers food, water, and training only.`;
      const ACTION_CHECK = `\nACTION CHECK: The action field must be a persona-voiced version of DO_THIS_TODAY_INSTRUCTION — nothing else. Do not substitute a different action. Do not add protein urgency if DO_THIS_TODAY_INSTRUCTION does not mention protein.`;
      const FINAL_CHECK = persona === "Critical"
        ? `FINAL CHECK: You are the drill sergeant. Short sentences. Every number must be from the data — do not invent figures. Call out the three biggest failures with consequences. Acknowledge ONE thing done right. Recovery must include specific foods, amounts, and timing. Rest days are valid — never imply not training is a failure. Never write averages as negative numbers.${TIME_CHECK}${ACCURACY_CHECK}${SUPPLEMENT_FINAL_CHECK}${ACTION_CHECK}`
        : persona === "Motivational"
        ? `FINAL CHECK: You are the energetic coach. Every exclamation mark needs a specific number before it. Reframe each gap as still fixable. Reference the ${targetWeight||"target"}kg goal. Recovery must include specific foods and timing. Action must end on forward momentum with a specific time and amount. No empty phrases.${TIME_CHECK}${ACCURACY_CHECK}${SUPPLEMENT_FINAL_CHECK}${ACTION_CHECK}`
        : `FINAL CHECK: You are the honest trainer. Plain English. Every number must be from the data. Explain what each gap means for the ${targetWeight||"target"}kg goal specifically. One acknowledgement of what went right. Recovery must include specific foods. Outlook must reference what the user will feel in training if this pattern continues. No hedging.${TIME_CHECK}${ACCURACY_CHECK}${SUPPLEMENT_FINAL_CHECK}${ACTION_CHECK}`;
      const raw = await llmFetch({
        model:       LLM_MODEL_HEAVY,
        reasoning_effort: "none",
        max_tokens:  2600,
        temperature: 0.7,
        messages: [
          { role: "system", content: _sysPrompt },
          { role: "user",   content: prompt + `\n\n` + FINAL_CHECK },
        ],
      });
      // Truncation detection — if JSON is incomplete, log and retry once
      if (raw && !raw.includes('}')) {
        Sentry.captureMessage("[runCopilot] AI response truncated", { extra: { rawLength: raw.length } }); if (process.env.NODE_ENV !== "production") console.error('[runCopilot] AI response truncated — missing closing brace, length:', raw.length);
        // Attempt to salvage by closing the JSON
        const salvaged = raw + '"}';
        try { JSON.parse(salvaged.slice(salvaged.indexOf('{'))); } catch(_) {}
      }
      // V40: split into 5 state vars (headline, right_now, recovery, outlook, action)
      const sections = splitAuditResponse(raw);
      setCpHeadline(sections.headline || "");
      setCpMetabolic(sections.right_now || sections.metabolic_review || "");
      setCpTactical(sections.recovery || sections.tactical_recovery || "");
      setCpOutlook(sections.outlook || "");
      setCpAction(sections.action || "");
      // V105: extract suggested target weight from AI response
      const wtMatch = raw.match(
        /(?:aim for|target weight|goal weight|reach|get to|down to|up to)\s+(\d{2,3}(?:\.\d)?)\s*kg/i
      );
      if (wtMatch && session) {
        const suggestedKg = parseFloat(wtMatch[1]);
        const suggKey = `target_weight_suggestion_${suggestedKg}`;
        const alreadySuggested = (() => { try { return localStorage.getItem(suggKey) === "shown"; } catch(_) { return false; } })();
        if (suggestedKg !== targetWeight && !alreadySuggested) {
          setActiveNudge({
            id: "target_weight_suggestion",
            title: "AI suggested target weight",
            body: `Based on your physique goal, the AI recommends a target weight of ${suggestedKg}kg. Would you like to save this?`,
            primaryLabel: `Save ${suggestedKg}kg as my target`,
            secondaryLabel: "Not now",
            onPrimary: async () => {
              try { localStorage.setItem(suggKey, "shown"); } catch(_) {}
              setTargetWeight(suggestedKg);
              try {
                await supabase.from("profiles").upsert(
                  { id: session.user.id, target_weight: suggestedKg, updated_at: new Date().toISOString() },
                  { onConflict: "id" }
                );
              } catch(_) {}
              setActiveNudge(null);
            },
            onSecondary: () => {
              try { localStorage.setItem(suggKey, "shown"); } catch(_) {}
              setActiveNudge(null);
            },
          });
        }
      }
      // Store JSON string to Supabase for persistence (last_audit column)
      const toStore = JSON.stringify({
        metabolic_review:  sections.metabolic_review,
        tactical_recovery: sections.tactical_recovery,
        outlook:           sections.outlook,
      });
      setCpResp(toStore);  // legacy state — drives Supabase write only
      if(session){
        await supabase.from("profiles").upsert(
          {id:session.user.id, last_audit:toStore, updated_at:new Date().toISOString()},
          {onConflict:"id"}
        );
      }
    } catch(e) {
      Sentry.captureException(e, { extra: { context: "runCopilot" } }); if (process.env.NODE_ENV !== "production") console.error("[runCopilot]", e.code, e.message);
      const errMsg   = e.code === "TIMEOUT"
        ? "Audit timed out — the AI service may be busy. Please try again in a moment."
        : e.code === "BAD_RESPONSE"
        ? "AI service is busy — please try again in a few minutes."
        : "Audit unavailable — please check your connection and try again.";
      const recovery = e.code === "TIMEOUT"
        ? "The AI service is usually fast. If this persists, try again shortly."
        : "Make sure you have an internet connection and try running the audit again.";
      const out = "Tap the audit button to retry.";
      setCpHeadline("");
      setCpMetabolic(errMsg);
      setCpTactical(recovery);
      setCpOutlook(out);
      setCpAction("");
    }
    setCpLoading(false);
  }

  // ─── AI SERVICE — loadIntelMeta ────────────────────────────────────────────
  // Lightweight 7-day Supabase fetch. No LLM call.
  // Populates intelByDay for Momentum / Wall of Shame / Survival modules.
  async function loadIntelMeta() {
    if (!session || intelLoading) return;
    setIntelLoading(true);
    try {
      const { byDay } = await fetchSevenDayLogs(session.user.id);
      setIntelByDay(byDay);
    } catch(_){}
    setIntelLoading(false);
  }


  // ─── AI SERVICE — runWeeklyBriefing ───────────────────────────────────────
  // V50: Structural overhaul. Output is now JSON with four keys:
  //   summary    : string  (exactly 5 sentences)
  //   pros       : string[] (exactly 3 items)
  //   negatives  : string[] (exactly 3 items)
  //   priorities : string[] (exactly 3 items)
  //   - All prior logic preserved: 7-day averages, Accidental Keto,
  //     Protein gap, Missing days, Metabolic state, Refeed alert,
  //     Persona scaling, Physique goal, no medical markers.
  //   - splitWeeklyResponse() handles JSON parse with two fallback strategies.
  //   - State split into wbSummary / wbPros / wbNegatives / wbPriorities.

  function splitWeeklyResponse(raw) {
    const s = cleanAIResponse(raw || "");

    // Strategy 1: widest JSON block
    try {
      const start = s.indexOf("{");
      const end   = s.lastIndexOf("}");
      if (start !== -1 && end > start) {
        const parsed = JSON.parse(s.slice(start, end + 1));
        const toArr = v => Array.isArray(v) ? v.map(String) : [];
        return {
          summary:    String(parsed.summary    || ""),
          pros:       toArr(parsed.pros),
          negatives:  toArr(parsed.negatives),
          priorities: toArr(parsed.priorities),
        };
      }
    } catch(_) {}

    // Strategy 2: per-key regex extraction
    try {
      const extractStr = key => {
        const m = s.match(new RegExp(`"${key}"\\s*:\\s*"([^"]*)"`, "i"));
        return m ? m[1] : "";
      };
      const extractArr = key => {
        const m = s.match(new RegExp(`"${key}"\\s*:\\s*\\[([^\\]]+)\\]`, "i"));
        if (!m) return [];
        return m[1].match(/"([^"]*)"/g)?.map(x => x.replace(/"/g,"")) || [];
      };
      return {
        summary:    extractStr("summary"),
        pros:       extractArr("pros"),
        negatives:  extractArr("negatives"),
        priorities: extractArr("priorities"),
      };
    } catch(_) {}

    // Strategy 3: plain-text fallback — dump everything into summary
    return { summary: s, pros: [], negatives: [], priorities: [] };
  }

  async function runWeeklyBriefing() {
    if (!session) return;
    if (!effectiveIsPremium) { throw new Error("Premium required"); }
    setWeeklyLoading(true);
    setWbSummary(""); setWbPros([]); setWbNegatives([]); setWbPriorities([]);
    try {
      const { byDay, dates } = await fetchSevenDayLogs(session.user.id);
      setIntelByDay(byDay);

      // ── Compute 7-day averages ─────────────────────────────────────────────
      const today = new Date().toISOString().slice(0, 10);
      const loggedDays = dates.filter(d => byDay[d]?.logged);
      // Exclude today — it is a partial day and must not skew averages or appear as a gap
      const completedDays = loggedDays.filter(d => d !== today);
      const n = completedDays.length || 1;

      const avg = completedDays.reduce((acc, d) => {
        const b = byDay[d];
        acc.calories += b.calories || 0;
        acc.protein  += b.protein  || 0;
        acc.carbs    += b.carbs    || 0;
        acc.fat      += b.fat      || 0;
        acc.fibre    += b.fibre    || 0;
        acc.sugar  += b.sugar  || 0;
        acc.sodium += b.sodium || 0;
        return acc;
      }, { calories:0, protein:0, carbs:0, fat:0, fibre:0, sugar:0, sodium:0 });
      Object.keys(avg).forEach(k => { avg[k] = Math.round(avg[k] / n); });

      // Water: read from byDay.water which is now populated from water_logs
      // via fetchSevenDayLogs -- authoritative per-day historical data.
      const avgWater = Math.round(
        completedDays.reduce((s, d) => s + (byDay[d]?.water || 0), 0) / n
      );

      // ── Pre-compute audit flags ────────────────────────────────────────────
      const avgFatOver     = avg.fat   - targets.fat;
      const avgCarbsUnder  = targets.carbs - avg.carbs;
      const avgProteinGap  = targets.protein - avg.protein;
      const accidentalKeto = avgFatOver > 20 && avgCarbsUnder > 50;
      const proteinFlaggable = avgProteinGap > 15;

      // ── Missing days ──────────────────────────────────────────────────────
      const missingDays  = dates.filter(d => d !== today && !byDay[d]?.logged);
      const missingCount = missingDays.length;
      const missingNote  = missingCount > 0
        ? `MISSING DAYS (${missingCount}/7): ${missingDays.join(", ")} — these are failures of discipline. Call them out explicitly in NEGATIVES.`
        : "All 7 days logged.";

      // ── Per-day lines ─────────────────────────────────────────────────────
      // Exclude today from PER-DAY LOG — model was computing its own average including today's partial data
      // Calories removed from per-day lines — model was recomputing its own average and overriding CALORIE_FACT
      const dayLines = dates.slice().reverse().filter(d => d !== today).map(d => {
        const b = byDay[d];
        return b?.logged
          ? `${d}: P:${Math.round(b.protein)}g C:${Math.round(b.carbs)}g F:${Math.round(b.fat)}g Fi:${Math.round(b.fibre||0)}g`
          : `${d}: NO DATA`;
      }).join("\n");

      // ── Metabolic state (pre-computed) ────────────────────────────────────
      const weeklyMetabolicState =
        avg.carbs < 50   ? "Very Low Carb" :
        avg.carbs <= 100 ? "Low Carb State"  :
        "Normal Carb State";
      const sortedLoggedDates = [...loggedDays].sort((a, b) => b.localeCompare(a));
      let weeklyLowCarbStreak = 0;
      for (const d of sortedLoggedDates) {
        if ((byDay[d]?.carbs || 0) < 100) { weeklyLowCarbStreak++; } else { break; }
      }
      const weeklyRefeedAlert = weeklyLowCarbStreak >= 3;

      // ── Persona tone instructions ─────────────────────────────────────────
      const personaInstructions = {
        Critical:
          `VOICE — OBEY THROUGHOUT: You are a blunt, aggressive strength coach. Short punchy sentences. Full stops that land like punches. Name failures without softening. No hedge words: "may", "might", "could", "perhaps", "not ideal", "if not addressed" are ALL FORBIDDEN. Replace every hedge with a direct statement. ` +
          `Protein short = "you are losing muscle". Calories over = "you are gaining fat". Missing log days = "no data means no progress". ` +
          `NEGATIVES and PRIORITIES must be cold, consequential, and use direct language. ` +
          `METABOLIC STATE: Name it bluntly using plain English. State exactly what it means for training and recovery. ` +
          `REFEED: If flagged, prescribe 50-100g complex carbs on the next training day. No softening. ` +
          `PLAIN_ENGLISH_LAW: No science jargon. BANNED: leucine, MPS, glycogen, substrate, anabolic, catabolic, thermogenesis, metabolic efficiency, satiety signals, lean mass preservation, metabolic rate, basal metabolic rate, muscle protein synthesis, glycogen resynthesis, leucine threshold, substrate utilisation, normal metabolic state, kick your metabolism. Use everyday language instead. ` +
          `The summary must OPEN with the single biggest failure of the week, named directly. Pros acknowledged in one sentence maximum.`,
        Balanced:
          `VOICE — OBEY THROUGHOUT: You are a clinical sports nutritionist writing a concise report. Surgical precision. Zero warmth phrases: "let's", "great job", "well done", "amazing", "keep it up" are ALL FORBIDDEN. State what is happening with specific numbers. "May not be ideal" is FORBIDDEN — state what IS happening. ` +
          `Every observation must reference a specific number from the data. Explain the practical impact on the user's goal — not the science behind it. ` +
          `METABOLIC STATE: Describe in plain terms what the carb and calorie intake means for energy and recovery. ` +
          `REFEED: If flagged, prescribe 50-100g complex carbohydrates on the next training day and explain why in plain terms. ` +
          `PLAIN_ENGLISH_LAW: No science jargon. BANNED: leucine, MPS, glycogen, substrate, anabolic, catabolic, thermogenesis, metabolic efficiency, satiety signals, lean mass preservation, metabolic rate, basal metabolic rate, muscle protein synthesis, glycogen resynthesis, leucine threshold, substrate utilisation, normal metabolic state. Use everyday language instead. ` +
          `The summary must OPEN with the most significant finding from the data. Reference specific numbers throughout.`,
        Motivational:
          `VOICE — OBEY THROUGHOUT: You are a high-energy performance coach. Frame every finding as an opportunity. Your energy comes from SPECIFIC NUMBERS, not generic enthusiasm. "Fantastic!" and "Great job!" are BANNED unless a specific number is attached. "I'm excited" is BANNED. Instead: "2150 kcal average — that is your engine RUNNING!" Every exclamation mark must be earned by a number. ` +
          `METABOLIC STATE: Frame as a tactical choice with a specific performance number attached. Use plain English. ` +
          `REFEED: Reframe positively — "fuel the engine with 50-100g complex carbs on training day — this is the performance upgrade!" ` +
          `PLAIN_ENGLISH_LAW: No science jargon. BANNED: leucine, MPS, glycogen, substrate, anabolic, catabolic, thermogenesis, metabolic efficiency, satiety signals, lean mass preservation, metabolic rate, basal metabolic rate, muscle protein synthesis, glycogen resynthesis, leucine threshold, substrate utilisation, normal metabolic state, kick your metabolism. Use everyday language instead. ` +
          `The summary must OPEN with the single biggest WIN of the week stated with a number. Every list item must reference a number. Tone: inspiring, data-grounded, action-obsessed.`,
      };

      // ── JSON contract — persona voice FIRST ─────────────────────────────
      const WEEKLY_SYSTEM =
        (personaInstructions[persona] || personaInstructions.Balanced) + `\n` +
        `You are a weekly nutrition performance analyst. ` +
        `OUTPUT FORMAT LAW: Respond ONLY with a single valid JSON object. ` +
        `Start with { and end with }. Nothing before or after the JSON. No markdown. No backticks. ` +
        `The JSON must have exactly these four keys: ` +
        `"summary" (string, exactly 5 sentences — the FIRST sentence must be NUTRITION_OPENING_SENTENCE copied verbatim with no changes to any number; remaining 4 sentences cover protein, water, training, and outlook; must not mention supplements), ` +
        `"pros" (array of exactly 3 strings, positive observations), ` +
        `"negatives" (array of exactly 3 strings, critical failures — if CALORIE_GAP_SENTENCE says "do not list calories as a gap", calories must not appear in negatives; if calories are a gap, the first negative must be CALORIE_GAP_SENTENCE copied verbatim), ` +
        `"priorities" (array of exactly 3 strings, non-negotiable actions for next 7 days). ` +
        `COUNT LAW: summary = 5 sentences. Each list = exactly 3 items. No exceptions. ` +
        `FORBIDDEN: Do not mention blood tests, LDL, creatinine, urea, or any medical lab values. Do not mention supplements, supplement adherence, or supplement doses in any field. ` +
        `TARGET LAW: The ACTIVE DAILY TARGET already contains the deficit/surplus needed to reach the goal. ` +
        `BMR is provided as reference only. ALL evaluation must use the ACTIVE DAILY TARGET. ` +
        `UNDER_TARGET_LAW: Being UNDER the weekly calorie target average = progressing slightly FASTER than planned = a WIN or neutral finding, NOT a gap. ` +
        `Being OVER the weekly calorie target average = progressing SLOWER than planned = a gap to fix. ` +
        `CALORIE_CHECK: Before writing GAPS TO FIX — is the weekly calorie average under or over target? Under = do not list as a gap. Over = list as a gap. ` +
        `ENERGY CONFLICT: If fat avg is >20g over target AND carbs avg is >50g under target, ` +
        `name this as Accidental Keto undermining the 3x/week lifting mandate -- must appear in negatives. ` +
        `DISCIPLINE: Mention missing log days but keep primary focus on macro-partitioning and lifting mandate. ` +
        `30-DAY PROJECTION LAW: Use only the pre-computed projection numbers provided. State the projected weight change explicitly in kg. A caloric DEFICIT (eating BELOW target) means projected weight LOSS. A caloric SURPLUS (eating ABOVE target) means projected weight GAIN. Never invert this relationship. Connect it to whether the user will achieve their goal on the current trajectory. Be specific about the timeline. ` +
        `VOICE LAW: Always address the user directly using 'you' and 'your' throughout the entire briefing. Never refer to 'the user' in the third person at any point. This applies to the summary, pros, negatives, and priorities sections. ` +
        `Do NOT output [THINK] blocks or chain-of-thought. Output only the JSON object. ` +
        `TARGET WEIGHT LAW: If TARGET_WEIGHT is provided in the user context and marked as '(user set)', always use this as the authoritative target weight. Never estimate or recalculate target weight from physique goal descriptions when a user-set value exists. Only estimate target weight if TARGET_WEIGHT is 'not set'. ` +
        `SAFETY LAW: You must never suggest the user has a medical condition. You must never recommend stopping or adjusting medication. You must never recommend caloric intake below 1200 kcal/day for any user. You must never diagnose, imply diagnosis, or use diagnostic language for any physical or mental health condition. If the data implies a pattern consistent with disordered eating (e.g. consecutive days under 800 kcal), do not name it -- instead state \"intake pattern warrants review with a registered dietitian\" and move on. These rules override all persona instructions.` +
        `WEEKLY_PERSONA_LAW: Motivational: The summary must open with the single biggest WIN of the week stated loudly. Pros celebrated. Negatives reframed as what to attack next week. Priorities as a rally call. Balanced: The summary must open with the most clinically significant finding. Pros stated with mechanism. Negatives with physiological consequence. Priorities as ranked interventions. Critical: The summary must open with the single biggest failure of the week named directly. Pros acknowledged in one sentence maximum. Negatives stated bluntly. Priorities as non-negotiable commands. ` +
        `WEEKLY_SUPPLEMENT_BAN: The weekly briefing must never reference supplements, supplement adherence, supplement doses, or supplement schedules anywhere — not in summary, not in pros, not in negatives, not in priorities. This ban applies to every field in the output. ` +
        `CALORIE_NUMBER_LAW: The ONLY calorie average you are permitted to write is the one from CALORIE_FACT on line 1 of this prompt. You must not write any other calorie average figure. Never write "1967" or "204 kcal short" or "204 kcal under" or any calorie average that differs from CALORIE_FACT. If CALORIE_FACT says the average is X kcal/day, that is the only calorie figure you may reference for the weekly average. If you find yourself writing a different calorie figure, stop and use CALORIE_FACT instead. ` +
        `SECTION_DEFINITIONS:
SUMMARY — The single most important finding of the week. What the data pattern means for the goal. One clear verdict, not a list of numbers.
PROS — Three specific things that worked this week with exact numbers. What to keep doing and why.
NEGATIVES — Three specific things that hurt progress with exact numbers. What they cost in real terms.
PRIORITIES — Three non-negotiable actions for next week. Specific, time-bound, measurable.
PLAIN_ENGLISH_LAW: No science jargon. Banned: leucine, MPS, glycogen, substrate, anabolic, catabolic, pro-rata, thermogenesis, metabolic efficiency, satiety signals, lean mass preservation, metabolic rate, basal metabolic rate, muscle protein synthesis, glycogen resynthesis, leucine threshold, substrate utilisation, normal metabolic state.
SPECIFICITY_LAW: Every sentence must reference at least one specific number from the data.
UK_LAW: Write in UK English. Use UK spelling throughout (e.g. "fibre" not "fiber", "colour" not "color"). Reference UK dietary guidelines where applicable. `;

      // ── Pre-compute weekly calorie verdict — single source of truth ─────────
      const calsOverUnder = avg.calories >= targets.calories ? 'over' : 'under';
      const calsDiff      = Math.abs(avg.calories - targets.calories);
      const calsStatement = avg.calories >= targets.calories
        ? `Calories are OVER target — averaging ${avg.calories} kcal/day, ${calsDiff} kcal above the ${targets.calories} target.`
        : `Calories are UNDER target — averaging ${avg.calories} kcal/day, ${calsDiff} kcal below the ${targets.calories} target.`;
      const calVerdict = avg.calories >= targets.calories
        ? `OVER TARGET: Averaging ${avg.calories} kcal/day — ${calsDiff} kcal/day above the ${targets.calories} target. Progress slightly slower than planned.`
        : `UNDER TARGET: Averaging ${avg.calories} kcal/day — ${calsDiff} kcal/day below the ${targets.calories} target. Progress slightly faster than planned.`;
      // Hardcoded sentences — model must copy these verbatim, not generate its own calorie figures
      const nutritionOpeningSentence = avg.calories > targets.calories
        ? `This week you averaged ${avg.calories} kcal/day — ${avg.calories - targets.calories} kcal above your ${targets.calories} kcal target, which means progress toward ${targetWeight ? targetWeight + 'kg' : 'your goal'} is slightly slower than planned.`
        : `This week you averaged ${avg.calories} kcal/day — ${targets.calories - avg.calories} kcal below your ${targets.calories} kcal target, which means you are progressing toward ${targetWeight ? targetWeight + 'kg' : 'your goal'} slightly faster than planned.`;
      const calorieGapSentence = avg.calories > targets.calories
        ? `Calorie intake averaged ${avg.calories} kcal/day — ${avg.calories - targets.calories} kcal above the ${targets.calories} target.`
        : null;

      // Weight log context
      const wLogSorted = [...(weightLogs || [])].sort((a,b) => new Date(a.logged_at) - new Date(b.logged_at));
      const wLogRecent = wLogSorted.slice(-7);
      const wLogFirst  = wLogRecent.length > 0 ? parseFloat(wLogRecent[0].weight_kg) : null;
      const wLogLast   = wLogRecent.length > 0 ? parseFloat(wLogRecent[wLogRecent.length-1].weight_kg) : null;
      const wLogDelta  = (wLogFirst !== null && wLogLast !== null) ? +(wLogLast - wLogFirst).toFixed(1) : null;
      const weightLogBlock = wLogRecent.length > 0
        ? `WEIGHT LOG (last ${wLogRecent.length} entries)\n` +
          wLogRecent.map(w => `  ${w.date || new Date(w.logged_at).toISOString().slice(0,10)}: ${parseFloat(w.weight_kg).toFixed(1)}kg`).join("\n") + "\n" +
          `  Net change: ${wLogDelta !== null ? (wLogDelta > 0 ? "+" : "") + wLogDelta + "kg" : "n/a"} over this period\n` +
          `  WEIGHT TREND LAW: Assess whether the weight trend is consistent with the caloric deficit/surplus. If losing on a surplus or gaining on a deficit, flag the discrepancy. Reference the weight numbers directly.`
        : `WEIGHT LOG: No entries recorded this period. Prompt the user to log weight daily for accurate progress assessment.`;

      // Supplement block intentionally removed from weekly prompt — model must not reference supplements

      // V26 HOTFIX 6: Fetch 7-day workout sessions for weekly briefing
      let weekSessions = 0, weekWorkoutCalories = 0;
      try {
        const oldest = dates[dates.length - 1];
        const { data: wkSessions } = await supabase
          .from("workout_sessions")
          .select("id,name,duration,calories_burned,date")
          .eq("user_id", session.user.id)
          .gte("date", oldest)
          .lte("date", dates[0]);
        weekSessions = (wkSessions || []).length;
        weekWorkoutCalories = (wkSessions || []).reduce((s, w) => s + (w.calories_burned || 0), 0);
      } catch(_) {}

      // V27: Fetch latest body measurements for weekly briefing
      let latestMeasurement = null, prevMeasurement = null;
      try {
        const { data: bmRows } = await supabase
          .from("body_measurements")
          .select("weight_kg,body_fat_pct,waist_cm,logged_at")
          .eq("user_id", session.user.id)
          .order("logged_at", { ascending: false })
          .limit(2);
        if (bmRows && bmRows.length > 0) latestMeasurement = bmRows[0];
        if (bmRows && bmRows.length > 1) prevMeasurement = bmRows[1];
      } catch(_) {}

      const weeklyPrompt =
`⚠️ CALORIE FACT (copy this exactly, do not recalculate): ${calsStatement}
This same direction must appear in both NUTRITION and GAPS TO FIX. If NUTRITION says ${calsOverUnder}, GAPS cannot say the opposite. If NUTRITION says ${calsOverUnder}, GAPS must also say ${calsOverUnder}.

WEEKLY NUTRITION REVIEW

DATA_NOTE: Today (${today}) is a partial day — excluded from all averages and gap analysis. Never reference today's intake as a gap or failure. Analysis covers completed days only.

ACTIVE DAILY TARGETS (what every day is benchmarked against)
  Calories : ${targets.calories} kcal | Protein: ${targets.protein}g | Carbs: ${targets.carbs}g | Fat: ${targets.fat}g | Fiber: ${targets.fibre||30}g

CALORIE_CONTEXT:
  Active daily target: ${targets.calories} kcal/day — this already contains the built-in deficit/surplus to reach the goal.
  Goal mode: ${goalMode === "simple" ? simpleGoal || "not set" : "AI-generated"} (${simpleGoal === 'lose' ? 'calorie deficit applied' : simpleGoal === 'bulk' ? 'calorie surplus applied' : 'maintenance'})
  TARGET_LAW: Hitting the daily target = ON TRACK for the goal. The target already contains the deficit/surplus. Frame all analysis relative to the target only — do not reference TDEE or maintenance calories.

EVALUATION RULE: The daily target of ${targets.calories} kcal already contains the built-in deficit to reach the goal.
  - Averaging AT or BELOW target = on track or ahead of schedule = not a gap
  - Averaging ABOVE target = behind schedule = list as a gap
  Use CALORIE_FACT (line 1 of this prompt) as the single source of truth. Do not recalculate.

7-DAY AVERAGES (${n} completed days — today excluded as partial)
  Calories : ${avg.calories} kcal/day | Active Target: ${targets.calories} kcal/day | Delta: ${avg.calories - targets.calories > 0 ? "+" : ""}${avg.calories - targets.calories} kcal
  Protein  : ${avg.protein}g/day     | Active Target: ${targets.protein}g/day     | ${proteinFlaggable ? `GAP: ${avgProteinGap}g -- FLAGGABLE (>15g rule)` : `Gap: ${avgProteinGap}g -- within tolerance`}
  Carbs    : ${avg.carbs}g/day       | Active Target: ${targets.carbs}g/day       | Delta: ${avg.carbs - targets.carbs > 0 ? "+" : ""}${avg.carbs - targets.carbs}g
  Fat      : ${avg.fat}g/day         | Active Target: ${targets.fat}g/day         | Delta: ${avg.fat - targets.fat > 0 ? "+" : ""}${avg.fat - targets.fat}g
  Fiber    : ${avg.fibre}g/day       | Active Target: ${targets.fibre||30}g/day
  Water    : ${avgWater}ml/day       | Target: ${hydrationTarget}ml/day
  Missing log days: ${missingCount} of 7
${accidentalKeto ? `\nACCIDENTAL KETO ALERT: Fat avg ${avgFatOver}g over target. Carbs avg ${avgCarbsUnder}g under target. This must appear in negatives -- it starves glycolytic pathways and destroys the 3x/week lift mandate.` : ""}

METABOLIC STATE (pre-computed)
  State: ${weeklyMetabolicState} (avg ${avg.carbs}g carbs/day)
  Consecutive low-carb days: ${weeklyLowCarbStreak}
${weeklyRefeedAlert
  ? `  STRATEGIC REFEED REQUIRED: ${weeklyLowCarbStreak} consecutive days in ${weeklyMetabolicState}. Must be addressed in priorities -- 50-100g complex carbs (oats, sweet potato, rice) on next training day.`
  : `  No refeed required.`}

PER-DAY LOG
${dayLines}

${missingNote}

USER CONTEXT
  Weight: ${weight}kg | Height: ${height}cm
  Activity: ${sanitiseForPrompt(goal||"moderate").slice(0,60)}
  TARGET_WEIGHT: ${targetWeight ? targetWeight + 'kg (user set)' : 'not set'}
${physiqueGoal
  ? `  Physique goal: "${sanitiseForPrompt(physiqueGoal)}"
  PHYSIQUE SCALING: If TARGET_WEIGHT is marked as '(user set)', always use it as the authoritative target weight — never estimate from athlete comparisons or physique descriptions. Only estimate a target weight from the physique goal if TARGET_WEIGHT is 'not set'.`
  : "  No specific physique goal set."}

${weightLogBlock}

30-DAY PROJECTION (pre-computed, use these numbers in summary):
  7-day average: ${avg.calories} kcal/day. Target: ${targets.calories} kcal/day.
  Gap: ${avg.calories < targets.calories ? Math.round(targets.calories - avg.calories) + ' kcal/day UNDER target — losing weight slightly FASTER than planned' : avg.calories > targets.calories ? Math.round(avg.calories - targets.calories) + ' kcal/day OVER target — losing weight slightly SLOWER than planned' : 'exactly on target'}
  Over 30 days: projected ${Math.abs(((avg.calories - targets.calories) * 30 / 7700)).toFixed(2)}kg ${avg.calories < targets.calories ? "faster progress" : avg.calories > targets.calories ? "slower progress" : "on track"}.
  RULE: Under target = FASTER progress. Over target = SLOWER progress. The target already contains the deficit. This is absolute — never say the opposite.
  Use ONLY these pre-computed numbers for the projection. Do not calculate independently.

CALORIE_VERDICT: ${calVerdict}
IMPORTANT: Use CALORIE_VERDICT verbatim in both NUTRITION section and GAPS TO FIX. Do not calculate calories independently. Copy the direction (over/under) exactly as stated here.
NUTRITION_OPENING_SENTENCE (copy this verbatim as the first sentence of summary — do not change any numbers): ${nutritionOpeningSentence}
CALORIE_GAP_SENTENCE: ${calorieGapSentence || 'Calories are under target — do not list calories as a gap at all.'}
WEEKLY_CALORIE_STATUS: ${calVerdict}
WEEKLY_PROTEIN_STATUS: ${avg.protein >= targets.protein ? 'OVER target by ' + Math.round(avg.protein - targets.protein) + 'g/day on average' : 'UNDER target by ' + Math.round(targets.protein - avg.protein) + 'g/day on average'}
WEEKLY_CARBS_STATUS: ${avg.carbs >= targets.carbs ? 'OVER target by ' + Math.round(avg.carbs - targets.carbs) + 'g/day on average' : 'UNDER target by ' + Math.round(targets.carbs - avg.carbs) + 'g/day on average'}
WEEKLY_FAT_STATUS: ${avg.fat >= targets.fat ? 'OVER target by ' + Math.round(avg.fat - targets.fat) + 'g/day on average' : 'UNDER target by ' + Math.round(targets.fat - avg.fat) + 'g/day on average'}
WEEKLY_FIBRE_STATUS: ${Math.round(avg.fibre)}g/day average
WEEKLY_SUGAR_STATUS: ${Math.round(avg.sugar)}g/day average${avg.sugar > 30 ? ' — consistently elevated' : ''}
WEEKLY_SODIUM_STATUS: ${Math.round(avg.sodium)}mg/day average${avg.sodium > 2300 ? ' — consistently elevated' : ''}
WEEKLY_WATER_STATUS: ${avgWater >= hydrationTarget ? 'ON TRACK — ' + Math.round(avgWater) + 'ml/day average' : 'UNDER target by ' + Math.round(hydrationTarget - avgWater) + 'ml/day on average'}
Use WEEKLY_*_STATUS fields as authoritative — do not recalculate averages or interpret raw numbers directly.

WEEKLY_WORKOUTS: ${weekSessions} sessions logged, ${weekWorkoutCalories} kcal burned from exercise
WORKOUT CONSISTENCY LAW: Reference the user's workout consistency as part of the weekly analysis. If they trained multiple times, acknowledge it. If zero sessions, note it.
BODY_MEASUREMENTS: ${latestMeasurement ? 'Latest: Weight ' + (latestMeasurement.weight_kg||'?') + 'kg' + (latestMeasurement.body_fat_pct ? ', Body fat ' + latestMeasurement.body_fat_pct + '%' : '') + (latestMeasurement.waist_cm ? ', Waist ' + latestMeasurement.waist_cm + 'cm' : '') + (prevMeasurement ? ' | Previous: Weight ' + (prevMeasurement.weight_kg||'?') + 'kg' + (prevMeasurement.waist_cm ? ', Waist ' + prevMeasurement.waist_cm + 'cm' : '') : '') : 'No body measurements logged'}
BODY_COMPOSITION_LAW: If body measurement data is available, reference physical progress trends in your analysis. Weight on the scale alone does not tell the full story — reference body composition changes where data exists.

FINAL CHECK: Read CALORIE_VERDICT above. Is it OVER TARGET or UNDER TARGET? Use that exact direction in every section — do not recalculate.
CALORIE_CONSISTENCY: Both NUTRITION and GAPS TO FIX must reflect CALORIE_VERDICT. If CALORIE_VERDICT says UNDER TARGET, GAPS cannot call calories a gap. If CALORIE_VERDICT says OVER TARGET, NUTRITION cannot say the user is eating below target. No exceptions.
PARTIAL_DAY_CHECK: Does GAPS TO FIX or NEGATIVES mention today's date (${today})? If yes — remove it. Today is not complete and must never appear as a gap or failure.
SUPPLEMENT_CHECK: Scan entire response for "supplement", "doses", "adherence". Remove every instance. Weekly briefing covers nutrition, training, and water only.
CONSISTENCY CHECK: Does any section contradict CALORIE_VERDICT? Fix it before outputting.
BANNED TERMS — remove before submitting: "substrate", "substrate utilisation", "catabolic", "anabolic", "leucine", "MPS", "glycogen", "glycogen replenishment", "thermoregulation", "thermogenesis", "metabolic efficiency", "metabolic rate", "normal metabolic state", "satiety signals", "lean mass preservation", "lean mass loss", "fat loss trajectory", "weight loss trajectory", "pro-rata", "kick your metabolism", "ketogenic state", "ketosis". Plain English replacements: "satiety signals" → "how full you feel"; "lean mass preservation" → "holding on to muscle"; "lean mass loss" → "muscle loss"; "metabolic efficiency" / "metabolic rate" / "normal metabolic state" → "training consistency" or "your energy and recovery". Replace all instances before outputting.
SELF-CALCULATION BAN: Never calculate derived figures not in the injected data (e.g. "reducing fat loss by Xg"). Only use numbers explicitly provided in the prompt.
ACCURACY CHECK: If listing specific days with deficits, verify the number matches the threshold stated. Do not say "exceeding 10g" if the deficit is 8g. Use the exact number from the data.
GAP_THRESHOLD: Only list something in GAPS TO FIX if the deviation is meaningful — at least 5% from target. A 2g fat overage on an 82g target is noise, not a gap. Do not waste a gap slot on trivial deviations.
THRESHOLD FINAL CHECK: Before outputting — scan every item in pros and negatives: Fat target is ${targets.fat}g. A 2g deviation = ${Math.round(2/Math.max(targets.fat,1)*100)}% — below threshold, remove from pros and negatives. Fiber target is ${targets.fibre||30}g. Only include fiber if deviation exceeds ${Math.round((targets.fibre||30)*0.05)}g. Protein target is ${targets.protein}g. Only include protein if deviation exceeds ${Math.round(targets.protein*0.05)}g. Water target is ${hydrationTarget}ml — a 500ml+ deviation is always above threshold and should be included. Only include items above the 5% threshold.
LOGGING_CHECK: Never reference a number of logged days that exceeds 7. If you find yourself writing "8 out of 7" or any number over 7 for days logged — remove the entire sentence.
Respond ONLY with the JSON object. No preamble. No commentary. Start with {`;

      const raw = await llmFetch({
        model:       LLM_MODEL_HEAVY,
        max_tokens:  1800,
        temperature: 0.7,
        reasoning_effort: "none",
        messages: [
          { role: "system", content: WEEKLY_SYSTEM },
          { role: "user",   content: weeklyPrompt  },
        ],
      });

      const parsed = splitWeeklyResponse(raw);

      // ── Post-process: enforce correct calorie figures regardless of model output ──
      const caloriesOverTarget = avg.calories > targets.calories;
      const correctCalorieGap = caloriesOverTarget
        ? `Calorie intake averaged ${avg.calories} kcal/day — ${avg.calories - targets.calories} kcal above the ${targets.calories} target.`
        : null;

      // FIX 1: Replace first sentence of summary with the JS-built nutrition opening
      if (parsed.summary) {
        const summarySentences = parsed.summary.split(/(?<=[.!?])\s+/);
        summarySentences[0] = nutritionOpeningSentence;
        parsed.summary = summarySentences.join(' ');
      }

      // FIX 2: Remove any calorie-related entries from negatives, inject correct one if over target
      if (parsed.negatives) {
        parsed.negatives = parsed.negatives.filter(n => {
          const l = n.toLowerCase();
          return !l.includes('calori') && !l.includes('kcal') &&
                 !l.includes('204') && !l.includes('1967') && !l.includes('25 kcal');
        });
        if (correctCalorieGap) {
          parsed.negatives.unshift(correctCalorieGap);
        }
        // Keep array at max 3 items
        parsed.negatives = parsed.negatives.slice(0, 3);
      }

      // FIX 3: Strip any rogue calorie figures from summary that slipped past sentence[0] replacement
      if (parsed.summary) {
        parsed.summary = parsed.summary
          .split(/(?<=[.!?])\s+/)
          .filter(s => !s.includes('204') && !s.includes('1967'))
          .join(' ');
      }

      setWbSummary(parsed.summary    || "Model returned empty output. Check the endpoint.");
      setWbPros(parsed.pros.length        ? parsed.pros        : ["No positive data parsed."]);
      setWbNegatives(parsed.negatives.length ? parsed.negatives : ["No negatives data parsed."]);
      setWbPriorities(parsed.priorities.length ? parsed.priorities : ["No priorities data parsed."]);
      const now = Date.now();
      setWeeklyTs(now);
      try { localStorage.setItem("np_weekly_ts", String(now)); } catch(_){}

    } catch(e) {
      const msg = llmErrMsg(e);
      setWbSummary(msg);
      setWbPros([]); setWbNegatives([]); setWbPriorities([]);
    }
    setWeeklyLoading(false);
  }

  // ─── V27 FIX 9: Cross-app weekly summary ──────────────────────────────────
  async function runCrossAppWeeklySummary() {
    if (!session || !effectiveIsPremium) return;
    setCrossAppLoading(true); setCrossAppData(null);
    try {
      const sevenAgo = new Date(); sevenAgo.setDate(sevenAgo.getDate() - 7);
      const sevenAgoISO = sevenAgo.toISOString().slice(0, 10);
      // Fetch workout sessions for last 7 days
      let wkSess = 0, wkCals = 0, wkVol = 0;
      try {
        const { data: ws } = await supabase
          .from("workout_sessions").select("id,name,duration,calories_burned,exercises,date")
          .eq("user_id", session.user.id).gte("date", sevenAgoISO);
        wkSess = (ws || []).length;
        wkCals = (ws || []).reduce((s, w) => s + (w.calories_burned || 0), 0);
        wkVol = (ws || []).reduce((s, w) => {
          const exs = typeof w.exercises === "string" ? JSON.parse(w.exercises) : (w.exercises || []);
          return s + exs.reduce((a, ex) => a + (ex.sets || []).reduce((b, st) => b + ((st.done && st.weight && st.reps) ? st.weight * st.reps : 0), 0), 0);
        }, 0);
      } catch(_) {}
      // Fetch water logs for last 7 days — exclude today (partial day)
      let waterStatus = "Not logged this week";
      let crossAppWaterAvg = 0;
      try {
        const todayForWater = new Date().toISOString().slice(0, 10);
        const last7 = Array.from({ length: 7 }, (_, i) => {
          const d = new Date(); d.setDate(d.getDate() - i); return d.toISOString().slice(0, 10);
        }).filter(d => d !== todayForWater);
        const { data: wLogs } = await supabase
          .from("water_logs").select("log_date,water_ml")
          .eq("user_id", session.user.id).in("log_date", last7);
        if (wLogs && wLogs.length > 0) {
          const avgW = Math.round(wLogs.reduce((s, r) => s + (r.water_ml || 0), 0) / wLogs.length);
          crossAppWaterAvg = avgW;
          waterStatus = avgW >= hydrationTarget
            ? `ON TRACK — averaging ${avgW}ml/day vs ${hydrationTarget}ml target`
            : `${hydrationTarget - avgW}ml/day under target — averaging ${avgW}ml/day`;
        }
      } catch(_) {}
      // Supplement data intentionally removed — weekly briefing must not reference supplements
      // Use existing log history for nutrition — exclude today (partial day)
      const todayISO = new Date().toISOString().slice(0, 10);
      const nutDays = (logHistory || []).filter(d => d.logged && d.date >= sevenAgoISO && d.date !== todayISO);
      const n = nutDays.length || 1;
      const avgCal = Math.round(nutDays.reduce((s, d) => s + (d.calories || 0), 0) / n);
      const avgProt = Math.round(nutDays.reduce((s, d) => s + (d.protein || 0), 0) / n);
      const raw = await llmFetch({
        model: LLM_MODEL_HEAVY,
        reasoning_effort: "none",
        max_tokens: 600,
        temperature: 0.7,
        messages: [
          { role: "system", content: `${AI_PERSONA_VOICE[persona] || AI_PERSONA_VOICE.Balanced} You are a holistic performance analyst reviewing both nutrition and training data for one person. FIELD_INSTRUCTIONS: headline — one punchy verdict sentence on the whole week. nutrition_verdict — 2-3 sentences, what nutrition means for the goal. training_verdict — 2-3 sentences, what training means for recovery and progress. combined_insight — the most important connection between nutrition and training this week. next_week_focus — the single most important priority, specific and actionable. PLAIN_ENGLISH_LAW: No science jargon. Banned: leucine, MPS, glycogen, substrate, anabolic, catabolic, thermogenesis, metabolic efficiency, satiety signals, lean mass preservation, metabolic rate, basal metabolic rate, muscle protein synthesis, glycogen resynthesis, leucine threshold, substrate utilisation, normal metabolic state, kick your metabolism. SPECIFICITY_LAW: Every sentence references a specific number. Return ONLY valid JSON. No markdown. ${AI_SAFETY_LAW} UK_LAW: Write in UK English. Use UK spelling throughout. UNDER_TARGET_LAW: If weekly average calories are below target, frame this as slightly ahead of schedule — not as undereating, a deficit, or a risk. Apply this framing in nutrition_verdict, combined_insight, and next_week_focus equally.` },
          { role: "user", content: `WEEKLY_NUTRITION: Avg ${avgCal} kcal/day, ${avgProt}g protein/day, ${nutDays.length}/7 days logged. Target: ${targets.calories} kcal/day.\nWEEKLY_TRAINING: ${wkSess} sessions, ${Math.round(wkVol)}kg total volume, ${wkCals} kcal burned from exercise.\nWEEKLY_WATER: ${waterStatus}\nGOAL: ${sanitiseForPrompt(physiqueGoal) || "General fitness"}\nTARGET_WEIGHT: ${targetWeight || "Not set"}kg\nCURRENT_WEIGHT: ${weight}kg\n\nOutput JSON: {"headline":"string","nutrition_verdict":"string","training_verdict":"string","combined_insight":"string","next_week_focus":"string"} — one sentence each. Never mention supplements.` },
        ],
      });
      const cleaned = cleanAIResponse(raw);
      const parsed = JSON.parse(cleaned);
      if (!parsed.headline) throw new Error("Missing headline in response");
      // Post-process: replace nutrition_verdict first sentence with JS-built calorie truth
      if (parsed.nutrition_verdict) {
        const calDiff = Math.abs(avgCal - targets.calories);
        const correctOpening = avgCal > targets.calories
          ? `This week you averaged ${avgCal} kcal/day — ${calDiff} kcal above your ${targets.calories} kcal target, which means progress toward ${targetWeight ? targetWeight + 'kg' : 'your goal'} is slightly slower than planned.`
          : `This week you averaged ${avgCal} kcal/day — ${calDiff} kcal below your ${targets.calories} kcal target, which means you are progressing toward ${targetWeight ? targetWeight + 'kg' : 'your goal'} slightly faster than planned.`;
        const nvSentences = parsed.nutrition_verdict.split(/(?<=[.!?])\s+/);
        nvSentences[0] = correctOpening;
        parsed.nutrition_verdict = nvSentences.join(' ');
      }
      // Aggressively strip supplement/vitamin references from all string fields
      const stripSupplements = (text) => {
        if (!text) return text;
        return text
          .split(/(?<=[.!?])\s+/)
          .filter(s => {
            const low = s.toLowerCase();
            return !low.includes('supplement') && !low.includes('doses') &&
              !low.includes('adherence') && !low.includes('vitamin') &&
              !low.includes('magnesium') && !low.includes('zinc') &&
              !low.includes('fish oil') && !low.includes('creatine') &&
              !low.includes('omega');
          })
          .join(' ')
          .trim();
      };
      Object.keys(parsed).forEach(key => {
        if (typeof parsed[key] === 'string') parsed[key] = stripSupplements(parsed[key]);
      });
      // Fix water figures to match completedDays average
      if (crossAppWaterAvg > 0) {
        const fixWater = (text) => {
          if (!text) return text;
          return text.replace(/(\d+)ml\/day/g, (match, val) => {
            const v = parseInt(val);
            if (v > 1500 && v < 3500 && v !== crossAppWaterAvg) return `${crossAppWaterAvg}ml/day`;
            return match;
          });
        };
        if (parsed.nutrition_verdict) parsed.nutrition_verdict = fixWater(parsed.nutrition_verdict);
        if (parsed.combined_insight) parsed.combined_insight = fixWater(parsed.combined_insight);
      }
      setCrossAppData(parsed);
    } catch(e) {
      Sentry.captureException(e, { extra: { context: "crossAppSummary" } }); console.error("[crossAppSummary]", e.message);
      setCrossAppData({ headline: "Summary unavailable — please try again.", nutrition_verdict: "", training_verdict: "", combined_insight: "", next_week_focus: "" });
    }
    setCrossAppLoading(false);
  }

  // ─── V27 FIX 10: Body composition projector ───────────────────────────────
  async function runBodyCompositionProjector() {
    if (!session || !effectiveIsPremium) return;
    setBodyProjLoading(true); setBodyProjData(null);
    try {
      const wlSorted = [...(weightLogs || [])].sort((a,b) => new Date(a.logged_at) - new Date(b.logged_at));
      const wl30 = wlSorted.slice(-30);
      const weightTrend = wl30.length >= 2
        ? ((parseFloat(wl30[wl30.length-1].weight_kg) - parseFloat(wl30[0].weight_kg)) / Math.max(1, wl30.length) * 7).toFixed(2)
        : "insufficient data";
      // V131: Use 7-day rolling average (excluding today) — same methodology as daily audit & weekly briefing
      const todayIso = new Date().toISOString().slice(0, 10);
      const last7Logged = (logHistory || []).filter(d => d.logged && d.date !== todayIso && (d.calories||0) > 0).slice(-7);
      const avgDayCount = last7Logged.length;
      const avgCal = avgDayCount > 0 ? Math.round(last7Logged.reduce((s,d) => s + (d.calories||0), 0) / avgDayCount) : 0;
      const avgBasis = avgDayCount >= 7 ? "7-day average" : avgDayCount > 0 ? `last ${avgDayCount} day${avgDayCount!==1?"s":""} average` : "no data";
      const raw = await llmFetch({
        model: LLM_MODEL_LIGHT,
        max_tokens: 400,
        temperature: 0.3,
        messages: [
          { role: "system", content: `${AI_PERSONA_VOICE[persona] || AI_PERSONA_VOICE.Balanced} You are a body composition analyst. FIELD_INSTRUCTIONS: current_trajectory_30d and 90d — what happens if nothing changes, in plain language with real weight numbers. on_target_trajectory_30d and 90d — what happens if they hit targets, make it vivid and motivating. key_insight — the single biggest driver or blocker, one sentence. time_to_goal — honest estimates. All fields must reference actual target weight (${targetWeight||'not set'}kg) and current weight (${weight}kg). PLAIN_ENGLISH_LAW: No science jargon. Banned: leucine, MPS, glycogen, substrate, anabolic, catabolic, thermogenesis, metabolic efficiency, satiety signals, lean mass preservation, metabolic rate, basal metabolic rate, muscle protein synthesis, glycogen resynthesis, leucine threshold, substrate utilisation, normal metabolic state. Return ONLY valid JSON. No markdown. ${AI_SAFETY_LAW} UK_LAW: Write in UK English. Use UK spelling throughout. UNDER_TARGET_LAW: If calories are below target, frame this as slightly ahead of schedule — not as a deficit or risk.` },
          { role: "user", content: `BODY_MEASUREMENTS: ${(()=>{ const m = bodyMeasurements?.[0]; return m ? `Waist: ${m.waist_cm||'not logged'}cm, Body fat: ${m.body_fat_pct||'not logged'}%` : 'Not logged'; })()}\nCURRENT_WEIGHT: ${weight}kg\n30_DAY_WEIGHT_TREND: ${weightTrend} kg/week\n7_DAY_CALORIE_AVERAGE: ${avgCal} kcal/day (${avgBasis}) vs ${targets.calories} target\nGOAL_MODE: ${goalMode || "not set"}\nTARGET_WEIGHT: ${targetWeight || "not set"}kg\n\nProject body composition changes based on the 7-day calorie average (not today's intake alone). Output JSON: {"current_trajectory_30d":"string","current_trajectory_90d":"string","on_target_trajectory_30d":"string","on_target_trajectory_90d":"string","key_insight":"string","time_to_goal_current":"string","time_to_goal_optimised":"string","avg_basis":"string (e.g. Based on your 7-day average of 2332 kcal/day)"} — each value is one sentence.` },
        ],
      });
      const cleaned = cleanAIResponse(raw);
      setBodyProjData(JSON.parse(cleaned));
    } catch(e) { if (process.env.NODE_ENV !== "production") console.warn("[bodyProjError]", e); }
    setBodyProjLoading(false);
  }

  // ─── V27 FIX 11: Smart meal prep planner ──────────────────────────────────
  async function runMealPrepPlanner() {
    if (!session || !effectiveIsPremium) return;
    if (!targets.calories || targets.calories < 800) {
      setMealPrepError("Set your daily calorie targets first (Settings → Generate Targets).");
      return;
    }
    setMealPrepLoading(true); setMealPrepData(null); setMealPrepError("");
    try {
      // Get frequent foods from log history
      const foodCounts = {};
      (logs || []).concat((logHistory || []).flatMap(d => d.items || [])).forEach(item => {
        if (item?.name) foodCounts[item.name] = (foodCounts[item.name] || 0) + 1;
      });
      const topFoods = Object.entries(foodCounts).sort((a,b) => b[1] - a[1]).slice(0, 10).map(([name]) => name);
      const raw = await llmFetch({
        model: LLM_MODEL_LIGHT,
        max_tokens: 1500,
        temperature: 0.4,
        messages: [
          { role: "system", content: `You are a practical meal prep specialist for UK adults. Create a realistic 3-day meal prep plan using foods available in UK supermarkets. REAL_FOOD_LAW: Every meal MUST have a descriptive name — e.g. "Scrambled eggs with wholemeal toast", NOT just "Breakfast" or macro targets. The slot field is the meal type (Breakfast/Lunch/Dinner/Snack), the name field is the actual food description. PREP_LAW: For each meal include a "prep" field: 1-2 sentences of practical preparation instructions under 20 words. Reference UK supermarket ingredients. No chef techniques. VARIETY_LAW: Vary meals across days. UK_SHOPPING_LAW: Shopping list must reference actual ingredients with quantities. Return ONLY valid JSON. No markdown, no explanation, no preamble. ${AI_SAFETY_LAW}` },
          { role: "user", content: `DAILY_TARGETS: ${targets.calories} kcal, ${targets.protein}g protein, ${targets.carbs}g carbs, ${targets.fat}g fat\nGOAL_MODE: ${goalMode || "general fitness"}\nFREQUENT_FOODS: ${topFoods.length > 0 ? topFoods.join(", ") : "No history yet"}\nPHYSIQUE_GOAL: ${sanitiseForPrompt(physiqueGoal) || "General fitness"}\n\nCreate a 3-day meal prep plan. 3 meals + 1 snack per day. UK supermarket foods only.\n\nOutput JSON: {"prep_sessions":[{"day":"string","meals":[{"slot":"Breakfast|Lunch|Dinner|Snack","name":"string","prep":"string (brief prep instructions)","calories":0,"protein":0,"carbs":0,"fat":0}]}],"shopping_list":[{"item":"string","quantity":"string"}],"total_prep_time_mins":0}` },
        ],
      });
      const cleaned = cleanAIResponse(raw);
      const parsed = JSON.parse(cleaned);
      if (!parsed.prep_sessions || !Array.isArray(parsed.prep_sessions)) {
        throw new Error("Invalid meal plan structure — missing prep_sessions");
      }
      setMealPrepData(parsed);
    } catch(e) {
      console.error('runMealPrepPlanner error:', e);
      console.error('Error message:', e?.message);
      setMealPrepError("Could not generate meal plan. Please try again.");
    }
    setMealPrepLoading(false);
  }

  // ─── LAYOUT SHELLS ─────────────────────────────────────────────────────────
  // shell/phone already use T — T is live at this point (Object.assign ran above)
  // V24 FIX 4: 100dvh + safe-area-inset-top for Android status bar / notch
  const shell={minHeight:"100dvh",background:T.bg,display:"flex",flexDirection:"column",fontFamily:T.fontSans};
  const phone={
    width:"100%",background:T.bg,minHeight:"100dvh",
    display:"flex",flexDirection:"column",
    paddingBottom:110, // Accounts for BottomNav: tabs (~50px) + switcher row (~30px) + margin
  };

  // ─── LOADING ───────────────────────────────────────────────────────────────
  // V42: Gate on BOTH authReady AND profileLoading.
  // Without this, screen briefly flashes onboard before profile loads.
  const _queueLen = !isOnline ? getQueueLength() : 0;
  const _queueFull = !isOnline && isQueueFull();
  const OfflineBanner = !isOnline ? (
    <div style={{
      width:"100%",background:_queueFull ? T.accent : T.red,color:_queueFull ? T.ink : T.card,
      fontFamily:T.fontSans,fontSize:10,fontWeight:"bold",
      textAlign:"center",padding:"6px 16px",boxSizing:"border-box",flexShrink:0,
    }}>
      {_queueFull
        ? "Offline — queue full. Some items may not be saved. Reconnect to sync."
        : `Offline${_queueLen > 0 ? ` — ${_queueLen} change${_queueLen===1?"":"s"} queued` : " — data may not save until you’re back online"}.`}
    </div>
  ) : null;

  // V25 FIX 5: streak computation memoised with Map for O(1) lookup
  const progressStreakData = useMemo(() => {
    const _lhSorted = [...(logHistory||[])].sort((a,b)=>a.date<b.date?-1:1);
    const logMap = new Map(_lhSorted.map(x => [x.date, x]));
    let _cur=0, _best=0, _run=0, _prev=null;
    for (const e of _lhSorted) {
      if (!e.logged) { _run=0; _prev=null; continue; }
      if (!_prev) { _run=1; }
      else {
        const exp=new Date(_prev+"T00:00:00"); exp.setDate(exp.getDate()+1);
        _run = e.date===exp.toISOString().slice(0,10) ? _run+1 : 1;
      }
      _best=Math.max(_best,_run); _prev=e.date;
    }
    const _today=new Date();
    for (let i=0;i<365;i++) {
      const _d=new Date(_today); _d.setDate(_d.getDate()-i);
      const _iso=_d.toISOString().slice(0,10);
      const _e=logMap.get(_iso);
      if (_e&&_e.logged) { _cur++; } else if (i>0) { break; }
    }
    // V159 FIX 4: best streak must reflect current streak if it exceeds historical best
    _best = Math.max(_best, _cur);
    return { currentStreak:_cur, bestStreak:_best };
  }, [logHistory]);

  // ── PASSWORD RESET CALLBACK SCREEN ──────────────────────────────────────────
  // Shown when the user clicks the reset link in their email and Supabase
  // fires the PASSWORD_RECOVERY event via onAuthStateChange.
  if (isPasswordReset) return (
    <div style={{
      minHeight:"100dvh", background:T.bg,
      display:"flex", alignItems:"center",
      justifyContent:"center", padding:20,
      fontFamily:T.fontSans,
    }}>
      <div style={{width:"100%", maxWidth:380}}>
        <ComicCard>
          <p style={{textAlign:"center",fontSize:28,marginBottom:8}}>🔐</p>
          <h2 style={{
            fontFamily:T.fontHead, fontSize:18, fontWeight:900,
            color:T.text, textAlign:"center",
            margin:"0 0 6px", letterSpacing:"-0.01em",
          }}>
            Set New Password
          </h2>
          <p style={{
            color:T.textDim, fontSize:12, textAlign:"center",
            margin:"0 0 20px", lineHeight:1.6,
          }}>
            Choose a strong password for your account.
          </p>
          {newPasswordDone ? (
            <>
              <p style={{
                color:T.secondary, fontSize:13, textAlign:"center",
                fontWeight:700, margin:"0 0 16px",
              }}>
                ✅ Password updated successfully
              </p>
              <Btn onClick={() => {
                setIsPasswordReset(false);
                setNewPasswordDone(false);
                setNewPassword("");
              }}>
                Sign In
              </Btn>
            </>
          ) : (
            <>
              <Field
                label="New Password"
                type="password"
                value={newPassword}
                onChange={e => setNewPassword(e.target.value)}
                placeholder="Minimum 8 characters"
              />
              {newPasswordErr && (
                <p style={{
                  color:T.red, fontSize:11,
                  margin:"8px 0 12px", textAlign:"center",
                  fontFamily:T.fontSans, fontWeight:"bold",
                }}>
                  {newPasswordErr}
                </p>
              )}
              <Btn
                disabled={newPasswordLoading || newPassword.length < 8}
                onClick={async () => {
                  setNewPasswordLoading(true);
                  setNewPasswordErr("");
                  const { error } = await supabase.auth.updateUser({
                    password: newPassword,
                  });
                  if (error) {
                    setNewPasswordErr(error.message);
                  } else {
                    setNewPasswordDone(true);
                  }
                  setNewPasswordLoading(false);
                }}
              >
                {newPasswordLoading
                  ? <><Spinner size={14}/> Updating...</>
                  : "Update Password"}
              </Btn>
            </>
          )}
        </ComicCard>
      </div>
    </div>
  );

  if (!authReady || (session && profileLoading)) return (
    <div style={{...shell,alignItems:"center"}}>
      <div style={{textAlign:"center"}}>
        <Spinner size={32}/>
        <p style={{color:T.textSub,fontSize:13,fontFamily:T.fontSans,fontWeight:"bold",marginTop:16}}>
          {!authReady ? "Connecting to Supabase…" : "Loading your profile…"}
        </p>
      </div>
    </div>
  );

  // ==============================================================================
  // SCREEN: LAUNCH — app selection shown on every load/refresh, before auth and
  // before dashboard. Tapping NutriLithe dismisses. Tapping LiftLithe navigates.
  // ==============================================================================
  // V101: Skip launch screen for logged-in users with targets — they've already chosen NutriLithe
  if (showLaunch && !(session && hasTargets)) return (
    <div style={{...shell,alignItems:"center",justifyContent:"center"}}>
      <div style={{width:"100%",maxWidth:420,padding:"32px 20px",boxSizing:"border-box",display:"flex",flexDirection:"column",alignItems:"center",gap:32}}>
        {/* Logo / brand */}
        <div style={{textAlign:"center"}}>
          <div style={{display:"inline-flex",alignItems:"center",gap:10,marginBottom:6}}>
            <div style={{background:T.accent,padding:"8px 10px",border:T.border,boxShadow:T.shadow,borderRadius:T.radiusSm}}>
              <Lightning size={24} color={T.ink} weight="bold"/>
            </div>
            <span style={{color:T.accent,fontSize:34,fontWeight:900,fontFamily:T.fontSans,letterSpacing:"3px",textTransform:"uppercase",lineHeight:1}}>
              LITHE
            </span>
          </div>
          <p style={{color:T.textSub,fontSize:10,fontFamily:T.fontSans,fontWeight:"bold",margin:0,letterSpacing:"2px",textTransform:"uppercase"}}>
            Choose your app
          </p>
        </div>

        {/* App tiles */}
        <div style={{width:"100%",display:"flex",flexDirection:"column",gap:12}}>
          {/* NutriLithe tile */}
          <button
            onClick={()=>{ setShowLaunch(false); try{ localStorage.setItem("lithe_app","nutri"); }catch(_){} }}
            style={{
              width:"100%",background:T.card,border:`2px solid ${T.accent}`,
              boxShadow:T.shadow,padding:"22px 20px",cursor:"pointer",
              display:"flex",alignItems:"center",gap:16,textAlign:"left",
            }}>
            <div style={{background:T.accent,padding:"10px",border:T.border,flexShrink:0,borderRadius:T.radiusSm}}>
              <Lightning size={22} color={T.ink} weight="bold"/>
            </div>
            <div>
              <p style={{color:T.accent,fontSize:16,fontWeight:900,fontFamily:T.fontSans,
                margin:"0 0 3px",letterSpacing:"1px",textTransform:"uppercase"}}>NutriLithe</p>
              <p style={{color:T.textSub,fontSize:10,fontFamily:T.fontSans,fontWeight:"bold",margin:0}}>
                Nutrition tracking & AI audit
              </p>
            </div>
            <div style={{marginLeft:"auto",color:T.accent,fontSize:18,fontWeight:900,fontFamily:T.fontSans}}>&#8250;</div>
          </button>

          {/* LiftLithe tile */}
          <button
            onClick={()=>{ window.location.assign("/workout"); }} // V24 FIX 2
            style={{
              width:"100%",background:T.card,border:`2px solid ${T.secondary}`,
              boxShadow:T.shadow,padding:"22px 20px",cursor:"pointer",
              display:"flex",alignItems:"center",gap:16,textAlign:"left",
            }}>
            <div style={{background:T.secondary,padding:"10px",border:T.border,flexShrink:0,borderRadius:T.radiusSm}}>
              <ChartBar size={22} color={T.ink} weight="bold"/>
            </div>
            <div>
              <p style={{color:T.secondary,fontSize:16,fontWeight:900,fontFamily:T.fontSans,
                margin:"0 0 3px",letterSpacing:"1px",textTransform:"uppercase"}}>LiftLithe</p>
              <p style={{color:T.textSub,fontSize:10,fontFamily:T.fontSans,fontWeight:"bold",margin:0}}>
                Workout tracking & programmes
              </p>
            </div>
            <div style={{marginLeft:"auto",color:T.secondary,fontSize:18,fontWeight:900,fontFamily:T.fontSans}}>&#8250;</div>
          </button>
        </div>

        <p style={{color:T.textDim,fontSize:8,fontFamily:T.fontSans,fontWeight:"bold",
          margin:0,letterSpacing:"1px",textTransform:"uppercase"}}>
          lithe.fit
        </p>
      </div>
    </div>
  );
  if (!session) return (
    <div style={shell}><div style={phone}>
      {OfflineBanner}
      <div style={{background:getHeaderBg(persona),padding:"16px 16px 12px"}}>
        <div style={{display:"flex",alignItems:"center",gap:10}}>
          <img src="/logo192.png" alt="LF" width={38} height={38}
            style={{borderRadius:11,objectFit:"cover",flexShrink:0}}/>
          <div>
            <h1 style={{color:"#fff",fontSize:30,fontWeight:800,margin:0,fontFamily:T.fontDisplay,letterSpacing:"-0.5px",lineHeight:1}}>
              Lithe.Fit
            </h1>
            <p style={{color:"rgba(255,255,255,0.7)",fontSize:11,margin:"2px 0 0",fontFamily:T.fontDisplay,fontWeight:500}}>
              Lithe.Fit · {authScreen==="login"?"Sign in":authScreen==="reset"?"Reset password":"Create account"}
            </p>
          </div>
        </div>
      </div>
      <div style={{padding:"24px 16px 48px",flex:1,overflowY:"auto",background:T.bg,display:"flex",flexDirection:"column",justifyContent:"center"}}>
        <div style={{display:"flex",border:T.border,boxShadow:T.shadowSm,marginBottom:20,borderRadius:T.radiusSm,overflow:"hidden"}}>
          {[{id:"login",label:"Sign In"},{id:"signup",label:"Create Account"}].map(({id,label},i)=>(
            <button key={id} onClick={()=>{setAuthScreen(id);setAuthErr("");setResetOk("");setGdprConsent(false);}} style={{
              flex:1,padding:"12px 0",
              background:authScreen===id?T.primary:T.surface,
              border:"none",borderRight:i===0?T.border:"none",
              color:authScreen===id?"#fff":T.textDim,
              fontSize:12,fontWeight:700,fontFamily:T.fontSans,
              cursor:"pointer",
            }}>{label}</button>
          ))}
        </div>
        <ComicCard>
          {authScreen==="signup"&&(
            <Field label="Display Name" value={authName} onChange={e=>setAuthName(e.target.value)}
              placeholder="Alex, Jordan, Dr. Smith…" icon={<User size={14} weight="bold"/>}/>
          )}
          <Field label="Email Address" value={authEmail}
            onChange={e=>setAuthEmail(e.target.value)}
            onKeyDown={e=>e.key==="Enter"&&(authScreen==="login"?handleLogin():authScreen==="reset"?handleReset(e):handleSignup())}
            placeholder="you@example.com" type="email" icon={<EnvelopeSimple size={14} weight="bold"/>}/>
          {authScreen!=="reset"&&(
            <Field label="Password" value={authPass}
              onChange={e=>setAuthPass(e.target.value)}
              onKeyDown={e=>e.key==="Enter"&&(authScreen==="login"?handleLogin():handleSignup())}
              placeholder={authScreen==="signup"?"8+ characters…":"••••••••"}
              type={showPass?"text":"password"} icon={<Lock size={14} weight="bold"/>}
              append={<span onClick={()=>setShowPass(v=>!v)} style={{cursor:"pointer"}}>{showPass?<EyeSlash size={14} weight="bold"/>:<Eye size={14} weight="bold"/>}</span>}/>
          )}
          {authScreen==="login"&&(
            <button onClick={()=>{setAuthScreen("reset");setAuthErr("");setResetOk("");}}
              style={{background:"none",border:"none",cursor:"pointer",color:T.textDim,
                fontSize:10,fontFamily:T.fontSans,fontWeight:"bold",padding:"2px 0 10px",
                textDecoration:"underline",display:"block"}}>
              Forgot password?
            </button>
          )}
          {authScreen==="reset"&&(
            <div style={{marginBottom:10}}>
              <p style={{margin:"0 0 8px",fontSize:11,fontFamily:T.fontSans,color:T.textSub,fontWeight:"bold",lineHeight:1.5}}>
                Enter your email and we'll send a reset link.
              </p>
              {resetOk&&(
                <div style={{background:T.surface,border:`2px solid ${T.primary}`,padding:"9px 12px",color:T.text,fontSize:11,fontFamily:T.fontSans,fontWeight:"bold",marginBottom:10,borderRadius:T.radiusSm}}>
                  {resetOk}
                </div>
              )}
            </div>
          )}
          {authErr&&(
            <div style={{background:authErr.startsWith("Check")?T.surface:`${T.red}14`,border:authErr.startsWith("Check")?`2px solid ${T.primary}`:`1px solid ${T.red}33`,padding:"10px 12px",color:authErr.startsWith("Check")?T.text:T.red,fontSize:12,fontFamily:T.fontSans,fontWeight:"bold",marginBottom:10,display:"flex",gap:8,alignItems:"flex-start",borderRadius:T.radiusSm}}>
              <WarningCircle size={14} weight="bold" style={{flexShrink:0,marginTop:1}}/><span>{authErr}</span>
            </div>
          )}
          {authErr.startsWith("Check")&&(
            <div style={{textAlign:"center",marginBottom:10}}>
              {resendOk?(
                <p style={{margin:0,fontSize:13,fontFamily:T.fontSans,fontWeight:600,color:T.accent}}>{resendOk}</p>
              ):resendCountdown>0?(
                <p style={{margin:0,fontSize:12,fontFamily:T.fontSans,color:T.textDim}}>Resend available in {resendCountdown}s…</p>
              ):(
                <button onClick={handleResend} style={{background:"none",border:"none",cursor:"pointer",color:T.accent,fontSize:13,fontFamily:T.fontSans,fontWeight:600,padding:"4px 0",textDecoration:"underline"}}>
                  Resend confirmation email
                </button>
              )}
            </div>
          )}
          {authScreen==="reset"?(
            <Btn onClick={handleReset} disabled={authLoad||!!resetOk} color={T.primary}>
              {authLoad?<><Spinner/> Sending…</>:<><EnvelopeSimple size={15} weight="bold"/> Send Reset Link</>}
            </Btn>
          ):(
            <>
            {authScreen==="signup"&&(
              <>
              <div style={{display:"flex",gap:8,alignItems:"flex-start",marginBottom:10}}>
                <input type="checkbox" id="age-confirm" checked={ageConfirmed}
                  onChange={e=>setAgeConfirmed(e.target.checked)}
                  style={{marginTop:2,accentColor:T.primary,width:16,height:16,flexShrink:0}}/>
                <label htmlFor="age-confirm" style={{fontSize:11,fontFamily:T.fontSans,color:T.textDim,lineHeight:1.5,cursor:"pointer"}}>I confirm I am 16 years of age or older</label>
              </div>
              <div style={{display:"flex",gap:8,alignItems:"flex-start",marginBottom:10}}>
                <input type="checkbox" id="gdpr-consent" checked={gdprConsent}
                  onChange={e=>setGdprConsent(e.target.checked)}
                  style={{marginTop:2,accentColor:T.primary,width:16,height:16,flexShrink:0}}/>
                <label htmlFor="gdpr-consent" style={{fontSize:11,fontFamily:T.fontSans,color:T.textDim,lineHeight:1.5,cursor:"pointer"}}>
                  I agree to the{" "}
                  <span onClick={(e)=>{e.preventDefault();e.stopPropagation();openExternalLink("https://www.lithe.fit/privacy");}} style={{color:T.primary,textDecoration:"underline",cursor:"pointer"}}>Privacy Policy</span>
                  {" "}and{" "}
                  <span onClick={(e)=>{e.preventDefault();e.stopPropagation();openExternalLink("https://www.lithe.fit/terms");}} style={{color:T.primary,textDecoration:"underline",cursor:"pointer"}}>Terms of Service</span>
                  . I understand this app does not provide medical advice.
                </label>
              </div>
              </>
            )}
            <Btn onClick={authScreen==="login"?handleLogin:handleSignup} disabled={authLoad||(authScreen==="signup"&&(!gdprConsent||!ageConfirmed))} color={T.primary}>
              {authLoad?<><Spinner/> {authScreen==="login"?"Signing In…":"Creating Account…"}</>
                :authScreen==="login"?<><Lightning size={15} weight="bold"/> Sign In</>:<><Plus size={15} weight="bold"/> Create Account</>}
            </Btn>
            </>
          )}
          {authScreen==="reset"&&(
            <button onClick={()=>{setAuthScreen("login");setAuthErr("");setResetOk("");}}
              style={{background:"none",border:"none",cursor:"pointer",color:T.textDim,
                fontSize:10,fontFamily:T.fontSans,fontWeight:"bold",padding:"8px 0 0",
                textDecoration:"underline",display:"block",textAlign:"center",width:"100%"}}>
              Back to Sign In
            </button>
          )}
        </ComicCard>
        <div style={{display:"flex",gap:6,alignItems:"center",justifyContent:"center",marginTop:20}}>
          <Cloud size={13} color={T.primary} weight="bold" style={{flexShrink:0}}/>
          <p style={{color:T.textDim,fontSize:11,fontFamily:T.fontSans,fontWeight:"bold",margin:0,lineHeight:1.5}}>
            Powered by <strong>Supabase</strong>. Data encrypted at rest with Row Level Security.
          </p>
        </div>
      </div>
    </div></div>
  );

  // ==============================================================================
  // TOP-LEVEL MODAL: PROTOCOL ESTABLISHED
  // Rendered outside all screen guards so it overlays Settings, Onboard, or any
  // other screen that triggers generateTargets.
  // ==============================================================================
  const protocolModal = targetBriefing ? (
    <div style={{
      position:"fixed",top:0,left:0,right:0,bottom:0,
      background:T.backdrop,zIndex:9999,
      display:"flex",alignItems:"center",justifyContent:"center",padding:"20px",
    }}>
      <div style={{
        background:T.surface,border:`4px solid ${T.accent}`,
        boxShadow:`8px 8px 0 ${T.ink}`,maxWidth:420,width:"100%",
        fontFamily:T.fontSans,maxHeight:"90vh",overflowY:"auto",
        borderRadius:T.radius,
      }}>
        {/* Header */}
        <div style={{background:T.ink,padding:"14px 18px",display:"flex",alignItems:"center",gap:10}}>
          <Lightning size={18} color={T.accent} weight="bold"/>
          <div>
            <p style={{color:T.accent,fontSize:13,fontFamily:T.fontSans,fontWeight:900,
              margin:0,letterSpacing:"2px",textTransform:"uppercase"}}>PROTOCOL ESTABLISHED</p>
            <p style={{color:T.textDim,fontSize:9,fontFamily:T.fontSans,fontWeight:"bold",margin:0}}>
              AI sports nutritionist analysis complete
            </p>
          </div>
        </div>
        {/* Macros grid */}
        <div style={{padding:"16px 18px 0"}}>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8,marginBottom:12}}>
            {[
              {label:"CALORIES", val:`${targetBriefing.targets.calories} kcal`, color:T.accent},
              {label:"PROTEIN",  val:`${targetBriefing.targets.protein}g`,      color:T.macroProtein},
              {label:"CARBS",    val:`${targetBriefing.targets.carbs}g`,         color:T.macroCarbs},
              {label:"FAT",      val:`${targetBriefing.targets.fat}g`,           color:T.macroFat},
              {label:"FIBRE",    val:`${targetBriefing.targets.fibre}g`,         color:T.textSub},
            ].map(({label,val,color})=>(
              <div key={label} style={{background:T.card,border:T.border,boxShadow:T.shadowXs,padding:"10px 12px",borderRadius:T.radiusSm}}>
                <p style={{color:T.textDim,fontSize:8,fontFamily:T.fontSans,fontWeight:900,
                  letterSpacing:"1px",textTransform:"uppercase",margin:"0 0 3px"}}>{label}</p>
                <p style={{color,fontSize:20,fontFamily:T.fontSans,fontWeight:900,margin:0,letterSpacing:"0.5px"}}>
                  {val}
                </p>
              </div>
            ))}
            {targetBriefing.suggestedTargetWeight && (
              <div style={{background:T.card,border:T.border,boxShadow:T.shadowXs,padding:"10px 12px",
                gridColumn:"1/-1",display:"flex",alignItems:"center",justifyContent:"space-between",borderRadius:T.radiusSm}}>
                <p style={{color:T.textDim,fontSize:9,fontFamily:T.fontSans,fontWeight:900,
                  letterSpacing:"1px",textTransform:"uppercase",margin:0}}>🎯 TARGET WEIGHT</p>
                <p style={{color:T.yellow,fontSize:20,fontFamily:T.fontSans,fontWeight:900,margin:0}}>
                  {targetBriefing.suggestedTargetWeight}
                  <span style={{fontSize:12,color:T.textSub,fontFamily:T.fontSans}}> kg</span>
                </p>
              </div>
            )}
            <div style={{background:T.ink,border:T.border,boxShadow:T.shadowXs,padding:"10px 12px",
              gridColumn:"1/-1",display:"flex",alignItems:"center",justifyContent:"space-between",borderRadius:T.radiusSm}}>
              <p style={{color:T.textDim,fontSize:9,fontFamily:T.fontSans,fontWeight:900,
                letterSpacing:"1px",textTransform:"uppercase",margin:0}}>ETA TO GOAL</p>
              <p style={{color:T.accent,fontSize:22,fontFamily:T.fontSans,fontWeight:900,margin:0}}>
                {targetBriefing.weeksToGoal}
                <span style={{fontSize:12,color:T.textSub,fontFamily:T.fontSans}}> weeks</span>
              </p>
            </div>
          </div>
          {/* Rationale */}
          <div style={{background:T.card,border:`2px solid ${T.secondary}`,
            boxShadow:T.shadowXs,padding:"11px 13px",marginBottom:14,borderRadius:T.radiusSm}}>
            <p style={{color:T.secondary,fontSize:8,fontFamily:T.fontSans,fontWeight:900,
              letterSpacing:"1.5px",textTransform:"uppercase",margin:"0 0 6px"}}>CLINICAL RATIONALE</p>
            <p style={{color:T.text,fontSize:11,fontFamily:T.fontSans,fontWeight:"bold",
              margin:0,lineHeight:1.75}}>{targetBriefing.rationale}</p>
          </div>
        </div>
        {/* Action buttons */}
        <div style={{padding:"0 18px 18px",display:"flex",gap:9}}>
          <button
            onClick={async()=>{
              const b = targetBriefing;
              setTargets(b.targets);
              await saveProfile({
                targets:b.targets,
                height:b._h, weight:b._w, age:b._a,
                gender, goal, persona, country, physiqueGoal,
              });
              setTargetBriefing(null);
              finishWizard();
            }}
            style={{
              flex:2,padding:"13px",background:T.accent,border:T.border,
              boxShadow:T.shadow,cursor:"pointer",
              color:T.ink,fontSize:12,fontFamily:T.fontSans,fontWeight:900,
              textTransform:"uppercase",letterSpacing:"1px",
            }}
          >
            <Check size={14} weight="bold" style={{marginRight:6,verticalAlign:"middle"}}/>
            Accept &amp; Execute
          </button>
          <button
            onClick={()=>setTargetBriefing(null)}
            style={{
              flex:1,padding:"13px",background:T.surface,border:T.border,
              boxShadow:T.shadowXs,cursor:"pointer",
              color:T.textSub,fontSize:12,fontFamily:T.fontSans,fontWeight:900,
              textTransform:"uppercase",letterSpacing:"1px",
            }}
          >
            Reject
          </button>
        </div>
      </div>
    </div>
  ) : null;

  // ==============================================================================
  // PAYWALL WAITLIST — Supabase table: waitlist
  // SQL (run once in Supabase SQL editor):
  //   create table if not exists waitlist (
  //     id         uuid primary key default gen_random_uuid(),
  //     email      text not null,
  //     created_at timestamptz not null default now()
  //   );
  //   alter table waitlist enable row level security;
  //   create policy "anon insert" on waitlist for insert to anon, authenticated with check (true);
  // ==============================================================================
  async function handleWaitlist() {
    if (!waitlistEmail.trim() || waitlistSubmitting || waitlistSubmitted) return;
    setWaitlistSubmitting(true);
    await supabase.from("waitlist").insert({ email: waitlistEmail.trim().toLowerCase() });
    setWaitlistSubmitting(false);
    setWaitlistSubmitted(true);
  }

  // ==============================================================================
  // V24 FIX 8d: PAYWALL MODAL — Lithe Premium upsell
  // Full-screen modal shown when a free user hits a premium gate.
  // Headline and sub-text vary by paywallReason. No price shown — "Coming Soon".
  // ==============================================================================
  const paywallModal = showPaywall ? (
    <div style={{
      position:"fixed",top:0,left:0,right:0,bottom:0,
      background:T.backdrop,zIndex:10000,
      display:"flex",alignItems:"center",justifyContent:"center",padding:"20px",
    }}>
      <div style={{
        background:T.surface,border:`4px solid ${T.accent}`,
        boxShadow:`8px 8px 0 ${T.ink}`,maxWidth:420,width:"100%",
        fontFamily:T.fontSans,borderRadius:T.radius,position:"relative",
      }}>
        {/* Close button */}
        <button onClick={()=>setShowPaywall(false)} style={{
          position:"absolute",top:12,right:14,background:"none",border:"none",
          color:T.textDim,fontSize:22,cursor:"pointer",fontWeight:900,lineHeight:1,
        }}>&times;</button>

        {/* Header */}
        <div style={{background:T.ink,padding:"20px 22px 16px",borderRadius:`${T.radius} ${T.radius} 0 0`}}>
          <p style={{color:T.accent,fontSize:9,fontFamily:T.fontSans,fontWeight:900,
            letterSpacing:"2px",textTransform:"uppercase",margin:"0 0 6px"}}>⚡ PREMIUM</p>
          <h2 style={{color:T.accent,fontSize:22,fontWeight:900,fontFamily:T.fontSans,
            margin:"0 0 8px",letterSpacing:"1px"}}>Unlock Lithe Premium</h2>
          <p style={{color:T.textSub,fontSize:11,fontFamily:T.fontSans,fontWeight:"bold",
            margin:0,lineHeight:1.6}}>
            {paywallReason === "daily_limit"
              ? "You've used your 3 free audits for today. Premium gives you unlimited daily audits."
              : paywallReason === "persona"
              ? "Motivational and Critical coaching styles are Premium features."
              : "This feature is part of Lithe Premium."}
          </p>
        </div>

        {/* Feature checklist */}
        <div style={{padding:"18px 22px"}}>
          {[
            "Unlimited daily AI audits",
            "Weekly AI briefing",
            "AI meal suggestions",
            "AI supplement planner",
            "Adaptive calorie targets",
            "All coaching personas",
          ].map(f => (
            <div key={f} style={{display:"flex",alignItems:"center",gap:10,marginBottom:10}}>
              <span style={{color:T.accent,fontSize:14,flexShrink:0}}>✓</span>
              <span style={{color:T.text,fontSize:12,fontFamily:T.fontSans,fontWeight:"bold"}}>{f}</span>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div style={{padding:"0 22px 22px"}}>
          <button disabled style={{
            width:"100%",padding:"15px",background:T.surface,border:T.border,
            color:T.textDim,fontSize:13,fontFamily:T.fontSans,fontWeight:900,
            textTransform:"uppercase",letterSpacing:"1px",cursor:"not-allowed",
            opacity:0.6,borderRadius:T.radiusSm,
          }}>
            Premium — Coming Soon
          </button>

          {/* Waitlist email capture */}
          <div style={{marginTop:14}}>
            {waitlistSubmitted ? (
              <p style={{color:T.accent,fontSize:12,fontFamily:T.fontSans,fontWeight:900,
                textAlign:"center",margin:0}}>
                You're on the list. ✓
              </p>
            ) : (
              <>
                <div style={{display:"flex",gap:6}}>
                  <input
                    type="email"
                    placeholder="your@email.com"
                    value={waitlistEmail}
                    onChange={e=>setWaitlistEmail(e.target.value)}
                    onKeyDown={e=>e.key==="Enter"&&handleWaitlist()}
                    style={{
                      flex:1,padding:"9px 12px",
                      background:T.inputBg||T.surface,border:T.border,
                      color:T.text,fontSize:12,fontFamily:T.fontSans,
                      borderRadius:T.radiusSm,outline:"none",
                    }}
                  />
                  <button
                    onClick={handleWaitlist}
                    disabled={!waitlistEmail.trim()||waitlistSubmitting}
                    style={{
                      padding:"9px 14px",
                      background:waitlistEmail.trim()&&!waitlistSubmitting?T.accent:T.surface,
                      border:T.border,color:waitlistEmail.trim()&&!waitlistSubmitting?T.ink:T.textDim,
                      fontSize:11,fontFamily:T.fontSans,fontWeight:900,
                      cursor:waitlistEmail.trim()&&!waitlistSubmitting?"pointer":"not-allowed",
                      borderRadius:T.radiusSm,whiteSpace:"nowrap",
                    }}
                  >
                    {waitlistSubmitting?"…":"Notify me"}
                  </button>
                </div>
                <p style={{color:T.textDim,fontSize:9,fontFamily:T.fontSans,fontWeight:"bold",
                  textAlign:"center",margin:"8px 0 0",lineHeight:1.5}}>
                  We'll notify you when subscriptions are available.
                </p>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  ) : null;

  // V25 FIX 6: logout queue confirmation modal
  const logoutConfirmModal = logoutConfirm ? (
    <div style={{
      position:"fixed",top:0,left:0,right:0,bottom:0,
      background:T.backdrop,zIndex:10001,
      display:"flex",alignItems:"center",justifyContent:"center",padding:"20px",
    }}>
      <div style={{
        background:T.card,border:T.border,boxShadow:T.shadow,
        maxWidth:360,width:"100%",padding:"22px",fontFamily:T.fontSans,borderRadius:T.radius,
      }}>
        <p style={{color:T.text,fontSize:13,fontWeight:900,margin:"0 0 8px",textTransform:"uppercase",letterSpacing:"0.5px"}}>
          Unsaved Changes
        </p>
        <p style={{color:T.textSub,fontSize:11,fontWeight:"bold",margin:"0 0 18px",lineHeight:1.5}}>
          You have {getQueueLength()} pending change{getQueueLength()!==1?"s":""} that haven't synced yet. Signing out will discard them.
        </p>
        <div style={{display:"flex",gap:8}}>
          <button onClick={()=>setLogoutConfirm(false)} style={{
            flex:1,padding:"10px",background:T.surface,border:T.border,
            color:T.text,fontSize:11,fontWeight:900,fontFamily:T.fontSans,
            cursor:"pointer",textTransform:"uppercase",letterSpacing:"0.5px",borderRadius:T.radiusSm,
          }}>Cancel</button>
          <button onClick={()=>handleLogout()} style={{
            flex:1,padding:"10px",background:T.red,border:T.border,
            color:"#fff",fontSize:11,fontWeight:900,fontFamily:T.fontSans,
            cursor:"pointer",textTransform:"uppercase",letterSpacing:"0.5px",borderRadius:T.radiusSm,
          }}>Sign Out Anyway</button>
        </div>
      </div>
    </div>
  ) : null;

  // ==============================================================================
  // SCREEN: ONBOARDING WIZARD — V94 / V103
  // Full-screen multi-step wizard for new users (no targets yet).
  // profileLoaded guard ensures we never show onboarding before the profile
  // fetch completes — eliminates false positives from intermediate React state.
  // ==============================================================================
  if (process.env.NODE_ENV !== "production") {
    console.log("[routing]",
      "hasTargets:", hasTargets,
      "targets.calories:", targets?.calories,
      "screen:", screen,
      "profileLoading:", profileLoading,
      "profileLoaded:", profileLoaded,
      "session:", !!session);
  }
  // V190: Post-wizard delight screen — shown once after first onboarding completion
  if (showWizardDone) {
    return (
      <div style={{background:T.bg,minHeight:"100dvh",display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",padding:"0 32px",boxSizing:"border-box"}}>
        <CheckCircle size={48} color={T.accent} weight="fill" style={{marginBottom:20,flexShrink:0}}/>
        <h1 style={{color:T.inkDark,fontSize:28,fontWeight:800,fontFamily:T.fontDisplay,margin:"0 0 8px",textAlign:"center"}}>You're all set!</h1>
        <p style={{color:T.textSub,fontSize:14,fontFamily:T.fontSans,fontWeight:500,margin:"0 0 16px",textAlign:"center"}}>Your daily targets:</p>
        <div style={{background:T.card,border:`1px solid ${T.cardBorder}`,borderRadius:T.radius,padding:"14px 20px",width:"100%",maxWidth:320,marginBottom:16}}>
          <p style={{margin:0,fontSize:13,fontFamily:T.fontSans,fontWeight:600,color:T.inkDark,textAlign:"center",lineHeight:1.8}}>
            {targets.calories} kcal · {targets.protein}g protein · {targets.carbs}g carbs · {targets.fat}g fat
          </p>
        </div>
        <p style={{color:T.textSub,fontSize:13,fontFamily:T.fontSans,fontWeight:500,margin:"0 0 32px",textAlign:"center"}}>Log your first meal to see how you're tracking.</p>
        <Btn onClick={()=>{setShowWizardDone(false);setScreen("dashboard");}} color={T.accent} style={{width:"100%",maxWidth:320}}>
          Let's go →
        </Btn>
      </div>
    );
  }

  if (!hasTargets && profileLoaded && session && screen==="settings") {
    const wStep = wizardStep || 1;
    const dots = [1,2,3,4,5];
    const wizardBack = () => setWizardStep(Math.max(1, wStep - 1));
    const ACTIVITY_MULTS = {sedentary:1.2, light:1.375, moderate:1.55, active:1.725};
    const wizardNext = () => setWizardStep(wStep + 1);

    return (
      <div style={{...shell,alignItems:"center",justifyContent:"center"}}>
        <div style={{width:"100%",maxWidth:420,padding:"32px 22px",boxSizing:"border-box",
          display:"flex",flexDirection:"column",alignItems:"center",minHeight:"100dvh",justifyContent:"center"}}>

          {/* Step 1: Welcome */}
          {wStep === 1 && (
            <div style={{textAlign:"center",width:"100%"}}>
              <div style={{display:"inline-flex",alignItems:"center",gap:10,marginBottom:16}}>
                <div style={{background:T.accent,padding:"10px 12px",border:T.border,boxShadow:T.shadow,borderRadius:T.radiusSm}}>
                  <Lightning size={28} color={T.ink} weight="bold"/>
                </div>
              </div>
              <h1 style={{color:T.ink,fontSize:28,fontWeight:900,fontFamily:T.fontSans,
                letterSpacing:"3px",textTransform:"uppercase",margin:"0 0 8px"}}>NUTRILITHE</h1>
              <p style={{color:T.textSub,fontSize:13,fontFamily:T.fontSans,fontWeight:"bold",
                margin:"0 0 20px"}}>Your AI nutrition co-pilot</p>
              <div style={{textAlign:"left",margin:"0 0 32px",display:"flex",flexDirection:"column",gap:0}}>
                <p style={{color:T.textSub,fontSize:13,fontWeight:500,fontFamily:T.fontSans,lineHeight:1.8,margin:0}}>🎯 AI-calculated macro targets, personalised to your goal</p>
                <p style={{color:T.textSub,fontSize:13,fontWeight:500,fontFamily:T.fontSans,lineHeight:1.8,margin:0}}>📊 Daily coaching audit that improves as you log</p>
                <p style={{color:T.textSub,fontSize:13,fontWeight:500,fontFamily:T.fontSans,lineHeight:1.8,margin:0}}>💬 Ask your AI coach anything, anytime</p>
              </div>
              <Btn onClick={()=>setWizardStep(2)} color={T.accent}>Start</Btn>
            </div>
          )}

          {/* Step 2: About You — V25 FIX 1: biometric validation */}
          {wStep === 2 && (()=>{
            const h = parseFloat(height), w = parseFloat(weight), a = parseFloat(age);
            const hOk = !height || (h >= 100 && h <= 250);
            const wOk = !weight || (w >= 30  && w <= 300);
            const aOk = !age    || (a >= 16  && a <= 120);
            const allValid = height && weight && age && hOk && wOk && aOk;
            const errStyle = {color:T.red,fontSize:9,fontFamily:T.fontSans,fontWeight:"bold",marginTop:2};
            return (
            <div style={{width:"100%"}}>
              <h2 style={{color:T.ink,fontSize:20,fontWeight:900,fontFamily:T.fontSans,
                textTransform:"uppercase",letterSpacing:"1px",margin:"0 0 6px"}}>About You</h2>
              <p style={{color:T.textSub,fontSize:11,fontFamily:T.fontSans,fontWeight:"bold",
                margin:"0 0 20px"}}>Tell us your basics so we can calculate your targets.</p>
              <div style={{display:"flex",gap:9,marginBottom:9}}>
                <div style={{flex:1}}>
                  <Field label="Height (cm)" type="number" value={height} onChange={e=>setHeight(e.target.value)} placeholder="175"/>
                  {!hOk && <p style={errStyle}>Must be 100–250 cm</p>}
                </div>
                <div style={{flex:1}}>
                  <Field label="Weight (kg)" type="number" value={weight} onChange={e=>setWeight(e.target.value)} placeholder="75"/>
                  {!wOk && <p style={errStyle}>Must be 30–300 kg</p>}
                </div>
              </div>
              <div style={{display:"flex",gap:9,marginBottom:16}}>
                <div style={{flex:1}}>
                  <Field label="Age" type="number" value={age} onChange={e=>setAge(e.target.value)} placeholder="28"/>
                  {!aOk && <p style={errStyle}>Must be 16–120</p>}
                </div>
                <div style={{flex:1}}><GenderToggle value={gender} onChange={setGender}/></div>
              </div>
              <div style={{display:"flex",gap:9}}>
                <Btn onClick={wizardBack} outline color={T.textDim} style={{flex:1}}><ArrowLeft size={14} weight="bold"/> Back</Btn>
                <Btn onClick={wizardNext} color={T.accent} style={{flex:2,opacity:allValid?1:0.4,pointerEvents:allValid?"auto":"none"}}>Next</Btn>
              </div>
            </div>
            );
          })()}

          {/* Step 3: Your Lifestyle */}
          {wStep === 3 && (
            <div style={{width:"100%"}}>
              <h2 style={{color:T.ink,fontSize:20,fontWeight:900,fontFamily:T.fontSans,
                textTransform:"uppercase",letterSpacing:"1px",margin:"0 0 6px"}}>Your Lifestyle</h2>
              <p style={{color:T.textSub,fontSize:11,fontFamily:T.fontSans,fontWeight:"bold",
                margin:"0 0 16px"}}>How active are you outside the gym?</p>
              {[
                {id:"sedentary", label:"Mostly seated",   sub:"Desk job, little or no exercise"},
                {id:"light",     label:"Lightly active",  sub:"Light exercise 1–3 days/week"},
                {id:"moderate",  label:"Moderately active",sub:"Moderate exercise 3–5 days/week"},
                {id:"active",    label:"Very active",     sub:"Hard training 6–7 days/week"},
              ].map(opt=>(
                <div key={opt.id} onClick={()=>setWizardActivity(opt.id)}
                  style={{
                    padding:"12px 16px",marginBottom:8,borderRadius:T.radiusSm,cursor:"pointer",
                    border:wizardActivity===opt.id?`2px solid ${T.accent}`:T.border,
                    background:wizardActivity===opt.id?T.accent+"18":T.surface,
                    transition:"all 0.15s",
                  }}>
                  <div style={{fontWeight:800,fontSize:14,fontFamily:T.fontSans,color:T.ink}}>{opt.label}</div>
                  <div style={{fontSize:11,fontFamily:T.fontSans,color:T.textSub,marginTop:2}}>{opt.sub}</div>
                </div>
              ))}
              <p style={{color:T.textSub,fontSize:11,fontFamily:T.fontSans,fontWeight:"bold",
                margin:"16px 0 8px"}}>Choose your coaching style</p>
              {[
                {id:"Balanced",     label:"Balanced",     sub:"Evidence-based, supportive tone"},
                {id:"Motivational", label:"Motivational", sub:"Energetic, goal-focused push"},
                {id:"Critical",     label:"Critical",     sub:"Direct, unfiltered feedback"},
              ].map(opt=>(
                <div key={opt.id} onClick={()=>setPersona(opt.id)}
                  style={{
                    padding:"12px 16px",marginBottom:8,borderRadius:T.radiusSm,cursor:"pointer",
                    border:persona===opt.id?`2px solid ${T.accent}`:T.border,
                    background:persona===opt.id?T.accent+"18":T.surface,
                    transition:"all 0.15s",
                  }}>
                  <div style={{fontWeight:800,fontSize:14,fontFamily:T.fontSans,color:T.ink}}>{opt.label}</div>
                  <div style={{fontSize:11,fontFamily:T.fontSans,color:T.textSub,marginTop:2}}>{opt.sub}</div>
                </div>
              ))}
              <div style={{display:"flex",gap:9,marginTop:16}}>
                <Btn onClick={wizardBack} outline color={T.textDim} style={{flex:1}}><ArrowLeft size={14} weight="bold"/> Back</Btn>
                <Btn onClick={wizardNext} color={T.accent} style={{flex:2}}>Next</Btn>
              </div>
            </div>
          )}

          {/* Step 4: Your Goal */}
          {wStep === 4 && (
            <div style={{width:"100%"}}>
              <h2 style={{color:T.ink,fontSize:20,fontWeight:900,fontFamily:T.fontSans,
                textTransform:"uppercase",letterSpacing:"1px",margin:"0 0 6px"}}>Your Goal</h2>
              <p style={{color:T.textSub,fontSize:11,fontFamily:T.fontSans,fontWeight:"bold",
                margin:"0 0 20px"}}>What are you working towards?</p>

              {goalMode !== "ai" ? (
                <>
                  {/* Simple mode: 3 goal cards */}
                  {[
                    {id:"lose",    emoji:"\uD83D\uDD25", label:"Lose Weight",    sub:"Reduce body fat through a calorie deficit"},
                    {id:"maintain",emoji:"\u2696\uFE0F",  label:"Maintain Weight", sub:"Stay at your current weight and improve body composition"},
                    {id:"bulk",    emoji:"\uD83D\uDCAA",  label:"Build Muscle",   sub:"Gain strength and size through a calorie surplus"},
                  ].map(opt=>(
                    <div key={opt.id} onClick={()=>{setSimpleGoal(opt.id);setGoalMode("simple");setGoal(SIMPLE_GOAL_PRESETS[opt.id]);}}
                      style={{
                        padding:"14px 16px",marginBottom:9,borderRadius:T.radiusSm,cursor:"pointer",
                        border:simpleGoal===opt.id&&goalMode==="simple"?`2px solid ${T.accent}`:T.border,
                        background:simpleGoal===opt.id&&goalMode==="simple"?T.accent+"18":T.surface,
                        transition:"all 0.15s",
                      }}>
                      <div style={{fontWeight:800,fontSize:14,fontFamily:T.fontSans,color:T.ink}}>
                        {opt.emoji} {opt.label}
                      </div>
                      <div style={{fontSize:11,fontFamily:T.fontSans,color:T.textSub,marginTop:2}}>{opt.sub}</div>
                    </div>
                  ))}
                  <div style={{textAlign:"center",marginBottom:16}}>
                    <span onClick={()=>setGoalMode("ai")}
                      style={{fontSize:11,fontFamily:T.fontSans,fontWeight:"bold",color:T.textDim,cursor:"pointer",textDecoration:"underline"}}>
                      Advanced
                    </span>
                  </div>
                  <div style={{display:"flex",gap:9}}>
                    <Btn onClick={wizardBack} outline color={T.textDim} style={{flex:1}}><ArrowLeft size={14} weight="bold"/> Back</Btn>
                    <Btn onClick={()=>{setWizardStep(5);generateTargets(true,ACTIVITY_MULTS[wizardActivity]);}} color={T.accent}
                      style={{flex:2,opacity:goalMode==="simple"?1:0.4,pointerEvents:goalMode==="simple"?"auto":"none"}}>Generate Targets</Btn>
                  </div>
                </>
              ) : (
                <>
                  {/* Advanced / AI mode: two textareas */}
                  <div style={{textAlign:"center",marginBottom:12}}>
                    <span onClick={()=>setGoalMode("simple")}
                      style={{fontSize:11,fontFamily:T.fontSans,fontWeight:"bold",color:T.textDim,cursor:"pointer",textDecoration:"underline"}}>
                      Simple
                    </span>
                  </div>
                  <Field textarea label="Current Lifestyle" value={goal} onChange={e=>setGoal(e.target.value)}
                    placeholder="e.g. Office job, sedentary during the week. Train 3-4 times a week, mostly weights. Sleep around 7 hours."/>
                  <p style={{color:T.textSub,fontSize:10,fontFamily:T.fontSans,fontWeight:"bold",margin:"-6px 0 14px 2px"}}>
                    The more detail you give, the more accurate your targets will be.
                  </p>
                  <Field textarea label="Your Goal" value={physiqueGoal} onChange={e=>setPhysiqueGoal(e.target.value)}
                    placeholder="e.g. Lose body fat while maintaining muscle. Target weight 80kg. Looking to get leaner for summer."/>
                  <p style={{color:T.textSub,fontSize:10,fontFamily:T.fontSans,fontWeight:"bold",margin:"-6px 0 14px 2px"}}>
                    Include a target weight or physique description if you have one.
                  </p>
                  <div style={{display:"flex",gap:9}}>
                    <Btn onClick={wizardBack} outline color={T.textDim} style={{flex:1}}><ArrowLeft size={14} weight="bold"/> Back</Btn>
                    <Btn onClick={()=>{setWizardStep(5);generateTargets(true,ACTIVITY_MULTS[wizardActivity]);}} color={T.accent} style={{flex:2}}>Generate Targets</Btn>
                  </div>
                </>
              )}
              <Btn onClick={handleSkipTargets} outline color={T.textDim} style={{width:"100%",marginTop:8}}>Use default targets (edit in Settings later)</Btn>
            </div>
          )}

          {/* Step 5: Generating */}
          {wStep === 5 && (
            <div style={{textAlign:"center",width:"100%"}}>
              <h2 style={{color:T.ink,fontSize:20,fontWeight:900,fontFamily:T.fontSans,
                textTransform:"uppercase",letterSpacing:"1px",margin:"0 0 12px"}}>Generating Targets</h2>
              {isGenerating ? (
                <div style={{display:"flex",flexDirection:"column",alignItems:"center",gap:14}}>
                  <Spinner size={32}/>
                  <p style={{color:T.textSub,fontSize:12,fontFamily:T.fontSans,fontWeight:"bold"}}>
                    AI Sports Nutritionist calculating your protocol...
                  </p>
                </div>
              ) : onboardErr ? (
                <div>
                  <p style={{color:T.red,fontSize:12,fontFamily:T.fontSans,fontWeight:"bold",marginBottom:14}}>{onboardErr}</p>
                  <Btn onClick={()=>setWizardStep(4)} outline color={T.textDim}><ArrowLeft size={14} weight="bold"/> Go Back</Btn>
                </div>
              ) : (
                <p style={{color:T.textSub,fontSize:12,fontFamily:T.fontSans,fontWeight:"bold"}}>
                  Review your targets in the protocol modal above.
                </p>
              )}
            </div>
          )}

          {/* Progress dots */}
          <div style={{display:"flex",gap:8,marginTop:32}}>
            {dots.map(d=>(
              <div key={d} style={{
                width:8,height:8,borderRadius:"50%",
                background:d===wStep?T.accent:T.surface,
                border:T.border,transition:"background 0.2s",
              }}/>
            ))}
          </div>
        </div>
        {protocolModal}
      </div>
    );
  }


  // ==============================================================================
  // SCREEN ROUTING — screens extracted to src/screens/
  // ==============================================================================
  if (screen==="settings") return (
    <ErrorBoundary screenName="Settings">
      {paywallModal}
      {logoutConfirmModal}
      <SettingsScreen {...{
        shell, phone, OfflineBanner, hasTargets, session, targets, setTargets,
        persona, setPersona, headerBg, height, setHeight, weight, setWeight,
        age, setAge, gender, setGender, goal, setGoal, country, setCountry,
        physiqueGoal, setPhysiqueGoal,
        goalMode, setGoalMode, simpleGoal, setSimpleGoal,
        wakeTime, setWakeTime, bedTime, setBedTime,
        autoAuditTime, setAutoAuditTime, darkMode, setDarkMode,
        bmrPreview, isGenerating, onboardErr, setOnboardErr,
        targetBriefing, setTargetBriefing, wizardStep, setWizardStep,
        saveProfile, setScreen, screen, syncing, syncErr,
        showDeleteModal, setShowDeleteModal,
        deleteConfirmText, setDeleteConfirmText, deleteErr, setDeleteErr,
        deleteLoading, setDeleteLoading, exportLoading, setExportLoading,
        exportErr, setExportErr, protocolModal, generateTargets,
        handleLogout, handleExportData, handleDeleteAccount,
        targetWeight, setTargetWeight,
        isPremium: effectiveIsPremium, setShowPaywall, setPaywallReason,
        healthConnectAvailable: hc.isAvailable,
        healthConnectGranted: hc.permGranted,
        onConnectHealthConnect: hc.requestPermissions,
      }}/>
    </ErrorBoundary>
  );

  // ── Chat context builders (used by IntelligenceScreen chat panels) ──────────
  function buildDailyAuditChatContext() {
    const currentHour = new Date().getHours();
    const timeLabel = currentHour < 12 ? "morning" : currentHour < 17 ? "afternoon" : "evening";
    const calLeft = Math.round(targets.calories - totals.calories);
    const proLeft = Math.round(targets.protein - totals.protein);
    const workoutLine = todayWorkouts.length > 0
      ? todayWorkouts.map(w => `${w.name||"Workout"} — ${w.duration||0} mins, ${w.calories_burned||0} kcal burned`).join("; ")
      : "No workout logged today";
    return `You are a nutrition assistant for the Lithe.Fit app.
Only answer questions about today's food, nutrition, hydration, and workout recovery. Decline anything else politely.

USER CONTEXT:
Time: ${timeLabel} (${String(currentHour).padStart(2,"0")}:00)
Today's intake: ${Math.round(totals.calories)} kcal / ${targets.calories} target (${calLeft} kcal remaining)
Protein: ${Math.round(totals.protein)}g / ${targets.protein}g target (${proLeft}g remaining)
Carbs: ${Math.round(totals.carbs)}g / ${targets.carbs}g target
Fat: ${Math.round(totals.fat)}g / ${targets.fat}g target
Water: ${waterMl}ml / ${hydrationTarget}ml target
Today's workout: ${workoutLine}
${cpHeadline ? `Daily audit headline: ${cpHeadline}` : ""}
${cpMetabolic ? `Right now: ${cpMetabolic}` : ""}

${AI_SAFETY_LAW}
PLAIN_ENGLISH_LAW: Plain English only. No science jargon.
UK_LAW: UK English throughout.
SCOPE_LAW: Only answer questions about today's nutrition and recovery. If asked anything outside this scope say: "I can only help with today's nutrition — try asking me about that instead."
UNDER_TARGET_LAW: If the user is under their calorie target, frame this positively — they are ahead of schedule. Never frame remaining calories as a deficit or failure.
BANNED TERMS: leucine, MPS, glycogen, substrate, anabolic, catabolic, thermogenesis, catabolism, ketogenic state, metabolic efficiency, satiety signals, lean mass preservation, metabolic rate, normal metabolic state, muscle protein synthesis, glycogen resynthesis, leucine threshold, substrate utilisation, basal metabolic rate, kickstart your metabolism.
CATABOLISM SYNONYM BAN: Never say "burned muscle for energy", "breaking down muscle tissue", "body is eating muscle", "muscle wasting".`;
  }

  function buildWeeklyChatContext() {
    const todayISO = new Date().toISOString().slice(0, 10);
    const sevenAgo = new Date(); sevenAgo.setDate(sevenAgo.getDate() - 7);
    const sevenAgoISO = sevenAgo.toISOString().slice(0, 10);
    const nutDays = (logHistory || []).filter(d => d.logged && d.date >= sevenAgoISO && d.date !== todayISO);
    const n = nutDays.length || 1;
    const avg7Cal = Math.round(nutDays.reduce((s, d) => s + (d.calories || 0), 0) / n);
    const avg7Pro = Math.round(nutDays.reduce((s, d) => s + (d.protein || 0), 0) / n);
    const avg7Carbs = Math.round(nutDays.reduce((s, d) => s + (d.carbs || 0), 0) / n);
    const avg7Fat = Math.round(nutDays.reduce((s, d) => s + (d.fat || 0), 0) / n);
    const calVerdict = avg7Cal <= targets.calories ? "on track (at or under target)" : `${avg7Cal - targets.calories} kcal/day over target`;
    const wkCount = todayWorkouts.length; // simplified — weekly count from crossAppData if available
    return `You are a nutrition assistant for the Lithe.Fit app.
Only answer questions about weekly nutrition patterns, planning, and recovery. Decline anything else politely.

USER CONTEXT:
7-day calorie average: ${avg7Cal} kcal/day vs ${targets.calories} target — ${calVerdict}
7-day protein average: ${avg7Pro}g/day vs ${targets.protein}g target
7-day carbs average: ${avg7Carbs}g/day vs ${targets.carbs}g target
7-day fat average: ${avg7Fat}g/day vs ${targets.fat}g target
Days logged: ${nutDays.length} of 7
${crossAppData?.nutrition_verdict ? `Weekly nutrition verdict: ${crossAppData.nutrition_verdict}` : ""}
${crossAppData?.combined_insight ? `Combined insight: ${crossAppData.combined_insight}` : ""}

${AI_SAFETY_LAW}
PLAIN_ENGLISH_LAW: Plain English only. No science jargon.
UK_LAW: UK English throughout.
SCOPE_LAW: Only answer questions about weekly nutrition planning. If asked anything outside this scope say: "I can only help with weekly nutrition planning — try asking me about that instead."
UNDER_TARGET_LAW: If the user is under their calorie target, frame this positively — they are ahead of schedule. Never frame remaining calories as a deficit or failure.
BANNED TERMS: leucine, MPS, glycogen, substrate, anabolic, catabolic, thermogenesis, catabolism, ketogenic state, metabolic efficiency, satiety signals, lean mass preservation, metabolic rate, normal metabolic state, muscle protein synthesis, glycogen resynthesis, leucine threshold, substrate utilisation, basal metabolic rate, kickstart your metabolism.
CATABOLISM SYNONYM BAN: Never say "burned muscle for energy", "breaking down muscle tissue", "body is eating muscle", "muscle wasting".`;
  }

  if (screen==="intelligence") return (
    <ErrorBoundary screenName="Intelligence">
      {paywallModal}
      <IntelligenceScreen {...{
        shell, phone, OfflineBanner, hasTargets, session, targets, persona,
        personaData, darkMode, setDarkMode,
        screen, setScreen,
        totals, logHistory, waterMl, hydrationTarget,
        cpLoading, setCpLoading, cpHeadline, cpMetabolic, setCpMetabolic,
        cpTactical, setCpTactical, cpOutlook, setCpOutlook, cpAction,
        weeklyLoading, setWeeklyLoading, wbSummary, setWbSummary,
        wbPros, setWbPros, wbNegatives, setWbNegatives,
        wbPriorities, setWbPriorities, weeklyTs, setWeeklyTs,
        intelView, setIntelView, intelByDay, setIntelByDay,
        habitMetrics, setHabitMetrics, intelLoading, setIntelLoading,
        height, weight, weightLogs, todayWorkouts,
        autoAuditTime,
        onRunCopilot: runCopilot, onRunWeeklyBriefing: runWeeklyBriefing,
        crossAppData, crossAppLoading, onRunCrossApp: runCrossAppWeeklySummary,
        loadIntelMeta, logs, hc, hints,
        progressMacros, setShowProgressFilter,
        buildDailyAuditChatContext, buildWeeklyChatContext,
        sendChatMessage, getLLMUrl,
        userId: session?.user?.id,
        effectiveIsPremium,
      }}/>
    </ErrorBoundary>
  );

  if (screen==="my-meals") return (
    <ErrorBoundary screenName="My Meals">
      <MyMealsScreen {...{
        shell, phone, OfflineBanner, hasTargets, session, targets, totals, persona,
        darkMode, setDarkMode, mealType, savedMeals, recipeIds, recipeIngredients, setRecipeIngredients,
        recipeSearch, setRecipeSearch, recipeResults, setRecipeResults,
        recipeSearching, recipeName, setRecipeName, recipeSaving,
        recipeLogModal, setRecipeLogModal, recipeLogType, setRecipeLogType,
        showRecipeBuilder, setShowRecipeBuilder, MEAL_COLOR, recipeTotals,
        recipeSearchFoods, recipeAddIngredient, recipeUpdateGrams,
        saveRecipe, deleteSavedMeal, logSavedMeal,
        mealSuggestions, mealSugLoading, mealSugErr, getMealSuggestions,
        setScreen,
        mealPrepData, mealPrepLoading, mealPrepError, setMealPrepData, onRunMealPrep: runMealPrepPlanner,
      }}/>
    </ErrorBoundary>
  );

  if (screen==="supplements") return (
    <ErrorBoundary screenName="Supplements">
      <SupplementsScreen {...{
        shell, phone, OfflineBanner, hasTargets, session, persona,
        darkMode, setDarkMode, suppStack, suppTakenToday, showSuppAdd, setShowSuppAdd,
        suppAddStep, setSuppAddStep, suppForm, setSuppForm,
        suppSearch, setSuppSearch, suppSearchRes, setSuppSearchRes,
        suppSearching, suppLoading, setSuppLoading,
        suppScheduleLoad, suppScheduleMsg, suppDbDebounceRef, SUPP_TIMINGS,
        addSupplement, toggleSuppTaken, deleteSupplement,
        searchSuppDB, runSuppSchedulePlanner, weight, setScreen,
      }}/>
    </ErrorBoundary>
  );

  if (screen==="progress") {
    const streakData = progressStreakData;

    return (
      <ErrorBoundary screenName="Progress">
        <ProgressScreen {...{
          shell, phone, OfflineBanner, hasTargets, session, targets, totals, persona,
          darkMode, setDarkMode, screen, setScreen, syncing, syncErr,
          logHistory, weightLogs,
          weightInput, setWeightInput, weightLogLoading, logWeight,
          bodyMeasurements, showBodyMeas, setShowBodyMeas,
          bodyMeasForm, setBodyMeasForm, bodyMeasLoading, saveBodyMeasurement,
          setShowProgressFilter,
          streakData, hc,
          ACHIEVEMENTS, unlockedAchievements, achievementToast,
          bodyProjData, bodyProjLoading, onRunBodyProj: runBodyCompositionProjector,
          hints,
        }}/>
      </ErrorBoundary>
    );
  }

  // Dashboard/Today screen (default)
  return (
    <ErrorBoundary screenName="Today">
      {toast && (
        <div style={{
          position:"fixed", top:16, left:"50%",
          transform:"translateX(-50%)",
          zIndex:9999, maxWidth:340, width:"90%",
          background: toast.type==="error" ? T.red : toast.type==="success" ? T.secondary : T.accent,
          color: T.bg,
          padding:"12px 18px",
          borderRadius:T.radiusSm,
          boxShadow:T.shadow,
          fontSize:13, fontFamily:T.fontSans,
          fontWeight:600, textAlign:"center",
        }}>
          {toast.message}
        </div>
      )}
      {activeNudge && (
        <NudgeModal nudge={activeNudge} setActiveNudge={setActiveNudge} T={T}/>
      )}
      {paywallModal}
      <NutriDashboardScreen {...{
        shell, phone, OfflineBanner, adjustToast, targets, totals, logs,
        groupedLogs, hasTargets, session, persona, headerBg, darkMode, setDarkMode,
        syncing, syncErr, proteinGapAlert, lastProteinLog, hydrationTarget,
        MEAL_COLOR, mealType, setMealType, logMode, setLogMode,
        nlpFood, setNlpFood, nlpCandidates, setNlpCandidates,
        nlpModal, setNlpModal, nlpModalQty, setNlpModalQty, nlpModalError, setNlpModalError,
        nlpHistory, servingPreset, setServingPreset,
        dbSuggestions, setDbSuggestions, dbSearching, dbDebounceRef,
        logLoading, logErr, setLogErr, logOk, setLogOk,
        barcode, setBarcode, barcodeQty, setBarcodeQty,
        barcodeUnit, setBarcodeUnit, barcodeStep, setBarcodeStep,
        scannedProduct, setScannedProduct, manual, setManual,
        manualUnit, setManualUnit, cameraActive, cameraErr,
        cameraSecureErr, cameraToast, cameraRationaleShown, setCameraRationaleShown,
        showCameraRationale, setShowCameraRationale,
        videoReady, videoRef, openSlots, setOpenSlots,
        waterMl, syncWater, showCustomWater, setShowCustomWater,
        customWaterVal, setCustomWaterVal, todayWorkouts, hc, postWorkoutNudge, setPostWorkoutNudge,
        showFavs, setShowFavs, savedMeals, savingMeal,
        saveMeal, deleteSavedMeal,
        showSuggestForm, setShowSuggestForm, suggestForm, setSuggestForm,
        suggestOk, setSuggestOk, suggestErr, setSuggestErr, submitFoodSuggestion,
        showMacroFilter, setShowMacroFilter, visibleMacros, setVisibleMacros,
        copyLoading, copyOk, copyModal, setCopyModal,
        copyYestLogs, copySelSlot, copySelItems, setCopySelItems,
        editItem, setEditItem, editForm, setEditForm, editSourceFood, setEditSourceFood, fetchEditSource, swipeRef,
        fetchNLP, confirmNlpCandidate, confirmModalLog, insertLog, deleteLog,
        searchFoodsDB, lookupProduct, confirmLog,
        fetchYesterdayLogs, copyFromYesterday,
        startCameraScanner, stopCamera, handleScan: startCameraScanner,
        updateMealType, updateLog, saveManual,
        openCopyModal, selectCopySlot, confirmCopyItems, copyAllFromYesterday,
        mealSuggestions, mealSugLoading, mealSugErr, getMealSuggestions,
        dayHistory, logHistory, screen, setScreen,
        searchHistory, showSearchHistory, setShowSearchHistory, fetchSearchHistory, saveSearchQuery,
        barcodeHistory, fetchBarcodeHistory,
        viewingDate, isViewingToday, navigateDate, returnToToday,
        hints,
        bodyProjData, bodyProjLoading, onRunBodyProj: runBodyCompositionProjector,
        heroSummary, heroSummaryLoading,
      }}/>
      <BottomNav screen={screen} setScreen={setScreen} hasTargets={hasTargets}/>
      <Analytics />
      {/* V190: Global achievement toast — fixed above bottom nav, visible on any screen */}
      {achievementToast && (
        <div onClick={() => setAchievementToast(null)} style={{
          position:"fixed",bottom:80,left:16,right:16,zIndex:9999,
          background:T.card,border:`1px solid ${T.cardBorder}`,
          borderRadius:T.radius,boxShadow:T.shadow,
          padding:"12px 16px",display:"flex",alignItems:"center",gap:10,
          cursor:"pointer",
        }}>
          <Trophy size={20} color={T.yellow} weight="fill" style={{flexShrink:0}}/>
          <div style={{flex:1}}>
            <p style={{margin:0,fontSize:13,fontWeight:700,fontFamily:T.fontDisplay,color:T.inkDark}}>{achievementToast.name}</p>
            <p style={{margin:0,fontSize:12,fontFamily:T.fontSans,color:T.textSub}}>{achievementToast.desc}</p>
          </div>
        </div>
      )}
    </ErrorBoundary>
  );

}
